export const gjData = {
  locale: {
    home_instavc_build: "સંસ્થાઓ અને કર્મચારીઓ વચ્ચે અર્થપૂર્ણ સંબંધો બનાવો",
    home_instavc_conference_platform:
      "અનન્ય વપરાશકર્તા અનુભવ સાથેનું કોન્ફરન્સ પ્લેટફોર્મ",
    home_instavc_start_conference:
      "સ્ટાર્ટ કાન્ફરેન્સ |જ઼ોઇન કોન્ફરન્સ | ઇન્સ્ટા કોન્ફરન્સ",
    home_instavc_Hippa:
      "હિપા એલિજિબલ અને પીસીઆઈ ડીએસએસ, એસઓસી, આઇએસઓ / ઇઆઇસી 27001, આઇએસઓ / ઇઆઇસી 27017, આઇએસઓ / ઇઆઇસી 27018, અને આઈએસઓ 9001 અનુરૂપ.",
    home_instavc_copyrights:
      "© ૨૦૧૮. ઇન્સ્ટાવીસી· પીપલિંક યુનિફાઇડ કમ્યુનિકેશન્સ પ્રા. લિ.",
    home_instavc_terms_agree: "હું સંમત છું",
    home_instavc_terms: "શરતો અને નિયમો",

    visibility: "દૃશ્યતા",
    members: "સભ્યો",
    create_class: "વર્ગ બનાવો",
    public_class: " સાર્વજનિક - ફક્ત વર્ગના સભ્યો જ જોડાઈ શકે છે",
    private_class: " ખાનગી - તમારી સંસ્થામાં કોઈપણ જોડાઈ શકે છે",
    private: "ખાનગી",
    filter_by: "આના દ્વારા ફિલ્ટર કરો:",
    blocked: "અવરોધિત",
    deleted: " કાઢી નાખ્યું",
    unblock: "અનાવરોધિત કરો",
    make_active: "સક્રિય કરો",
    addNewSubject: "નવો વિષય ઉમેરો",
    editSubject: "વિષય સંપાદિત કરો",
    addNewClass: "નવો વર્ગ ઉમેરો",
    assign_teacher: "શિક્ષકને સોંપો",
    exculde_students: "વિદ્યાર્થીઓને બાકાત રાખો",
    dateOfJoining: "જોડાવાની તારીખ",
    classes: "વર્ગો",
    users: "વપરાશકર્તાઓ",
    classList: "વર્ગોની સૂચિ",
    add_teacher: "શિક્ષક ઉમેરો",
    add_student: "વિદ્યાર્થી ઉમેરો",
    mySessions: "મારા સત્રો",
    reports: "અહેવાલો",

    inclass_admin_teacher: "શિક્ષકો",
    inclass_admin_student: "વિદ્યાર્થીઓ",
    inclass_admin_studentName: "વિદ્યાર્થીનું નામ",
    inclass_admin_studentID: "વિદ્યાર્થી ID",
    inclass_teacher_designation: "હોદ્દો",
    inclass_teacher_department: "વિભાગ",
    inclass_student_rollnumber: "રોલ નંબર",
    inclass_teacher_status: "સ્થિતિ",
    inclass_admin_user_info: "વપરાશકર્તા માહિતી",
    inclass_admin_professional_info: "વ્યવસાયિક માહિતી",
    inclass_student_classname: "વર્ગનું નામ",

    instavc_login: "લૉગ ઇન",
    instavc_login_email: "ઇમેઇલ",
    instavc_login_password: "પાસવર્ડ",
    instavc_login_button: "લૉગ ઇન",
    instavc_login_forgotpassword: "પાસવર્ડ ભૂલી ગયા છો ?",
    instavc_login_have_account: "એકાઉન્ટ નથી ?",
    instavc_login_signup: "સાઇનઅપ",
    instavc_signup: "સાઇનઅપ",
    instavc_signup_firstname: "પ્રથમ નામ",
    instavc_signup_lastname: "છેલ્લું નામ",
    instavc_signup_email: "ઇમેઇલ",
    instavc_signup_password: "પાસવર્ડ",
    instavc_signup_cpassword: "પાસવર્ડની પુષ્ટિ કરો",
    instavc_signup_button: "સાઇનઅપ",
    instavc_signup_already_have_account: "પહેલેથી જ એક એકાઉન્ટ છે?",
    instavc_signup_login: "લૉગ ઇન",
    instavc_signup_fname_error: "પ્રથમ નામ ફક્ત મૂળાક્ષરોનું હોવું જોઈએ",
    instavc_signup_lname_error: "છેલ્લું નામ ફક્ત મૂળાક્ષરોનું હોવું જોઈએ",
    instavc_signup_email_error: "ઇમેઇલ યોગ્ય ફોર્મેટમાં હોવો જોઈએ",
    instavc_signup_password_error:
      "પાસવર્ડ આઠ અક્ષરો લાંબો હોવો જોઈએ અને એક અપરકેસ, એક લોઅરકેસ, એક અંક અને એક ખાસ અક્ષરનું સંયોજન હોવું જોઈએ",
    instavc_signup_cpassword_error:
      "કન્ફર્મ પાસવર્ડ ઉપરના પાસવર્ડ સાથે મેળ ખાતો હોવો જોઈએ",
    instavc_forgotpassword_link:
      "તમારા એકાઉન્ટ સાથે સંકળાયેલ ઈમેલ આઈડી દાખલ કરો. તમારો પાસવર્ડ રીસેટ કરવા માટે અમે તમને OTP મેઈલ કરીશું.",
    instavc_forgotpassword_email: "ઇમેઇલ સરનામું દાખલ કરો",
    instavc_forgotpassword: "પાસવર્ડ ભૂલી ગયા છો",
    instavc_forgotpassword_button: "પાસવર્ડ ભૂલી ગયા છો",
    instavc_confirmpass_heading: "વિદ્યાર્થી બનાવો",
    instavc_confirmpass_verificationcode: "વેરિફિકેશન કોડ દાખલ કરો",
    instavc_confirmpass_newpassword: "નવો પાસવર્ડ દાખલ કરો",
    instavc_confirmpass_retypepassword: "નવો પાસવર્ડ ફરીથી નાંખો",
    instavc_confirmpass_button: "શિક્ષક બનાવો",
    instavc_forgotpassword_signin: "સાઇન ઇન",
    instavc_forgotpassword_passwordcreated:
      "અભિનંદન! તમારો નવો પાસવર્ડ અપડેટ કરવામાં આવ્યો છે, તમે હવે inClass માં સાઇન ઇન કરી શકો છો.",
    instavc_dashboard: "ડૅશબોર્ડ",
    instavc_dashboard_schedule: "શેડ્યૂલ સત્ર",
    instavc_dashboard_meetinglist: "ભૂતકાળના સત્રો",
    instavc_dashboard_conferenceplatform:
      "અનન્ય વપરાશકર્તા અનુભવ સાથેનું કોન્ફરન્સ પ્લેટફોર્મ",
    instavc_dashboard_SC_room: "સ્ટાર્ટ કાન્ફરેન્સ",
    instavc_dashboard_SC_roomlist: "તમારું સુનિશ્ચિત સત્ર પસંદ કરીને",
    instavc_dashboard_startconference: "સ્ટાર્ટ કાન્ફરેન્સ",
    instavc_dashboard_JC: "જ઼ોઇન કોન્ફરન્સ",
    instavc_dashboard_JC_ID: "વાયા કાન્ફરેન્સ આઇડ ઓર શેડ્યૂલ્ડ",
    instavc_dashboard_JC_button: "જ઼ોઇન કોન્ફરન્સ",
    instavc_dashboard_SC: "સ્ટાર્ટ કાન્ફરેન્સ",
    instavc_dashboard_SC_p2p: "બાઇ સેલેક્ટિંગ ઍ રૂમ ફ્રોમ યૌર લીસ્ટ",
    instavc_dashboard_instaconference: "ઇન્સ્ટા કોન્ફરન્સ",
    instavc_dashboard_buynow: "હમણાં જ ખરીદો",
    instavc_dashboard_myprofile: "માય પ્રોફાઇલ",
    instavc_dashboard_settings: "સેટ્ટિંગ્સ",
    instavc_dashboard_myadmin: "માય ઍડમિન",
    instavc_dashboard_affiliate: "માય અફિલીયેટ",
    instavc_dashboard_logout: "લૉગ આઉટ",
    conference_myrooms: "માય રૂમ્સ",
    conference_myrooms_host: "શિક્ષક ID",
    conference_myrooms_roomhost: "તમે આ રૂમના હોસ્ટ છો.",
    conference_myrooms_search: "સર્ચ...",
    conference_myrooms_hostuser: "હોસ્ટ યૂજ઼ર",
    conference_myrooms_gotopremium: "ગો ટૂ પ્રીમિયમ ",
    conference_myrooms_buynow: "બાય નાવ ",
    conference_myrooms_renewal: "રિન્યૂયલ",
    conference_setup: "સેટપ",
    conference_myrooms_renewnow: "સેટપ નાવ",
    // "conference_myrooms_hosts": "હોસ્ટ",
    conference_myrooms_join: "જોઇન",
    conference_myrooms_setup: "રૂમ સેટપ",
    conference_myrooms_sethost_email:
      "સેટ યૉરસેલ્ફ  ઍસ ઍ હોસ્ટ, ઓર ઍંટર ઍ યૂજ઼ર'ઍસ ઈમેલ અડ્રેસ ટૂ મેક હિમ/હર  ઍસ ઍ હોસ્ટ.",
    conference_myrooms_selfhost: "સેટ યૉરસેલ્ફ  ઍસ ઍ હોસ્ટ",
    conference_myrooms_otherhost:
      "ઑર - ઇફ યૂ વૉંટ ટૂ મેક ઍની યૂજ઼ર ઍસ હોસ્ટ, ઍંટર હિસ/હર ઈમેલ અડ્રેસ",
    conference_myrooms_email: "ઈમેલ અડ્રેસ",
    Cancel: "કૅન્સલ",
    conference_myrooms_apply: "અપ્લાઇ",
    view_schedule_myrooms: "માય રૂમ્સ",
    view_schedule_search: "સર્ચ ...",
    view_schedule_schedule: "શેડ્યૂલ.",
    view_schedule_calender: "બિલો ઇસ ધી કૅલંડર ટૂ ચેક ધી શેડ્યૂલ્સ ઓફ ધીસ રૂમ ",
    video_recordings: "વીડિયો રેકૉર્ડિંગ્સ",
    view_recordings_search: "સર્ચ",
    view_recordings_month: "ધિસ મન્થ",
    view_recordings_week: "લાસ્ટ 7 ડેય્સ",
    view_recordings_today: "ટુડે",
    no_recordings: "નો રેકૉર્ડિંગ્સ યેટ્!",
    no_recordings_message: "દેર આર નો વીડિયોસ હિયર, રાઇટ નાઉ.",
    no_recordings_startmessage:
      "વન્સ યૂ સ્ટાર્ટ રેકૉર્ડિંગ યૂ કૅન વૉચ ઑલ યૌર વીડિયોસ હિયર.",
    stop_recording: "ડૂ યૂ વૉંટ ટૂ સ્ટોપ દિસ રેકૉર્ડિંગ ?",
    stop_recording_agree: "અગ્રી",
    stop_recording_disagree: "ડિસાગ્રી",
    conference_in_use: "કાન્ફરેન્સ ઇસ ઇન યૂસ",
    conference_mode: "કાન્ફરેન્સ મોડ",
    large_conference_mode: "લાર્જ કાન્ફરેન્સ મોડ",
    conference_setup_configuration: "કૉનફિગરેશન",
    conference_setup_generateid: "કોઈ સત્ર આઈડી મળ્યું નથી, એક જનરેટ કરો!",
    conference_setup_regenerate: "રીજેનરેટ",
    conference_setup_meetingid: "પ્રક્રિયા નંબર",
    conference_setup_camera: "ફેસટાઈમ ઍચ ડી કૅમરા",
    conference_setup_defaultmicrophone:
      "ડિફૉલ્ટ - ઇંટર્નલ માઇક્રોફોન (બિલ્ટ-ઇન)",
    conference_setup_microphone: "ઇંટર્નલ માઇક્રોફોન (બિલ્ટ-ઇન)",
    conference_setup_volume: "વૉલ્યૂમ",
    conference_setup_videomode: "વીડિયો મોડ",
    conference_setup_forward: "ફૉર્વર્ડ",
    conference_setup_mix: "મિક્સ",
    conference_setup_invite: "ઇન્વાઇટ",
    conference_setup_invitepeople: "ઇન્વાઇટ પીપલ",
    conference_setup_invitefriends:
      "ઇન્વાઇટ  યોર ફ્રેંડ્સ ઍન્ડ કોવર્કર્સ ટૂ કોલૅબોવરેટ.",
    conference_setup_invite_directlink: "ડાઇરેક્ટ લિંક તો યૉર રૂમ",
    conference_setup_invite_sharelink:
      "શેર ધીસ લિંક વિથ યૌર પાર્ટિસિપેંટ્સ ફોર ધેમ ટૂ જોઇન યૌર સેશન",
    conference_setup_invite_link:
      "https://connect.instavc.com/conference-guest/eddca0fc7adcdc61a24dabe02597412a36bb96dac7302f3cedb6aac50169d58614eb46b940b556a9/f",
    conference_setup_invitebyemail: "ઇન્વાઇટ બાઇ મેલ",
    conference_setup_invite_enteremail:
      "તમારા સહભાગીઓને આમંત્રણ આપવા માટે પસંદ કરેલું ઇમેઇલ સરનામું દાખલ કરો",
    conference_setup_invite_emailid: "ઈ - મેઈલ સરનામું",
    conference_setup_invite_close: "બંધ",
    conference_setup_invite_button: "આમંત્રિત",
    conference_setup_advancesettings: "એડવાન્સ સેટિંગ્સ",
    conference_setup_changeresolution: "રીસોલ્યુસન પસંદ કરો",
    conference_setup_lowbandwidth: "લો બેન્ડવિડ્થ",
    conference_setup_poornetwork: "નબળું નેટવર્ક",
    conference_setup_vga: "વીજીએ - (640x480)",
    conference_setup_vga_graphics:
      "વિડિઓ ગ્રાફિક્સ એરે (વીજીએ) વિડિઓ રીસોલ્યુસન માટે",
    conference_setup_hd1080: "એચ.ડી1080p - (1920x1080)",
    conference_setup_fhd: "સંપૂર્ણ હાઇ ડેફિનેશન (એફએચડી) વિડિઓ રીસોલ્યુસન માટે",
    conference_setup_4k: "4K - (3840 x 2160)",
    conference_setup_4k_fhd:
      "સંપૂર્ણ હાઇ ડેફિનેશન (એફએચડી) વિડિઓ રીસોલ્યુસન માટે",
    conference_setup_sif: "એસ.આઇ.એફ. - (320x240)",
    conference_setup_sif_vr: "એસ.આઇ.એફ.એસ.આઇ.એફ.",
    conference_setup_hd720: "એચ.ડી720p - (1280x720)",
    conference_setup_hd720_vr: "હાઇ ડેફિનેશન (એચડી)વિડિઓ રીસોલ્યુસન માટે ",
    conference_setup_2k: "2K - (2048×1080)",
    conference_setup_2k_fhd:
      "સંપૂર્ણ હાઇ ડેફિનેશન (એફએચડી) વિડિઓ રીસોલ્યુસન માટે",
    conference_setup_broadcastoptions: "બ્રોડકાસ્ટ વિકલ્પો",
    conference_setup_enable: "સક્ષમ કરો",
    conference_setup_disable: "અક્ષમ કરો",
    conference_setup_reportquality:
      "વોઇસ અને વિડિઓ કોલ્સને સુધારવામાં સહાય માટે ગુણવત્તાની આંકડાની જાણ કરો",
    conference_setup_havetroubleshoot:
      "શું તમે કોન્ફરન્સ ટ્રબલશૂટ કરવા માંગો છો, તો અહીં લિંકને ક્લિક કરો ",
    conference_setup_conferencetroubleshoot: "કન્ફરન્સ ટ્રુબલશૂટર",
    conference_troubleshoot: "ટ્રુબલશૂટ",
    conference_troubleshoot_faq: "FAQ",
    conference_troubleshoot_emailreport: "ઇમેઇલ રિપોર્ટ ",
    conference_troubleshoot_gotoconference: "કન્ફરન્સ પર જાઓ",
    conference_troubleshoot_os: "ઑપરેટિંગ સિસ્ટમ",
    conference_troubleshoot_version: "વર્સન",
    conference_troubleshoot_browser: "બ્રાઉઝર",
    conference_troubleshoot_chromeversion: "ક્રોમ વર્સન",
    conference_troubleshoot_privatebrowsing: "ખાનગી બ્રાઉઝિંગ",
    conference_troubleshoot_displayresolution: "ડિસ્પ્લે રીઝોલ્યુશન",
    conference_troubleshoot_aspectratio: "ડિસ્પ્લે આસ્પેક્ટ રેશિયો",
    conference_troubleshoot_hasspeakers: "સિસ્ટમમાં સ્પીકર્સ છે ?",
    conference_troubleshoot_foundspeaker: "સ્પીકર ડિવાઇસ મળ્યાં ",
    conference_troubleshoot_hasmicrophone: "સિસ્ટમમાં માઇક્રોફોન  છે ?",
    conference_troubleshoot_foundmicrophone: "માઇક્રોફોન ડિવાઇસ મળ્યાં ",
    conference_troubleshoot_haswebcam: "સિસ્ટમમાં વેબકૅમેરો  છે ?",
    conference_troubleshoot_foundcameras: "વેબકૅમેરો  મળ્યાં ",
    conference_troubleshoot_webcampermission: "વેબસાઇટ પર વેબકેમ પરવાનગી છે ?",
    conference_troubleshoot_microphonepermission:
      "વેબસાઇટમાં માઇક્રોફોન પરવાનગી છે ?",
    conference_troubleshoot_getUsermedia:
      "બ્રાઉઝર આ પૃષ્ઠ પર ગેટ યૂસર મીડિયા ને મંજૂરી આપે છે?",
    conference_troubleshoot_changeoutput_audiodevice:
      "શું તમે આઉટપુટ ઑડિઓ ડિવાઇસ બદલી શકો છો?",
    conference_troubleshoot_changecamera_resolution:
      "નવી કન્ફરન્સ વિનંતી કર્યા વિના તમે કૅમેરાનાં રીઝોલ્યુશન બદલી શકો છો?",
    conference_troubleshoot_supportwebrtc:
      "બ્રાઉઝર વેબઆરટીસીને સમર્થન આપે છે (ક્યાં તો 1.0 અથવા 1.1)?",
    conference_troubleshoot_supportortc:
      "બ્રાઉઝર ઓઆરટીસી (વેબઆરટીસી 1.1) ને સપોર્ટ કરે છે?",
    conference_troubleshoot_turnserver:
      "ટર્ન સર્વરને ફરીથી પહોંચી શકાય તેવું છે?",
    conference_troubleshoot_turn: "turn:139.59.64.172:443",
    conference_troubleshoo_coturn: "turn:coturn.instavc.com:443",
    conference_troubleshoot_replacetracks:
      "શું તમે સાથીઓને નિયોજીકરણ કર્યા વિના ટ્રેક્સ બદલી શકો છો ?",
    conference_troubleshoot_record_remoteaudio:
      "Can your browser record remote audio or process remote audio stream in WebAudio API?",
    conference_troubleshoot_browsersupports_websocketapi:
      "બ્રાઉઝર્સ વેબસોકેટ ઍપીઆઇ ને સપોર્ટ કરે છે",
    conference_troubleshoot_blockwebsocket:
      "તમારી સિસ્ટમએ વેબસ્કેટ્સ પ્રોટોકોલને અવરોધિત કર્યો છે, અથવા વેબસોકેટ્સ સર્વર સુલભ નથી? ના ",
    conference_troubleshoot_supportwebaudioapi:
      "બ્રાઉઝર વેબઑડિઓ ઍપીઆઇ ને સપોર્ટ કરે છે ?",
    conference_troubleshoot_supportsctp:
      "બ્રાઉઝર એસસીટીપી ડેટા ચેનલોને સપોર્ટ કરે છે ?",
    conference_troubleshoot_supportsrtp:
      "બ્રાઉઝર આરટીપી ડેટા ચેનલોને સપોર્ટ કરે છે ?",
    conference_troubleshoot_support_screencapturing:
      "આ પૃષ્ઠ સ્ક્રીન કેપ્ટપ્ચરિંગ ઍપીઆઇ ને સપોર્ટ કરે છે ?",
    conference_troubleshoot_support_multimonitor:
      "શું બ્રાઉઝર મલ્ટિ-મોનિટર સિલેક્શન અને કોઈપણ મોનિટરની સ્ક્રીન કેપ્ચરિંગને સપોર્ટ કરે છે?",
    conference_troubleshoot_mobiledevice: "તે મોબાઇલ ડિવાઇસ છે? ?",
    conference_troubleshoot_supportscreencap_canvas:
      "શું બ્રાઉઝર કેનવાસથી સ્ક્રીન કેપ્ચરિંગને સપોર્ટ કરે છે ?",
    conference_troubleshoot_supportscreencap_video:
      "શું બ્રાઉઝર વિડિઓમાંથી સ્ક્રીન કેપ્ચરિંગને સપોર્ટ કરે છે ?",
    conference_troubleshoot_supportpromisses:
      "શું બ્રાઉઝર વચનોનું સમર્થન કરે છે?",
    conference_troubleshoot_ipaddress: "આઇપી સરનામાં બતાવવા માટે ક્લિક કરો",
    conference_troubleshoot_stunserver:
      "સ્ટન સર્વરને ફરીથી પહોંચી શકાય તેવું છે ?",
    cancel: "રદ કરો",
    instavc_conference_revoke_fromhost: "હોસ્ટમાંથી રદ કરો",
    instavc_conference_startvideoconf_button: "વિડિઓ કન્ફરન્સ પ્રારંભ કરો",
    instavc_conference_loading:
      "તમારી સ્ક્રીન લોડ કરી રહ્યું છે, કૃપા કરીને રાહ જુઓ",
    instavc_conference_authenticating:
      "ઇન્સ્ટાવાક સર્વરમાં પ્રમાણિત કરી રહ્યું છે ....",
    instavc_conference_joinconference: "કન્ફરન્સમાં જોડાતા",
    instavc_conference_publishyourvideo: "તમારી વિડિઓ પ્રકાશિત કરી રહ્યું છે",
    instavc_conference_publishyouraudio: "તમારી વિડિઓ પ્રકાશિત કરી રહ્યું છે",
    instavc_conference_settings: "સેટિંગ્સ",
    instavc_conference_setting: "કન્ફરન્સ સેટિંગ્સ",
    instavc_conference_setting_source: "સ્રોત",
    instavc_conference_setting_camera: "કેમેરો",
    instavc_conference_audioinputs: "ઑડિઓ ઇનપુટ્સ",
    instavc_conference_setting_apply: "અરજી કરો",
    instavc_conference_setting_resolution: "રીઝોલ્યુશન",
    instavc_conference_setting_qr: "ક્યૂઆર (બીટા)",
    instavc_conference_whiteboard: "વ્હાઇટબોર્ડ",
    instavc_conference_screenshare: "સ્ક્રીન શેર",
    instavc_conference_presenter: "પ્રસ્તુતકર્તા",
    instavc_conference_stopshare: "શેર રોકો",
    instavc_conf_install_Screenshare: "સ્ક્રીનશેર ઇન્સ્ટોલ કરો",
    instavc_conference_videosync: "સાથે જુઓ",
    instavc_conference_videourl: "વિડિઓ યુ આર ઍલ",
    instavc_conference_enter_videourl: "વિડિઓ યુ આર ઍલ દાખલ કરો",
    instavc_conference_videourl_note:
      "નોંધ: ફક્ત સક્રિય સહભાગીઓ જ આ વિડિઓ જોઈ શકે છે, મોડું જોડાનારાઓ વિડિઓ જોઈ શકતા નથી",
    instavc_conf_recordings: "રેકોર્ડિંગ",
    instavc_conference_sharecontent: "તમારી સ્ક્રીન શેર કરો",
    instavc_conference_sharecontent_screen:
      "connect.instavc.com તમારી સ્ક્રીનની સામગ્રીને શેર કરવા માંગે છે. તમે જે શેર કરવા માગો છો તે પસંદ કરો",
    instavc_conference_shareentire_screen: "તમારી સંપૂર્ણ સ્ક્રીન",
    instavc_conference_sharescreen_applicationwindow: "એપ્લિકેશન વિંડો",
    instavc_conference_sharescreen_chrometab: "ક્રોમ ટેબ",
    instavc_conference_sharescreen_share: "શેર કરો",
    instavc_conf_sharescreen: "તમે તમારી સ્ક્રીન શેર કરી રહ્યાં છો!",
    instavc_conf_share_otherparticipants:
      "અન્ય સહભાગીઓ તમારી સ્ક્રીન પર એપ્લિકેશન અને દસ્તાવેજો જોઈ શકે છે",
    instavc_stopsharing: "શેર કરવાનું બંધ કરો",
    instavc_conference_chat: "ચેટ",
    instavc_conference_additional_camera: "અતિરિક્ત કેમેરો",
    instavc_conference_sharescreen_groupchat: "જૂથ ચેટ",
    instavc_conference_sharescreen_GC: "જી.સી.",
    instavc_conference_entermessage: "કંઈક બોલ!",
    instavc_conference_adddevice: "ડિવાઇસ ઉમેરો",
    instavc_conference_adddevice_addcamera: " કેમેરો ઉમેરો",
    instavc_conference_adddevice_source: "સ્રોત",
    instavc_conference_adddevice_camera: "કેમેરો",
    instavc_conference_adddevice_cameraname: "ફેસટાઇમ એચડી કેમેરો",
    instavc_conference_adddevice_close: "બંધ ",
    instavc_conference_adddevice_publish: "પ્રકાશિત કરો",
    instavc_conference_info: "માહિતી",
    questions: "પ્રશ્નો",
    instavc_conference_askquestions: "પ્રશ્નો પૂછો",
    instavc_conference_info_meetingid: "વ્યક્તિગત સત્ર ID",
    instavc_conference_fullscreen: "સંપૂર્ણ સ્ક્રીન",
    conference_setup_invitepeoplel: "લોકોને આમંત્રણ આપો",
    conference_setup_invite_linktojoin:
      "https://connect.instavc.com/conference-guest/93ac2135d88727ca29061b4b6bf9477bc8f285a8121ff580649512abad353fbc6751a134d56438f7/f",
    conference_setup_invite_byemail: "મેઇલ દ્વારા આમંત્રિત કરો",
    instavc_conference_participants: "ભાગ લેનાર",
    instavc_conference_participants_search: "તપાસ ...",
    instavc_conference_participant: "ભાગ લેનાર",
    instavc_conference_participants_muteall: "બધાને મ્યૂટ કરો",
    instavc_conference_participants_unmuteall: "બધાને અનમ્યૂટ કરો",
    instavc_conference: "કન્ફરન્સ",
    instavc_conf_more: "વધારે",
    instavc_conference_picturemode:
      "આ વિડિઓ પિક્ચર-ઇન-પિક્ચર મોડમાં ચાલી રહી છે",
    instavc_conference_mediastreams_stats: "મીડિયા સ્ટ્રીમ આંકડા",
    instavc_conference_mediastreams_audio: "ઓડિઓ",
    instavc_conference_mediastreams_audio_send: "મોકલો",
    instavc_conference_mediastreams_audio_codec: "કોડેક",
    instavc_conference_mediastreams_audio_rates: "રે ત્સ (કે બી પી ઍસ)",
    instavc_conference_mediastreams_audio_lost: "ખોવાઈ ગઈ",
    instavc_conference_mediastreams_audio_fraction: "ટુકડો",
    instavc_conference_mediastreams_video: "વિડિઓ",
    instavc_conference_mediastreams_video_send: "મોકલો",
    instavc_conference_mediastreams_video_codec: "કોડેક",
    instavc_conference_mediastreams_video_rates: "રે ત્સ (કે બી પી ઍસ)",
    instavc_conference_mediastreams_video_lost: "ખોવાઈ ગઈ",
    instavc_conference_mediastreams_video_fraction: "ટુકડો",
    instavc_conference_resolution: "રીસોલ્યુસન",
    instavc_conference_framerate: "ફ્રેમ દર",
    instavc_conference_nack: "નૅક",
    instavc_conference_pli: "પી.એલ.આઇ.",
    instavc_conference_bw: "ઉપલબ્ધ બી.ડબલ્યુ",
    instavc_conference_audiomuted: "ઑડિયો મ્યૂટ કર્યો",
    instavc_conference_microphonemuted: "તમારો માઇક્રોફોન મ્યૂટ કર્યો",
    join_conference_join_meetinginvitation: "સત્ર આમંત્રણોમાં જોડાઓ",
    join_conference_search: "શોધ ...",
    "join_conference_meeting details": "મીટિંગ નામ\nInvited By:\ninvitor name",
    join_conference_join: "જોડાઓ",
    join_conference_nomeetings: "કોઈ સત્રો નથી",
    join_conference_noupcomingmeetings:
      "અરે! તમારી પાસે હજુ સુધી કોઈ આગામી સત્રો નથી!",
    insta_conference_mycontacts: "મારા સંપર્કો",
    insta_conference_search: "શોધો ...",
    insta_conference_typemessage: "સંદેશ લખો",
    insta_conference_addcontact: "સંપર્ક ઉમેરો",
    insta_conference_enteremail: "મેઇલ આઈડી દાખલ કરો ",
    insta_conference_add: "ઉમેરો",
    insta_conference_nouserfound:
      "આ ઇમેઇલ સરનામાં સાથે આવો કોઈ વપરાશકર્તા મળ્યો નથી",
    instavc_conf_callnot_allowed:
      "જ્યારે તમે પહેલાથી ક aલમાં હો ત્યારે તમે અન્ય વપરાશકર્તાઓને કૉલ કરી શકતા નથી",
    insta_conference_pendingapproval: "સંમતિ બાકી",
    insta_conference_outgoingvideocall: "આઉટગોઇંગ વિડિઓ કૉલ",
    insta_conference_calling: "કૉલઈન્ગ ....",
    insta_conference_incomingvideocall: "ઇનકમિંગ વિડિઓ કૉલ",
    insta_conference_calldecline: "રદ કરો",
    insta_conference_callaccept: "સ્વીકારો",
    insta_conference_instavcalert: "કનેક્ટ.નેસ્ટાવી.કોમ પરવાનગી આપવા માંગે છે",
    insta_conference_usemicrophone: "તમારા માઇક્રોફોનનો ઉપયોગ કરો",
    insta_conference_usecamera: "તમારા ક cameraમેરાનો ઉપયોગ કરો",
    insta_conference_blockdevices: "અવરોધિત કરો",
    insta_conference_allowdevices: "મંજૂરી આપો",
    instavc_schedulemeeting_createmeeting: "નવું સત્ર બનાવો / સંપાદિત કરો",
    instavc_schedulewebinar_createmeeting:
      "નવી વેબિનર  સંપાદન બનાવો / સંપાદિત કરો",
    instavc_schedulemeeting_meetingname: "તમારા સત્રને નામ આપો",
    instavc_schedulemeeting_selectnames_tomeeting:
      "તમારા સત્ર માટે રૂમ પસંદ કરો",
    instavc_schedulemeeting_setduration: "સમયગાળો સેટ કરો",
    instavc_schedulemeeting_15min: "15 મિનિટ",
    instavc_schedulemeeting_30min: "30 મિનિટ",
    instavc_schedulemeeting_60min: "60 મિનિટ",
    instavc_schedulemeeting_setcustom: "કસ્ટમ સેટ કરો",
    instavc_schedulemeeting_customduration: "કસ્ટમ સમયગાળો",
    instavc_schedulemeeting_minutes: "મિનિટ",
    instavc_schedulemeeting_setconfpassword: "તમારો કોન્ફરન્સ પાસવર્ડ સેટ કરો",
    instavc_schedulemeeting_typepassword: "તમારા સત્ર માટે પાસવર્ડ લખો",
    instavc_schedulemeeting_conferencecolor: "તમારા કોન્ફરન્સ આઇકોનને રંગ આપો",
    instavc_schedulemeeting_invitepeople: "લોકોને આ સત્રમાં આમંત્રિત કરો",
    instavc_schedulemeeting_search: "શોધો ...",
    instavc_schedulemeeting_SM: "એસ.એમ.",
    instvc_SM_message:
      "અધિકૃત વપરાશકર્તા લાઇસેંસવાળા વપરાશકર્તાઓની સંખ્યા લાઇસેંસ મર્યાદાને ઓળંગી ગઈ છે. જો તમે વધુ લોકોને આમંત્રિત કરવા માંગતા હો તો ",
    instavc_SM_message_href: "પ્રીમિયમ પર જાઓ",
    instavc_schedulemeeting_notify: "આ સત્ર વિશે પસંદ કરેલા લોકોને સૂચિત કરો",
    instavc_schedulemeeting_addreminder: "રીમાઇન્ડર્સ ઉમેરો",
    instavc_schedulemeeting_add: "ઉમેરો",
    instavc_schedulemeeting_addmeetingreminder: "સત્ર રીમાઇન્ડર ઉમેરો",
    instavc_schedulemeeting_adddatetime: "તારીખ પીકર, સમય પીકર",
    instavc_schedulemeeting_apply: "અરજી કરો",
    instavc_schedulemeeting_name: "કૃપા કરીને સત્રનું નામ દાખલ કરો",
    instavc_schedulemeeting_selectroom: "કૃપા કરીને રૂમ પસંદ કરો",
    instavc_schedulemeeting_selectduration: "કૃપા કરીને સમયગાળો પસંદ કરો",
    instavc_recuring_schedule: "રિકરિંગ શેડ્યૂલ",
    instavc_schedulemeeting_nothinginreminders: "રીમાઇન્ડર્સમાં કંઈ નથી",
    instavc_schedulemeeting_createbutton: "બનાવો",
    instavc_schedulemeeting_createdsuccessfully: "સ્કડુલે સફળતાપૂર્વક બનાવ્યું",
    instavc_meetinglist_calender: "કૅલેન્ડર",
    instavc_meetinglist_selecteddates: "તમારી પસંદ કરેલી તારીખો",
    instavc_meetinglist_schedulecreted: "સૂચિ બનાવવામાં આવી",
    instavc_meetinglist_pastschedule: "પાછલું શેડ્યૂલ",
    instavc_meetinglist: "સત્રોની સૂચિ",
    instavc_meetinglist_meetingdetils: "સત્રનું નામ, સત્રનો સમય, દ્વારા આયોજિત",
    instavc_meetinglist_search: "શોધો ...",
    instavc_meetinglist_deleterecuring: "રિકરિંગ શેડ્યૂલ રદ કરો",
    instavc_meetinglist_alow_deleterecuring:
      "શું તમે પુનરાવૃત્તિના ફક્ત વર્તમાન સમયપત્રક, અથવા બધા સમયપત્રકોને  રદ કરવા માંગો છો ?",
    instavc_meetinglist_schedule_series:
      "શ્રેણીના અન્ય બધા શેડ્યૂલ બાકી રહેશે:",
    instavc_meetinglist_schedule_seriesdelete:
      "શ્રેણીની બધી  શેડ્યૂલ રદ કરવામાં આવશે:",
    instavc_meetinglist_allrecuringsch: "બધા રિકરિંગ સૂચિ",
    instavc_meetinglist_cancelchanges: "ફેરફારો રદ કરો",
    instavc_meetinglist_noschedules: "કોઈ સૂચિ નથી",
    instavc_ml_schedulemessage:
      "હજુ સુધી કોઈ સત્ર શેડ્યૂલ બનાવવામાં આવ્યું નથી! નીચેના બટન પર ક્લિક કરીને તમારું શેડ્યૂલ બનાવો.",
    instavc_create_schedule: "શેડ્યૂલ બનાવો",
    instavc_meetinglist_currentschedule: "વર્તમાન શેડ્યૂલ",
    instavc_meetinglist_join: "જોડાઓ",
    instavc_meetinglist_buynow: "હમણાં જ ખરીદો",
    instavc_dashboard_chooseplan: "પ્લાન પસંદ કરો",
    instavc_package_smbplan: "એસ.એમ.બી. પ્લાન",
    instavc_package_smbplan_host: "(હોસ્ટ બેસ્ડ લાઇસન્સ)",
    instavc_package_smbplandescription:
      "રૂમમાં એક સમયે 1 હોસ્ટ હોઈ શકે છે. ખરીદનાર હોસ્ટ એકાઉન્ટને સેટ અથવા બદલી શકે છે, જે રૂમને નિયંત્રિત કરી શકે છે.. કોલ દરમિયાન હોસ્ટ  ઍક્સેસ શેર કરી શકાતી નથી.. જ્યાં સુધી હોસ્ટ કોન્ફરન્સમાં જોડાશે નહીં ત્યાં સુધી અન્ય તમામ વપરાશકર્તાઓ સંપર્ક કરી શકતા નથી..",
    instavc_package_basic: "મૂળ",
    instavc_package_hostuser_smb: "1 હોસ્ટ અને",
    instavc_package_hostuser_smb_users: "વપરાશકર્તાઓ",
    instavc_package_currency: "$",
    instavc_package_permonth: "/ મહિનો",
    instavc_package_bill_smb: "વાર્ષિક બિલ",
    instavc_package_include_smb: "આ પેકેજ સાથે સમાવેશ થાય છે",
    instavc_package_specifictions_Whiteboard: "વ્હાઇટબોર્ડ",
    instavc_package_specifictions_Screen: "સ્ક્રીન શેર",
    instavc_package_specifictions_nChat: "વાતચીત",
    instavc_package_specifictions_Recording: "રેકોર્ડિંગ",
    instavc_package_specifictions_PresenterMode: "પ્રસ્તુતકર્તા મોડ",
    instavc_package_buynowbutton: "હમણાં જ ખરીદો",
    instavc_package_fullfeatures_smb: "સંપૂર્ણ સુવિધાઓ",
    instavc_package_billinginfo: "બિલિંગ માહિતી",
    instavc_package_billinginfo_name: "નામ",
    instavc_package_billinginfo_orginazation: "સંસ્થા",
    instavc_package_biilinginfo_gstin: "જીએસટીઆઈએન",
    Save: "સાચવો",
    instavc_package_billinginfo_edit: "ફેરફાર કરો",
    instavc_package_billingdetails: "બિલિંગ વિગતો",
    instavc_package_billingdetails_firstname: "પ્રથમ નામ",
    instavc_package_billingdetails_lastname: "છેલ્લું નામ",
    instavc_package_billingdetails_address: "સરનામું",
    instavc_package_billingdetails_zip: "ઝિપ",
    instavc_package_shippinginfo: "શિપિંગ માહિતી",
    instavc_package_shippinginfo_edit: "ફેરફાર કરો",
    instavc_package_shippingdetails: "શિપિંગ વિગતો",
    instavc_package_shippingdetails_firstname: "પ્રથમ નામ",
    instavc_package_shippingdetails_lastname: "છેલ્લું નામ",
    instavc_package_shippingdetails_address: "સરનામું",
    instavc_package_shippingdetails_zip: "ઝિપ",
    instavc_package_cartsummary: "કાર્ટ સારાંશ",
    instavc_package_hostbase: "હોસ્ટ બેસ્ડ લાઇસન્સ (લાઇસેંસ નામ)",
    instavc_package_smbplan_basic: "એસએમબી પ્લાન - મૂળ",
    instavc_package_plandetails:
      "$ 144.02\n\n1 વર્ષ માટે બિલ \n$ 13 પ્રતિ મહિના",
    instavc_package_term: "મુદત",
    instavc_package_1year: "1 વર્ષ",
    instavc_package_2years: "2 વર્ષ",
    instavc_package_3years: "3 વર્ષ",
    instavc_package_4years: "4 વર્ષ",
    instavc_package_5years: "5 વર્ષ",
    instavc_package_subtotal: "પેટાસરવાળો",
    instavc_package_taxes: "કર અને ફી (જી.એસ.ટી. +18%)",
    instavc_package_launchoffer: "લોંચોફર",
    instavc_package_promo: "પ્રોમો સફળતાપૂર્વક લાગુ થયો",
    instavc_package_remove: "દૂર કરો",
    instavc_package_havepromocode: "એક પ્રોમો કોડ છે ? અહીં અરજી કરો",
    instavc_package_entercouponcode: "કૃપા કરી માન્ય કૂપન કોડ દાખલ કરો",
    instavc_package_total: "કુલ",
    instavc_package_offerdisclaimer: "ઓફર અસ્વીકરણ જુઓ",
    instavc_package_paynow: "હવે પૈસા આપો",
    instavc_package_payment_instavclicense:
      "પીપલિંક યુનિફાઇડ કમ્યુનિકેશન\nઇન્સ્ટાવીસી લાઇસન્સ માટેની ચુકવણી",
    instavc_package_phone: "ફોન",
    instavc_package_entervalid_contactnumber:
      "કૃપા કરી માન્ય સંપર્ક નંબર દાખલ કરો",
    instavc_package_email: "ઇમેઇલ",
    instavc_package_enteremail:
      "કૃપા કરી કોઈ માન્ય ઇમેઇ આઈડી દાખલ કરો. ઉદાહરણ : you@example.com",
    instavc_package_paybycard: "કાર્ડ દ્વારા ચૂકવણી",
    instavc_package_securedbyrazorpay: "રેઝરપે દ્વારા સુરક્ષિત",
    instavc_package_card: "કાર્ડ",
    instavc_package_enterotp:
      " સેવ કરેલા કાર્ડ્સનો ઉપયોગ કરવા માટે મોકલેલ ઓટીપી દાખલ કરો xxxxxxxxx\n",
    instavc_package_resendotp: "ઓટીપી ફરીથી મોકલો",
    instavc_package_skipsavedcards: " સેવેડ કાર્ડ્સ છોડો",
    instavc_package_enter_otp: "કૃપા કરી ઓ.ટી.પી. દાખલ કરો",
    instavc_package_skipthesavedcards: "સેવેડ કાર્ડ્સ છોડો",
    instavc_package_cardnumber: "કાર્ડ નંબર",
    instavc_package_entervalid_cardnumber: "કૃપા કરી માન્ય કાર્ડ નંબર દાખલ કરો",
    instavc_package_expiry: "સમાપ્તિ",
    instavc_package_cardholdername: "કાર્ડ ધારકોનું નામ",
    instavc_package_cvv: "સીવીવી",
    instavc_package_3digitcode:
      "તે તમારા કાર્ડની પાછળ છાપવામાં આવેલ 3 અંકનો કોડ છે",
    instavc_package_pay: "આપો",
    instavc_package_remembercard: "કાર્ડ યાદ રાખો",
    instavc_package_medium: "માધ્યમ",
    instavc_package_hostuser_medium: "1 હોસ્ટ અને 50 વપરાશકર્તાઓ",
    instavc_package_month_medium: "$15/ મહિનો",
    instavc_package_bill_medium: "વાર્ષિક બિલ+ જી.એસ.ટી. 18%",
    instavc_package_include_medium: "આ પેકેજ સાથે સમાવેશ થાય છે",
    instavc_package_specifictions_medium:
      "વ્હાઇટબોર્ડ  n સ્ક્રીન શેર  n ચેટ  n રેકોર્ડિંગ  n પ્રીસેન્ટર મોડ",
    instavc_package_buynow_medium: "હમણાં જ ખરીદો",
    instavc_package_fullfeatures_medium: "સંપૂર્ણ સુવિધાઓ",
    instavc_package_advanced: "અદ્યતન",
    instavc_package_hostuser_advanced: "1 હોસ્ટ અને 100 વપરાશકર્તાઓ",
    instavc_package_month_advanced: "$16/ મહિનો",
    instavc_package_bill_advanced: "વાર્ષિક બિલ+ જી.એસ.ટી. 18%",
    instavc_package_include_advanced: "આ પેકેજ સાથે સમાવેશ થાય છે",
    instavc_package_specifictions_advanced:
      "વ્હાઇટબોર્ડ  n સ્ક્રીન શેર  n ચેટ  n રેકોર્ડિંગ  n પ્રીસેન્ટર મોડ",
    instavc_package_buynow_advanced: "હમણાં જ ખરીદો",
    instavc_package_fullfeatures_advanced: "સંપૂર્ણ સુવિધાઓ",
    instavc_package_virtualmcu: "વર્ચ્યુઅલ એમસીયુ લાઇસન્સ",
    instavc_package_virtualmcu_room: "(રૂમ આધારિત લાઇસન્સ)",
    instavc_package_vmcudetails:
      "રૂમમાં એક સમયે 1 હોસ્ટ હોઈ શકે છે. ખરીદનાર હોસ્ટ એકાઉન્ટને સેટ અથવા બદલી શકે છે, જે રૂમને નિયંત્રિત કરી શકે છે.. કોલ દરમિયાન હોસ્ટ  ઍક્સેસ શેર કરી શકાતી નથી.. જ્યાં સુધી હોસ્ટ કોન્ફરન્સમાં જોડાશે નહીં ત્યાં સુધી અન્ય તમામ વપરાશકર્તાઓ સંપર્ક કરી શકતા નથી",
    instavc_package_instavc: "ઇન્સ્ટાવીસી",
    instavc_package_silver: "સિલ્વર",
    instavc_package_userrooms_silver_users: "વપરાશકર્તાઓ",
    instavc_package_userrooms_silver_rooms: "રૂમ",
    instavc_package_month_silver: "$281/ મહિનો",
    instavc_package_bill_silver: "વાર્ષિક બિલ+ જી.એસ.ટી. 18%",
    instavc_package_include_silver: "આ પેકેજ સાથે સમાવેશ થાય છે",
    instavc_package_specifictions_silver:
      "વ્હાઇટબોર્ડ  n સ્ક્રીન શેર  n ચેટ  n રેકોર્ડિંગ  n પ્રીસેન્ટર મોડ",
    instavc_package_buynow_silver: "હમણાં જ ખરીદો",
    instavc_package_fullfeatures_silver: "સંપૂર્ણ સુવિધાઓ",
    instavc_package_gold: "ગોલ્ડ",
    instavc_package_userrooms_gold: "200 વપરાશકર્તાઓ - 30 રૂમ",
    instavc_package_month_gold: "$467/ મહિનો",
    instavc_package_bill_gold: "વાર્ષિક બિલ+ જી.એસ.ટી. 18%",
    instavc_package_include_gold: "આ પેકેજ સાથે સમાવેશ થાય છે",
    instavc_package_specifictions_gold:
      "વ્હાઇટબોર્ડ  n સ્ક્રીન શેર  n ચેટ  n રેકોર્ડિંગ  n પ્રીસેન્ટર મોડ",
    instavc_package_buynow_gold: "હમણાં જ ખરીદો",
    instavc_package_fullfeatures_gold: "સંપૂર્ણ સુવિધાઓ",
    instavc_package_platinum: "પ્લૅટિનમ",
    instavc_package_userrooms_platinum: "500 વપરાશકર્તાઓ - 50 રૂમ",
    instavc_package_month_platinum: "$ 933/ મહિનો",
    instavc_package_bill_platinum: "વાર્ષિક બિલ+ જી.એસ.ટી. 18%",
    instavc_package_include_platinum: "આ પેકેજ સાથે સમાવેશ થાય છે",
    instavc_package_specifictions_platinum:
      "વ્હાઇટબોર્ડ  n સ્ક્રીન શેર  n ચેટ  n રેકોર્ડિંગ  n પ્રીસેન્ટર મોડ",
    instavc_package_buynow_platinum: "હમણાં જ ખરીદો",
    instavc_package_fullfeatures_platinum: "સંપૂર્ણ સુવિધાઓ",
    instavc_package_legacybaselicense: "લેગસી આધારિત લાઇસન્સ",
    instavc_package_licensebased_ports: "પોર્ટની સંખ્યાના આધારે લાઇસન્સ",
    instavc_package_hardwareendpoint: "હાર્ડવેર એન્ડપોઇન્ટ સાથે ઇન્સ્ટાવીસી",
    instavc_package_webrtcconf_legacysupport:
      "લેગસી સપોર્ટ સાથે વેબઆરટીસી કોનફરન્સિંગ",
    instavc_package_sip: "એસઆઈપી / બીએફસીપી સપોર્ટ",
    instavc_package_chh323: "ChH323 / H.239 સપોર્ટ",
    instavc_package_contactus: "અમારો સંપર્ક કરો",
    instavc_myprofile_dashboard: "ડેશબોર્ડ",
    instavc_myprofile_settings: "સેટિંગ્સ",
    instavc_myprofile: "મારી પ્રોફાઈલ",
    instavc_myprofile_personaldetail: "અંગત વિગતો",
    instavc_myprofile_personaldetails_name: "નામ",
    instavc_myprofile_personaldetails_email: "ઇમેઇલ",
    instavc_myprofile_personaldetails_phoneno: "ફોન નંબર",
    instavc_myprofile_personaldetails_address: "સરનામું",
    instavc_myprofile_personaldetails_city: "શહેર",
    instavc_myprofile_edit: "ફેરફાર કરો",
    instavc_myprofile_personaldetails: "અંગત વિગતો",
    instavc_myprofile_firstname: "પ્રથમ નામ",
    instavc_myprofile_lastname: "છેલ્લું નામ",
    instavc_myprofile_email: "ઇમેઇલ",
    instavc_myprofile_phoneno: "ફોન નંબર",
    instavc_myprofile_professionaldetails: "વ્યવસાયિક વિગતો",
    instavc_myprofile_position: "પદ",
    instavc_myprofile_professionaldetails_email: "ઇમેઇલ",
    instavc_myprofile_professionaldetails_phoneno: "ફોન નંબર",
    instavc_myprofile_professionaldetails_address: "સરનામું",
    instavc_myprofile_professionaldetails_branch: "શાખા",
    instavc_myprofile_professionaldetails_edit: "ફેરફાર કરો",
    instavc_myprofile_officialdetails: "સત્તાવાર વિગતો",
    instavc_myprofile_officialdetails_position: "પદ",
    instavc_myprofile_officialdetails_email: "ઇમેઇલ",
    instavc_myprofile_officialdetails_phoneno: "ફોન નંબર",
    instavc_myprofile_officialdetails_branch: "શાખા",
    instavc_myprofile_officialdetails_address: "સરનામું",
    instavc_myprofile_contactinfo: "સંપર્ક માહિતી",
    instavc_myprofile_contactinformation: "સંપર્ક માહિતી",
    instavc_myprofile_add: "ઉમેરો",
    instavc_myprofile_contactinformation_address: "સરનામું",
    instavc_myprofile_contactinformation_city: "શહેર / નગર",
    instavc_myprofile_contactinformation_zip: "ઝિપ",
    instavc_myprofile_contactinformation_landmark: "સીમાચિહ્ન",
    instavc_myprofile_address: "સરનામું",
    instavc_myprofile_landmark: "સીમાચિહ્ન",
    instavc_myprofile_delete: "ચેતવણી",
    instavc_myprofile_deletealert: "શું તમે ખરેખર આને કાઢી નાખવા માંગો છો?",
    instavc_myprofile_disagree: "સહમત ન થવું",
    instavc_myprofile_agree: "સહમત થવું",
    instavc_myprofile_websitelinks: "વેબસાઇટ લિંક",
    instavc_myprofile_website_add: "ઉમેરો",
    instavc_myprofile_website: "વેબસાઇટ",
    instavc_myprofile_websiteexample: "https://www.google.com",
    instavc_myprofile_sociallinks: "સામાજિક લિંક્સ",
    instavc_myprofile_sociallinks_add: "ઉમેરો",
    instavc_myprofile_sociallink: "સામાજિક લિંક્સ",
    instavc_myprofile_sociallinks_example: "https://www.facebook.com/xxx",
    instavc_myprofile_basicinfo: "મૂળભૂત માહિતી",
    instavc_myprofile_basicinfo_add: "ઉમેરો",
    instavc_myprofile_basicinfo_dob: "જન્મ તારીખ",
    instavc_myprofile_basicinfo_gender: "લિંગ",
    instavc_myprofile_basicinformation: "મૂળભૂત માહિતી",
    instavc_myprofile_basicinformation_dob: "જન્મ તારીખ",
    instavc_myprofile_basicinformation_gender: "લિંગ",
    instavc_myprofile_basicinformation_deletealert:
      "ચેતવણી \n શું તમે ખરેખર આને કાઢી નાખવા માંગો છો?",
    instavc_myprofile_basicinformation_disagree: "સહમત ન થવું",
    instavc_myprofile_basicinformation_agree: "સહમત થવું",
    instavc_myprofile_uploadnewavatar: "નવી અવતાર અપલોડ કરો",
    instavc_myprofile_cropimage: "ઈમેજ કાપવા",
    instavc_myprofile_locale: "સ્થાન",
    instavc_myprofile_localesettings: "લોકેલ સેટિંગ્સ",
    instavc_myprofile_preferredlanguage: "પસંદગીની ભાષા :",
    instavc_myprofile_language: "અંગ્રેજી",
    instavc_settings: "સેટિંગ્સ",
    instavc_settings_changepassword: "પાસવર્ડ બદલો",
    instavc_settings_changepass: "પાસવર્ડ બદલો",
    instavc_settings_currentpassword: "અત્યારનો પાસવર્ડ",
    instavc_settings_newpassword: "નવો પાસવર્ડ",
    conf_password: "પાસવર્ડની પુષ્ટિ કરો",
    instavc_settings_enter_currentpassword: "કૃપા કરી વર્તમાન પાસવર્ડ દાખલ કરો",
    instavc_settings_enter_newpassword: "કૃપા કરીને નવો પાસવર્ડ દાખલ કરો",
    enter_confpassword: "કૃપા કરીને પાસવર્ડની પુષ્ટિ કરો",
    newpassword_confpassword_should_same:
      "નવો પાસવર્ડ અને કન્ફર્મ પાસવર્ડ સમાન હોવા જોઈએ",
    curnt_psw_and_new_psw_should_not_same:
      "વર્તમાન પાસવર્ડ અને નવો પાસવર્ડ સમાન ન હોવા જોઈએ",
    instavc_settings_help: "સહાય કરો",
    instavc_settings_affiliate: "એફિલિએટ બનો",
    instavc_settings_support: "સપોર્ટ સેન્ટર",
    instavc_settings_newticket: "નવી ટિકિટ ખોલો",
    instavc_settings_ticketstatus: "ટિકિટની સ્થિતિ તપાસો",
    instavc_settings_troubleshoot: "મુશ્કેલીનિવારણ",
    instavc_legacy_dailout: "ડાયલ આઉટ",
    instavc_legacy_stats: "સ્ટેટ્સ",
    instavc_legacy_dail_in_detail: "ડાયલ-ઇન વિગતો",
    instavc_legacy_h323_endpoint: "H.323 ઍન્ડ પોઈન્ટ",
    instavc_legacy_sip_endpoint: "એસ.આઈ.પી. ઍન્ડ પોઈન્ટ",
    instavc_admin_users: "વપરાશકર્તાઓ",
    instavc_courses: "અભ્યાસક્રમો",
    instavc_admin_username: "શિક્ષકનું નામ",
    instavc_admin_user_accountstatus: "ખાતાની સ્થિતિ",
    instavc_admin_user_confirmed: "સમર્થન ",
    instavc_admin_user_unconfirmed: "સમર્થન રહિત",
    instavc_admin_user_resetall: "બધાને ફરીથી સેટ કરો",
    instavc_admin_user_sync: "સિંક",
    instavc_admin_user_status: "સ્થિતિ",
    instavc_admin_user_phonenumber: "ફોન નંબર",
    instavc_admin_user_created: "બનાવ્યું",
    instavc_admin_user_all: "તમામ",
    instavc_admin_groups: "ગ્રૂપ",
    instavc_admin_addmore: "વધુ ઉમેરો",
    instavc_admin_group_peoplelink: "ક્વીન્સ, ગોલાઇવ, પીપલિંક",
    instavc_admin_select_plan: "પ્લાન પસંદ કરો",
    instavc_admin_lastmodified: "છેલ્લે સુધારેલું",
    instavc_admin_email_verified: "ઇમેઇલ ચકાસાયેલ",
    instavc_admin_verified: "ચકાસાયેલ",
    instavc_admin_Unverified: "ચકાસાયેલ નથી",
    instavc_admin_licenses: "લાઇસન્સ",
    instavc_admin_addlicense: "લાઇસેંસિસ ઉમેરો",
    instavc_admin_defaultroom: "ડિફૉલ્ટ રૂમ",
    instavc_admin_hostlicense: "હોસ્ટ બેસ્ડ લાઇસન્સ",
    instavc_admin_roomlicense: "રૂમ બેસ્ડ લાઇસન્સ",
    instavc_admin_virtualmcu: "વર્ચ્યુઅલ એમસીયુ બેસ્ડ લાઇસન્સ",
    instavc_admin_enterprise: "એન્ટરપ્રાઇઝ લાઇસન્સ",
    instavc_mcuserver: "એમસીયુ સર્વર",
    instavc_mculink: "https://awsmcu.instavc.com",
    instavc_admin_expirydate: "સમાપ્તિ તારીખ",
    instavc_admin_settings: "એડમિન સેટિંગ્સ",
    instavc_default_offer: "રેફરલ માટે ડિફોલ્ટ ઑફર",
    instavc_enter_coupon_code: "કૂપન કોડ દાખલ કરો",
    instavc_current_partshare: "વર્તમાન ભાગીદાર શેર",
    instavc_share_value: "શેર કિંમત",
    instavc_affliate_share: "વર્તમાન સંલગ્ન શેર",
    instavc_enter_share: " શેર કિંમત (%) દાખલ કરો",
    instavc_roomname: "રૂમ નામ",
    instavc_room_ten: "દસ",
    instavc_room_twenty: "વીસ",
    instavc_room_thirty: "ત્રીસ",
    instavc_room_hostbased: "હોસ્ટ બેઝ્ડ",
    instavc_virtualmcu: "વર્ચ્યુઅલ એમસીયુ",
    instavc_rooms_enterprises: "એન્ટરપ્રાઇઝ",
    instavc_roomid: "રૂમ આઈ.ડી.",
    instavc_roomtype: "ઉંમર",
    instavc_room_options: "રૂમ વિકલ્પો",
    instavc_commercialtype: "વિષયો",
    instavc_free: "મફત",
    instavc_poc: "પીઓ.સી.",
    instavc_commercial: "વાણિજ્યિક",
    instavc_createdAt: "બનાવ્યું મુ",
    instavc_useraccess: "વપરાશકર્તા વપરાશ",
    instavc_peoplelinkroom: "પીપલલિંક રૂમ",
    instavc_inputlimit: "ઇનપુટ મર્યાદા",
    instavc_participant_limit: "સહભાગીઓની મર્યાદા",
    instavc_adduser: "વપરાશકર્તા ઉમેરો",
    instavc_searchbyname: "નામ દ્વારા શોધો",
    instavc_manage_plans: "પ્લાન / પ્રૉડક્ટ મેનેજ કરો",
    instavc_new_plans: "નવી પ્લાન / પ્રૉડક્ટ",
    instavc_allplan_list: "બધી પ્લાન સૂચિ",
    instavc_sortby: "વર્ગ દ્વારા",
    instavc_active: "સક્રિય",
    instavc_inactive: "નિષ્ક્રિય",
    instavc_create_plan: "નવું પ્લાન બનાવો",
    instavc_plan_name: "પ્લાન નામ",
    instavc_enteramount: "રકમ દાખલ કરો (ન્યૂનતમ: INR 100)",
    instavc_select_product: "પ્રૉડક્ટ પસંદ કરો",
    instavc_host_room: "1 હોસ્ટ / રૂમ",
    instavc_multiroom: "મલ્ટી હોસ્ટ / રૂમ",
    instavc_legacyrooms: "લિગસી રૂમ",
    instavc_number_hosts: "હોસ્ટ ની સંખ્યા",
    instavc_number_participants: "સહભાગીઓની સંખ્યા",
    instavc_number_room: " રૂમની સંખ્યા",
    instavc_subscriptiom_period: "સબ્સ્ક્રિપ્શન અવધિ",
    instavc_sub_yearly: "વાર્ષિક",
    instavc_sub_monthly: "માસિક",
    instavc_sub_weekly: "સાપ્તાહિક",
    instavc_setinterval: "અંતરાલ સુયોજિત કરો",
    instavc_type: "ટાઈપ",
    instavc_subscription: "સબ્સ્ક્રિપ્શન",
    instavc_onetime: "એક વાર",
    instavc_description: "ડિસ્ક્રિપ્ષન",
    instavc_planid: "પ્લાનઆઈ.ડી.",
    instavc_orders: "ઓર્ડર",
    instavc_orderid: "ઓર્ડર આઈ.ડી.",
    instavc_none: "કંઈ નહીં",
    instavc_customer: "ગ્રાહક",
    instavc_build_anually: "વાર્ષિક બનાવો",
    instavc_recurring_billing: "રિકરિંગ બિલિંગ",
    instavc_next_due: "આગામી ચૂકવવાપાત્ર",
    instavc_invoice_details: "ઇન્વાઇસ વિગત",
    instavc_recurring_payment: "રિકરિંગ ચુકવણી",
    instavc_todays_sale: "આજનું વેચાણ",
    instavc_total_order: "કુલ ઓર્ડર",
    instavc_total_rooms: "કુલ રૂમ",
    instavc_current_conference: "વર્તમાન કાન્ફરેન્સ",
    instavc_current_user: "વર્તમાન વપરાશકર્તાઓ",
    instavc_live_broadcast: "લાઇવ બ્રોડકાસ્ટ્સ",
    instavc_loading_chart: "ચાર્ટ લોડ કરી રહ્યું છે ",
    instavc_view: "જુઓ",
    instavc_coupon_info: "કૂપન માહિતી",
    instavc_new_coupon: "નવું કૂપન",
    instavc_create_coupon: "નવું કૂપન બનાવો",
    instavc_coupon_code: "કુપનનૉ કોડ",
    instavc_company_code: "કંપની કોડ",
    instavc_select_plan: "પ્લાન પસંદ કરો",
    instavc_discount: "ડિસ્કાઉન્ટ",
    instavc_activestatus: "એક્ટિવ સ્ટેટસ",
    instavc_usage: "વપરાશ",
    instavc_activeusage: "સક્રિય વપરાશ",
    instavc_singleuse: "એક વાર  વાપરવુ",
    instavc_multiuse: "મલ્ટીવાર વાપરવુ",
    instavc_first_page: "પ્રથમ પાનું",
    instavc_previosu_page: "પાછલું પાનું",
    instavc_next_page: "આગામી પાનું",
    instavc_last_page: "છેલ્લું  પાનું",
    instavc_plan: "પ્લાન",
    instavc_request_withdrawal: "વિનંતી પાછી ખેંચી",
    instavc_withdraw: "પાછી ખેંચી",
    instavc_account: "અકાઉંટ",
    instavc_verification: "ચકાસણી",
    instavc_withdraw_history: "હિસ્ટરી પાછી ખેંચી",
    instavc_add_bank: "વિથડ્રૉ  માટે બેંક ખાતું ઉમેરો",
    instavc_bank_description:
      "અમે તમારી નાણાકીય માહિતીને ગુપ્ત રાખીને તમારા બેંક એકાઉન્ટને સુરક્ષિત કરીએ છીએ.જ્યારે પણ અમને આ એકાઉન્ટમાંથી ઉપાડ માટેની વિનંતી પ્રાપ્ત થાય છે ત્યારે અમે તમને સ્થિતિ ઇમેઇલ કરીશું. ઉપાડની નિષ્ફળતા અને વળતરની રકમ ટાળવા માટે, આ એકાઉન્ટ પરના નામ તમારા બેંક એકાઉન્ટ પરના નામ સાથે મેળ ખાતા હોવા જોઈએ.તમારી બેંકની નીતિઓ અને રજાના સમયપત્રકના આધારે ટ્રાન્સફર પૂર્ણ કરવામાં થોડો સમય લાગી શકે છે.",
    instavc_bank_accountnumber: "બેંક એકાઉન્ટ નંબર",
    instavc_enter_accountnumber: "તમારા એકાઉન્ટ નંબર દાખલ કરો",
    instavc_account_name: "એકાઉન્ટહોલ્ડરનું નામ",
    instavc_per_bank_account: "બેંક એકાઉન્ટ મુજબ",
    instavc_ifsc: "આઈએફએસસી કોડ",
    instavc_bankname: "બેંક નામ",
    "instavc_Branch Name": "બેંક શાખા નામ",
    instavc_confirmdetails: "વિગતોની પુષ્ટિ કરો",
    instavc_pandetails: "કૃપા કરીને તમારા પાન મુજબ નીચે વિગતો પ્રદાન કરો",
    instavc_enter_pan: "પાન મુજબ તમારું નામ દાખલ કરો",
    instavc_fathername: "પિતાનું નામ",
    instavc_enter_fathername: "પિતાનું નામ દાખલ કરો",
    instavc_pannumber: "પાન નંબર",
    instavc_panexampe: "Ex: BNZPM2501G",
    instavc_upload_pan_copy: "પાન કોપિ અપલોડ કરો",
    instavc_save_details: "વિગતો સેવ કરો",
    instavc_sales: "વેચાણ",
    instavc_transactionid: "ટ્રાન્ઝેક્શન આઈડી",
    instavc_date: "તારીખ",
    instavc_amount: "રકમ",
    instavc_setaccount_withdraw: "ઉપાડ પહેલાં એકાઉન્ટ વિગતો સેટ કરો",
    instavc_first_withdraw:
      "જો તમે પહેલી વાર ઉપાડ માટે વિનંતી કરી રહ્યા હો, તો તમારે એકાઉન્ટ વિગતો ભરવાની અને આગલા ટsબ્સમાં પાન કાર્ડ વિગતોનો ઉપયોગ કરીને તમારા એકાઉન્ટને ચકાસવાની જરૂર છે. એકવાર તમે ચકાસણી કરી લો, પછી તમે તમારા ઉપલબ્ધ બેલેન્સમાંથી ખસી જવા વિનંતી માટે આગળ વધી શકો છો. ",
    instavc_accountdetails: "એકાઉન્ટ વિગતો ભરો",
    instavc_available_balance: "વધેલી રાશી",
    instavc_amount_withdraw: "ઉપાડવાની રકમ",
    instavc_enteramount_withdraw: "તમે ઉપાડવા માંગો છો તે રકમ દાખલ કરો",
    instavc_select_payment_mode: "ચુકવણી મોડ પસંદ કરો",
    instavc_paypal_payment: "પેપાલ ચુકવણી",
    instavc_bank_transaction: "બેંક ટ્રાંઝેક્શન",
    instavc_paypalfee: "પેપલ ફી",
    instavc_totalamount_withdraw: "ઉપાડવાની કુલ રકમ",
    instavc_sendrequest: "વિનંતી મોકલી",
    instavc_no_request_withdraw: "ઉપાડ માટેની કોઈ વિનંતીઓ હજી સુધી ઉભી થઈ નથી!",
    instavc_start_process_withdraw:
      "તમે નીચેથી ઉપાડ માટેની પ્રક્રિયા શરૂ કરી શકો છો.",
    instavc_request_withdraw_now: "ઉપાડ માટેની વિનંતી",
    instavc_current_commission: "વર્તમાન ક્મીસન",
    instavc_from: "થી",
    instavc_to: "તરફ",
    instavc_today: "આજે",
    instavc_last7days: "છેલ્લા 7 દિવસ",
    instavc_lastmonth: "આ મહિને",
    instavc_paid_customers: "ચૂકવેલ ગ્રાહક",
    instavc_share_referral_link: "મિત્રો સાથે તમારી રેફરલ લિંક શેર કરો",
    instavc_copylink: "લિંક કોપિ કરો",
    instavc_minimum_payout: "ન્યૂનતમ ચુકવણી",
    instavc_referral_signup: "રેફરલ સાઇનઅપ્સ",
    instavc_referral_clicks: "રેફરલ ક્લિક્સ",
    instavc_paid: "ચૂકવેલ",
    instavc_unpaid: "અણચુકવેલું",
    instavc_totalearned: "કુલ કમાયેલ",
    instavc_myreferral: "મારા રેફરલ ",
    instavc_viewall: "બધુજ જુઓ",
    instavc_mysales: "માય સેલ્સ",
    instavc_sms_mfa: "એસએમએસ એમએફએ સ્થિતિ",
    instavc_facebook: "ફેસબુક",
    instavc_twitter: "ટ્વિટર",
    instavc_linkedin: "લિંક્ડઇન",
    instavc_referred_users: "રેફરલ વપરાશકર્તાઓ",
    instavc_created_date: "બનાવટની તારીખ",
    instavc_myearnings: "મારી કમાણી",
    instavc_earnings: "કમાણી",
    instavc_commission_share: "ક્મીસન શેર",
    instavc_commission_percentage: "ક્મીસન ટકાવારી",
    instavc_coupon_offers: "કુપન્સ / ઑફર્સ",
    instavc_my_referral_account: "મારું રેફરલ એકાઉન્ટ",
    instavc_req_withdraw: "ઉપાડ માટેની વિનંતી ",
    instavc_authenticating: "ઇન્સ્ટાવીસી સર્વરને પ્રમાણિત કરી રહ્યું છે ...",
    instavc_join_access_media:
      "જોડવું.. મીડિયા ઉપકરણોને ઍક્સેસ કરી રહ્યા છીએ...",
    instavc_publish_success: "પ્રકાશિત સફળ",
    instavc_recieves: "મેળવવું",
    instavc_host_screenshare:
      "તમારે સ્ક્રીન / દસ્તાવેજ શેરિંગ અથવા માટે હોસ્ટ બનવાની જરૂર છે",
    instavc_request_sharescreen:
      "સ્ક્રીન / દસ્તાવેજ શેરિંગ માટે ઍક્સેસની વિનંતી",
    instavc_note: "નોટ",
    instavc_filesize: "ફાઇલનું કદ 10MB કરતા વધુ ન હોવું જોઈએ",
    instavc_become_host:
      "યજમાન બનવા માટે વિડિઓ પર ડોટેડ ઓવરફ્લો મેનૂ આયકન્સને ક્લિક કરો",
    instavc_clicklink:
      "પોપઅપમાં, હોસ્ટ લિંક બનો પર ક્લિક કરો અને હોસ્ટ પાસવર્ડ દાખલ કરો અને હોસ્ટ બટન પર ક્લિક કરો",
    instavc_doc_share: "દસ્તાવેજ શેર",
    instavc_search_host: "હોસ્ટની રાહ જોવી",
    instavc_wait_for_host:
      "મહેરબાની કરીને આ સત્ર શરૂ કરવા માટે હોસ્ટની રાહ જુઓ",
    instavc_open_black_dialog: "બ્લૅક સંવાદ ખોલો",
    instavc_open_white_dialog: "વાઇટ સંવાદ ખોલો",
    instavc_dail_detail: "ડાયલ - ઇન - વિગતો",
    instavc_request_access: "એક્સેસની વિનંતી",
    instavc_inordder_enable: "ક્રમમાં સક્ષમ કરવા માટે",
    instavc_host_permission: "તમારે હોસ્ટની પરવાનગીની જરૂર છે",
    instavc_please_wait: "કૃપા કરી પ્રતીક્ષા કરો ",
    instavc_host_to_permit: "(હોસ્ટ)  માટે પરવાનગી",
    instavc_alternate_content: "વૈકલ્પિક સામગ્રી",
    instavc_meeting_room: "નો સેશન રૂમ",
    instavc_host_left_conference: "હોસ્ટ કોન્ફરન્સ છોડી દીધી!",
    instavc_conf_end: "કોન્ફરન્સ આપમેળે સમાપ્ત થશે",
    instavc_seconds: "સેકન્ડ્સ",
    instavc_waiting_msg:
      "રાહ જોવા બદલ આભાર. જ્યારે હોસ્ટ જોડાશે ત્યારે અમે સત્ર શરૂ કરીશું",
    instavc_let_hostname: "શું તમે હોસ્ટને જણાવવા માંગો છો કે તમે રાહ જુઓ છો?",
    instavc_exitconf: "કોન્ફરન્સ બહાર નીકળો ",
    instavc_host_left: "હોસ્ટ ગયો...",
    instavc_end_host_msg: "યજમાન આ સત્ર સમાપ્ત થયું છે. હાજરી આપવા બદલ આભાર.",
    instavc_close_conf:
      "તમે હોમે પાછા જઈ શકો છો (અથવા) એપ્લિકેશન બંધ કરી શકો છો.",
    instavc_gohome: "હોમે જાવ",
    instavc_hand_raised: "હેન્ડ રેસડ",
    instavc_ask: "પુછવું",
    instavc_protocal: "પ્રોટોકોલ",
    instavc_bitrate: "બિટરેટ",
    instavc_confirm_details: "તમારી વિગતોની પુષ્ટિ કરો",
    instavc_enter_info_conf:
      "કૃપા કરીને કોન્ફરન્સ શરૂ કરતા પહેલા તમારી માહિતી દાખલ કરો.",
    instavc_have_acc: "જો તમારી પાસે પહેલેથી જ એકાઉન્ટ છે?",
    instavc_host_access: "હોસ્ટ અકસેસ",
    instavc_host_pass: "હોસ્ટ પાસવર્ડ દાખલ કરો",
    instavc_becomehost: "હોસ્ટ બનો",
    instavc_permit_screenshare: " સ્ક્રીન-શેર પરવાનગી",
    instavc_allow_access: "વ્હાઇટબોર્ડ ઍક્સેસને મંજૂરી આપો",
    instavc_request_permission: "ને વધારાની પરવાનગીની વિનંતી કરી છે",
    instavc_deny: "નામંજૂર કરો",
    // "instavc_planid" : "પ્લાનઆઈડી",
    instavc_customeremail: "ગ્રાહક ઇમેઇલ",
    instavc_orderlink: "ઓર્ડર લિંક",
    instavc_customerid: "ગ્રાહક આઈ.ડી.",

    instavc_selectpackage: "પેકેજ પસંદ કરો",
    instavc_host_package: "હોસ્ટ આધારિત પેકેજ",
    instavc_virtualbase_mcu: "વર્ચ્યુઅલ એમસીયુ આધારિત ",
    instavc_plans_product: "પ્લાન / પ્રૉડક્ટ્સ",
    instavc_nodata: "કોઈ ડેટા ઉપલબ્ધ નથી",
    instavc_nodata_msg: "અરેરે! તમને હમણાં બતાવવા માટે કોઈ ડેટા ઉપલબ્ધ નથી.",
    instavc_basicplan: "મૂળ પ્લાન",
    instavc_host_participants: "30 સહભાગીઓ સાથે 1 હોસ્ટ",
    instavc_link: "લિંક",
    instavc_cancel_order: "ઓર્ડર રદ",
    instavc_per: "પ્રતિ",
    instavc_user_email: "વપરાશકર્તા ઇમેઇલ",
    instavc_owner: "માલિક",
    instavc_user: "વપરાશકર્તા ",
    instavc_default_users: "ડિફઔલ્ટ ઑફર્સ",
    instavc_system_settings: "સિસ્ટમ સેટિંગ્સ",
    instavc_expires: "સમાપ્ત થાય છે",
    instavc_start_VC: "વિડિઓ કોન્ફરન્સ પ્રારંભ કરો",
    instavc_start_AC: "ઓડિયો કોન્ફરન્સ શરૂ કરો",
    instavc_date_error: "પ્રારંભ તારીખ અને સમય વર્તમાન સમય કરતા વધુ હોવો જોઈએ",
    instavc_browser_update: "બ્રાઉઝર અપડેટ આવશ્યક છે",
    instavc_browser_note:
      "અમે નોંધ્યું છે કે તમે બ્રોવસેરનેમ નું જૂનું વર્સન વાપરી રહ્યા છો જે હવે અસમર્થિત છે.",
    instavc_browser_msg:
      "Instavc.com ને અપડેટ કરેલા બ્રોવસેરનેમ અથવા અન્ય કોઈપણ આધુનિક બ્રાઉઝર્સનાં જરૂર છે.",
    instavc_browser_upgrade:
      "વધુ સારા અનુભવ માટે કૃપા કરીને આ બ્રાઉઝર્સના કોઈપણ નવીનતમ સંસ્કરણ પર અપગ્રેડ કરો.",
    instavc_googlechrome: "ગૂગલ ક્રોમ",
    instavc_gc_version74: "વર્સ ન 74",
    instavc_mfirefox: "મોઝીલા ફાયરફોક્સ",
    instavc_mff_version: "વર્સ ન 66",
    instavc_opera: "ઓપેરા",
    instavc_opera_version: "વર્સ ન 60.0+",
    instavc_microsoftedge: "માઇક્રોસ .ફ્ટ એજ",
    instavc_ms_version: "વર્સ ન 44+",
    instavc_safari: "ઍપલ સફારી",
    instavc_safari_version: "વર્સ ન 12.1",
    instavc_contact_msg:
      "પહેલેથી અપગ્રેડ કર્યું છે, પરંતુ હજી પણ સમસ્યા છે? અમારો સંપર્ક કરો",
    instavc_camera_busy: "કેમેરા વ્યસ્ત લાગે છે!",
    instavc_close_camera:
      "કૃપા કરીને બધી એપ્લિકેશન બંધ કરો અને ફરીથી પ્રયાસ કરો.",
    instavc_resolution: "રીસોલ્યૂશન સપોર્ટેડ નથી!",
    instavc_camera_notsupport: "તમારો કેમેરો આ રીસોલ્યૂશન સપોર્ટેડ નથી.",
    instavc_camera_reconfig:
      "લો રીઝોલ્યુશન સાથે તમારી સેટિંગ્સને ફરીથી ગોઠવો અને ફરીથી પ્રયાસ કરો.",
    instavc_change_resolution: " રીઝોલ્યુશન બદલો",
    instavc_confirmation: "પુષ્ટિ",
    instavc_yes: "હા",
    instavc_delete_room: "શું તમે ખરેખર રૂમ કાઢી નાખવા માંગો છો?",
    instavc_delete_license: "શું તમે ખરેખર લાઇસેંસ કાઢી નાખવા માંગો છો??",
    instavc_help: "અમે તમને મદદ કરવા માટે છીએ",
    instavc_browse_questions:
      "સૌથી વધુ વારંવાર પૂછાતા પ્રશ્નો દ્વારા બ્રાઉઝ કરો.",
    instavc_os: "ઑપરેટિંગ સિસ્ટમ",
    instavc_macos: "મેક ઑ ઍ સ  X વર્સ ન:",
    instavc_chrome_version: "ક્રોમ વર્સ ન:",
    instavc_private_browsing: "ખાનગી બ્રાઉઝિંગ?",
    instavc_faq_no: "ના",
    instavc_display_resolution: "ઈન્સ્ટા વી સી_ડિસપ્લે_રેજ઼લ્યૂશન",
    instavc_aspect_ratio: "ડિસપ્લે આસ્પેક્ટ રેશિયો",
    instavc_sys_hasspeakers: "સિસ્ટમમાં સ્પીકર્સ છે?",
    instavc_found_speakers: "સ્પીકર ડિવાઇસ મળ્યાં : 2",
    instavc_speakers1: "સ્પીકર 1",
    instavc_speakers2: "સ્પીકર 2",
    instavc_sys_have_microphone: "સિસ્ટમમાં માઇક્રોફોન છે?",
    instavc_found_microphone: "માઇક્રોફોન ડિવાઇસ મળ્યાં : 2",
    instavc_microphone1: "માઇક્રોફોન 1",
    instavc_microphone2: "માઇક્રોફોન 2",
    instavc_has_webcam: "સિસ્ટમમાં વેબકેમ છે?",
    instavc_found_speakers1: "સ્પીકર ડિવાઇસ મળ્યાં : 1",
    instavc_camera1: "કેમેરો 1",
    instavc_webcam_permission: "વેબસાઇટ પર વેબકેમ પરવાનગી છે?",
    instavc_microphone_permission: "વેબસાઇટમાં માઇક્રોફોન પરવાનગી છે?",
    instavc_browser_allows:
      "બ્રાઉઝર આ પૃષ્ઠ પર ગેટ યૂજ઼ર મિડીઆ ને મંજૂરી આપે છે?",
    instavc_change_output_device: "શું તમે આઉટપુટ ઑડિઓ ડિવાઇસને બદલી શકો છો??",
    instavc_change_camera_resolutions:
      "નવી ગેટ યૂજ઼ર મિડીઆ વિનંતી કર્યા વિના તમે કેમેરાનાં રેજ઼લ્યૂશન બદલી શકો છો?",
    instavc_browser_support_webrtc:
      "બ્રાઉઝર વેબઆરટીસીને સપોર્ટ કરે છે( 1.0  અથવા 1.1)?",
    instavc_browser_support_ortc:
      "બ્રાઉઝર ઓઆરટીસીને સપોર્ટ કરે છે (વેબઆરટીસી 1.1)?",
    instavc_initial_setup:
      "કૃપા કરીને તમારા પ્રારંભિક સેટઅપ પર પ્રક્રિયા કરવામાં આવે ત્યાં સુધી રાહ જુઓ!",
    instavc_close_browser:
      "આ સમયે તમારા બ્રાઉઝરને બંધ ન કરો અથવા બૅક બટનનો ઉપયોગ કરશો નહીં.",
    instavc_whoops: "અરેરે!",
    instavc_nonet_msg:
      "કોઈ ઇન્ટરનેટ કનેક્શન મળ્યું નથી. કૃપા કરીને તમારું કનેક્શન તપાસો અથવા ફરીથી પ્રયાસ કરો.",
    instavc_nosearch: "કોઈ શોધ પરિણામ મળ્યા નથી",
    instavc_noserchmsg:
      "અમે તમારી શોધ સાથે મેળ ખાતી કોઈપણ વસ્તુ શોધી શક્યા નથી.",
    instavc_nosearch_filter:
      "તમે જે શોધી રહ્યા છો તે શોધવા માટે તમારી શોધ અથવા ફિલ્ટરને અડ્જસ્ટ કરવાનો પ્રયાસ કરો.",
    instavc_gotohoem_page: "હોમ પેજ પર જાઓ",
    instavc_pageloading: "પેજ લોડ થઈ રહ્યું છે ... કૃપા કરી પ્રતીક્ષા કરો!",
    instavc_process: "પ્રોસેસિંગ...",
    instavc_session_timeout: "સેશન ટાઈમ આઉટ",
    instavc_session_inactivity:
      "નિષ્ક્રિયતાને કારણે તમારું સેશન ટાઈમ આઉટ થઈ રહ્યું છે.",
    instavc_session_msg: "કૃપા કરીને સાઇન ઇન રહેવાનું પસંદ કરો.",
    instavc_session_reconnect: "ફરીથી કનેક્ટ કરો",
    instavc_site_notreached: "આ સાઇટ પર પહોંચી શકાતું નથી!",
    instavc_site_webaddress: "ખાતરી કરો કે તમને સાચો વેબ સરનામું મળી ગયું છે",
    instavc_check_internet: "તમારું નેટવર્ક તપાસો",
    instavc_search_url: "અન્ય બ્રાઉઝરમાં યુઆરએલને શોધો",
    instavc_goto: "પર જાઓ",
    instavc_request_for_access: "પ્રવેશ માટે વિનંતી",
    instavc_start_collabrate: "વ્હાઇટબોર્ડ માં સહયોગ શરૂ કરવા માટે",
    instavc_large_conference_mode:
      'આ  "લાર્જ કોન્ફરન્સ" મોડ છે, હોસ્ટ તમને પરવાનગી ન આપે ત્યાં સુધી તમે અન્યને વાત કરી અથવા જોઈ શકતા નથી',
    instavc_allow_participants:
      'આ  "લાર્જ કોન્ફરન્સ" મોડ છે, તમારે સહભાગીઓને જાતે બોલવાની મંજૂરી આપવી પડશે',
    instavc_buy_premium: "આ સુવિધાઓને અનલોક કરવા માટે પ્રીમિયમ ખરીદો",
    instavc_alert_tryagain: "કંઈક ખોટું થયું, કૃપા કરી ફરીથી પ્રયત્ન કરો",
    instavc_enter_name: "તમારું નામ દાખલ કરો",
    instavc_confirm: "પુષ્ટિ કરો",
    instavc_ok: "બરાબર",
    instavc_askquestion: "સવાલ પૂછો...",
    instavc_recieve: "સ્વીકારવું",
    instavc_delay: "વિલંબ (એમ.એસ.)",
    instavc_audio_opus: "ઑડિયો/ઓપસ",
    instavc_video_vp8: "વીડિયો/વી.પી.8",
    instavc_browser_not_support_incall:
      "કોલ દરમિયાન તમારું બ્રાઉઝર રીઝોલ્યુશન ફેરફારને સમર્થન આપતું નથી!",
    instavc_failed_toPublish: "વિડિઓ પ્રકાશિત કરવામાં નિષ્ફળ",
    instavc_publish_fail: "પ્રકાશિત કરવામાં નિષ્ફળ",
    instavc_video_cant_publish:
      "યૂજ઼ર્સની મર્યાદા પહોંચને કારણે વિડિઓ પ્રકાશિત કરી શકાતી નથી",
    instavc_failed_joinConference: "કોન્ફરન્સમાં જોડાવામાં નિષ્ફળ",
    instavc_mute_audio:
      "જો રિમોટ ઑડિઓ મ્યૂટ કરવામાં આવે તો તમે મ્યૂટ / અનમ્યૂટ કરી શકતા નથી",
    instavc_remote_audio_muted: "રિમોટ ઑડિઓ મ્યૂટ કર્યું!",
    instavc_enter_conferenceid: "તમારી કોન્ફરન્સ આઈડી દાખલ કરો",
    instavc_share_screen: "શેર સ્ક્રીન",
    instavc_sharing_your_screen: "તમારી સ્ક્રીન શેર કરી રહ્યાં છે...",
    instavc_stop: "બંધ",
    instavc_back: "બૅક",
    instavc_choose_plan: "નીચેની લીસ્ટમાંથી તમારી પ્લાન પસંદ કરો",
    instavc_have_promotionalcode: "પ્રમોશનલ કોડ / ભાગીદાર કોડ છે ?",
    instavc_contact_pricing: "પ્રાઇસીંગ માટે અમારો સંપર્ક કરો",
    instavc_payment_failed: "પેમેંટ નિષ્ફળ",
    instavc_payment_error: "દુર્ભાગ્યે તમારી પેમેંટ સંભાળતી વખતે ભૂલ આવી.",
    instavc_contact_support:
      "જો કોઈ સહાયની જરૂર હોય તો કૃપા કરીને અમારી સપોર્ટ ટીમનો સંપર્ક કરો.",
    instavc_tryagain: "ફરીથી પ્રયત્ન કરો",
    instavc_payment_success: "પેમેંટ સફળ",
    instavc_thanks_for_payment: "પેમેંટ બદલ આભાર!",
    instavc_payment_processed:
      "તમારી પેમેંટ સફળતાપૂર્વક પ્રક્રિયા કરવામાં આવી છે. સ્વચાલિત પેમેંટની રસીદ",
    instavc_mail_sent:
      "ટૂંક સમયમાં તમારા રજીસ્ટર ઇમેઇલ સરનામાં પર મોકલવામાં આવશે",
    instavc_goto_homepage: "હોમ પેજ પર પાછા જાઓ",
    instavc_want_toend_call: "કોલ સમાપ્ત કરવા માંગો છો?",
    instavc_exit_window:
      "આ વિંડોને બંધ કરવાથી તમારા કોલમાંથી બહાર નીકળી જશે. શું તમે ખરેખર આ કોલ સમાપ્ત કરવા માંગો છો?",
    instavc_create_room: "રૂમ બનાવો",
    instavc_userlimit: "યૂજ઼ર લિમિટ",
    instavc_edit_room: "ઍડિટ રૂમ",
    instavc_update: "અપડેટ",
    instavc_manage_license: "લાઇસેંસિસ મેનેજ કરો",
    instavc_package: "પેકેજ",
    instavc_no_of_rooms: "રૂમસ",
    instavc_no_of_users: "યૂજ઼રસ",
    instavc_purchasedOn: "પર ખરીદી",
    instavc_expiredon: "પર સમાપ્ત થાય છે",
    instavc_or: "અથવા",
    instavc_otherhost_email:
      "જો તમે કોઈપણ યૂજ઼રને હોસ્ટ તરીકે બનાવવા માંગતા હો, તો તેનું / તેણીનું ઇમેઇલ સરનામું દાખલ કરો.",
    instavc_set_host_password: "હોસ્ટ પાસવર્ડ સેટ કરો",
    instavc_host_password: "હોસ્ટ પાસવર્ડ",
    instavc_access_room: "આ રૂમમાં બીજું કોણ ઍક્સેસ કરી શકે છે?",
    instavc_select_user_host:
      "તેને / તેણીને હોસ્ટ બનાવવા માટે કોઈપણ યૂજ઼રસને લીસ્ટમાંથી પસંદ કરો.",
    instavc_prologin: "ઇન્સ્ટાવીસી પ્રો લોગીન",
    instavc_start: "સ્ટાર્ટ",
    instavc_enter_website: "કૃપા કરીને વેબસાઇટનું નામ દાખલ કરો",
    instavc_enter_valid_email: "કૃપા કરીને માન્ય ઇમેઇલ દાખલ કરો",
    instavc_enter_valid_phone: "કૃપા કરી માન્ય ફોન નંબર દાખલ કરો",
    instavc_field_required: "આ ફીલ્ડ જરૂરી છે",
    instavc_invitedby: "ઇન્વાઇટેડ બાઇ",
    instavc_storage: "સ્ટોરેજ",

    affiliate_approve: "મંજુર",
    affiliate_pending: "બાકી",
    affiliate_rejected: "નામંજૂર",
    affiliate_user_status: "યૂજ઼રસ સ્થિતિ",
    commission_other: "અન્ય કમિશન",
    add_commission: "કમિશન ઉમેરો",
    delete_commission: "શું તમે કમિશન કાઢી નાખવા માંગો છો?",
    update_commission: "કમિશન અપડેટ કરો",
    name: "નામ",
    offer_value: "ઓફર મૂલ્ય",
    add: "ઉમેરો",
    update: "અપડેટ",
    affiliates: "અફિલીયેટ્સ",
    status: "સ્ટેટસ",
    status_change_message: "શું તમે સ્ટેટસ બદલવા માંગો છો??",
    approve: "મંજૂર",
    reject: "નામંજૂર કરવું",
    commissions: "કમિશન",
    withdraw_data: "ડેટા પરત લો",
    withdraw_amount: "અમાઉંટ પરત  લો",
    payment_method: "પેમેંટ મેથોડ",
    payment_fee: "પેમેંટ ફી",
    total_amount_withdraw: "કુલ રકમ પરત લો ",
    total_earnings: "કુલ કમાણી",
    pending_amount: "બાકી રકમ",
    paid_amount: "ચૂકવેલ રકમ",
    unpaid_amount: "અચૂકવેલ રકમ",
    requested_withdraw: "રકમ પાછા ખેંચવાની વિનંતી",
    english: "અંગ્રેજી",
    french: "ફ્રેન્ચ",
    portuguese: "પોર્ટુગીઝ",
    hindi: "હિન્દી",
    gujarati: "ગુજરાતી",
    kannada: "કન્નડ",
    marathi: "મરાઠી",
    tamil: "તામિલ",
    telugu: "તેલુગુ",
    urdu: "ઉર્દુ",
    spanish: "સ્પૅનિશ",
    malyalam: "મલયાલમ",
    italian: "ઇટાલિયન",
    bangla: "બંગલા",
    room: "રૂમ",
    create: "બનાવો",
    repeat: "ફરી કરવું",
    daily: "રોજનું",
    repeat_every: "સમગ્ર ફરી કરવું",
    repeat_on: "પર પુનરાવર્તન કરો",
    repeat_by: "દ્વારા પુનરાવર્તન કરો",
    ends: "સમાપ્ત થાય છે",
    after: "પછી",
    occurences: "બનાવ",
    on: "પર",
    summary: "સારાંશ",
    repeats: "પુનરાવર્તન",
    withdraws: "ઉપાડ",
    every: "દરેક",
    days: "દિવસ",
    weeks: "અઠવાડિયા",
    months: "મહિનો",
    onday: "દિવસે",
    years: "વર્ષો",
    times: "વખત",
    until: "સુધી",
    past_meeting_list: "પાછલા સત્રની સૂચિ",
    organised_by: "દ્વારા યોજાયેલ",
    delete: "કાઢી નાંખવું",
    join: "જોડાઓ",
    to: "તરફ",
    enter_password: "પાસવર્ડ દાખલ કરો",
    submit: "સબમિટ",
    enter_passwordmessage: "કૃપા કરીને પાસવર્ડ દાખલ કરો",
    delete_message: "શું તમે કાઢી નાખવા માંગો છો?",
    meeting_permanent: "સત્ર કાયમ માટે?",
    day: "દિવસ",
    password_message: "પાસવર્ડ ખોટો છે",
    timezone: "સમય ઝોન",
    by: "દ્વારા",
    weekdays: ["સન", " મોન", "ટ્યૂ", "વેડ", " થુ", "ફ્રાઇ", "સૅટ"],
    allweek: [
      "રવિવાર",
      "સોમવાર",
      "મંગળવાર",
      "બુધવાર",
      "ગુરુવાર",
      "શુક્રવાર",
      "શનિવાર",
    ],
    day_month: "મહિનાનો દિવસ",
    day_week: "અઠવાડિયાના દિવસ",
    week: "અઠવાડિયું",
    month: "મહિનો",
    year: "વર્ષ",
    enterpassword:
      "કૃપા કરી તમારો નવો પાસવર્ડ દાખલ કરો અને પાસવર્ડની પુષ્ટિ કરો",
    passwordmessage: "પાસવર્ડ અને પુષ્ટિ પાસવર્ડ બંને એક સમાન હોવા જોઈએ",
    passwordupdate:
      "પાસવર્ડ સફળતાપૂર્વક અપડેટ થયો, કૃપા કરીને તમારા નવા પાસવર્ડથી લinગિન કરો",
    numeric: ["પ્રથમ", "બીજું", "ત્રીજું", "ચોથું", "પાંચમો"],
    verify_email: "તમારું ઇમેઇલ ચકાસો",
    confirm_code: "પુષ્ટિ કોડ",
    verify_msg: "કૃપા કરી કોડ માટે તમારો મોબાઇલ તપાસો.",
    verify: "ચકાસો",
    not_recieved: "પ્રાપ્ત થયો નથી?",
    resend_otp: "ઑટિપી ફરીથી મોકલો",
    start_browsing: "બ્રાઉઝિંગ પ્રારંભ કરો",
    become_affiliate: "એફિલિએટ બનો",
    affiliate: "એફિલિએટ",
    verify_mobile: "તમારા મોબાઇલને ચકાસી લો",
    instavc_allow_DocumentAccess: "પર્મિટ ડૉક્યુમેંટ-શેર",
    instavc_allow_Notes: "પર્મિટ નોટ્સ",

    //common - CameraResolution
    camera_not_access: "નીચેના એક કારણને લીધે કેમેરો ઍક્સેસિબલ નથી:",
    camera_not_access_reason1:
      "રિઝોલ્યુશન સેટિંગ્સ આ ડિસ્પ્લે સાથે સુસંગત ન હોઈ શકે.તમારા સેટિંગ્સને નીચા રીઝોલ્યુશન સાથે ફરીથી ગોઠવો અને ફરીથી પ્રયાસ કરો.",
    camera_not_access_reason2:
      "તમારા  કેમેરાનો ઉપયોગ વિવિધ એપ્લિકેશન દ્વારા કરવામાં આવી રહ્યો છે, કૃપા કરીને બધી એપ્લિકેશનો બંધ કરો અને લિંક પર ક્લિક કરીને ફરીથી પ્રયાસ કરો. ",

    //Containers
    //content - components - assignQuestionnaire
    asgnQue_Assign_Question: "પ્રશ્નાવલી સોંપો",
    asgnQue_assigned_question: "સોંપેલ પ્રશ્નાવલી",
    //assignQuestList
    quslsit_assig_que_list: "સોંપેલ પ્રશ્નાવલી લીસ્ટ",
    quslsit_question_lists: "પ્રશ્નાવલિ લીસ્ટ",
    quslsit_add_new_question: "નવી પ્રશ્નાવલી ઉમેરો",
    quslsit_no_question_assign: "હજી સુધી કોઈ પ્રશ્નાવલી સોંપાઇ નથી!",
    quslsit_assign_new_ques:
      "ઉપરોક્ત પ્રશ્નાવલિ બટનને ક્લિક કરવા માટે એક નવી પ્રશ્નાવલી સોંપો",

    //model-assign-Questionnaire
    select_questionnaire: "પ્રશ્નાવલી પસંદ કરો",
    duration: "સમયગાળો",
    time_limit: "સમય મર્યાદા",
    show_results: "પરિણામો બતાવો",
    save: "સાચવો",
    //viewAssigned
    content_group: "સામગ્રી જૂથ",
    list_assigned_ques: "સોંપેલ પ્રશ્નોની સૂચિ:",
    mins: "મિનિટ",
    marks: "ગુણ",
    //AssignedQuestions
    asgQues_5_Marks: "( 5 ગુણ )",
    asgQues_answers: "જવાબો",
    asgQues_no_questions: "કોઈ પ્રશ્નો નથી!",

    //content - components - contentGrade
    //GradeSetting
    grdSet_GPA_calculation: "ટકાવારીમાંથી જીપીએ ગણતરી",
    grdSet_GPA_cal_msg:
      "ટકાવારી 100% માટે છે જે 100 પોઇન્ટ સિવાય કંઈ નથી. તેથી ટકાવારીમાં 25 પોઇન્ટ્સ જીપીએ સિસ્ટમના 1 પોઇન્ટની સમકક્ષ છે. જી.પી.એ. સૂત્રની ટકાવારી ફક્ત તમારી ટકાવારીને 100 વડે વહેંચે છે અને 4 દ્વારા ગુણાકાર કરે છે. જો તમારી ટકાવારી 75% હોય તો તમારું ગ્રેડ (75/100) * 4 = 3. હશે, ",

    grdSet_grade_point: "જો ગ્રેડ પોઇન્ટ છે",
    //managegrade
    mngGrd_grades: "ગ્રેડ ",
    mngGrd_modify: "સુધારો",
    mngGrd_save_grades: "ગ્રેડ સાચવો",
    mngGrd_modify_grades: "ગ્રેડ સુધારો",
    mngGrd_grade_info: "ગ્રેડ માહિતી",
    //content - components - ContentParticipants
    //components-admnAnsView
    admnAns_answer_list_for_question:
      "નીચે આ સામગ્રી જૂથના બધા પ્રશ્નાવલિ માટે જવાબોની સૂચિ છે.",
    //components-participants
    prtcpt_certification: "પ્રમાણપત્રો:",
    prtcpt_other_content_group: "અન્ય સામગ્રી જૂથોમાં",
    prtcpt_sales: "વેચાણ",
    prtcpt_marketing: "માર્કેટિંગ",
    prtcpt_human_resource: "હ્યૂમન રીસોર્સ",
    //manageparticipants
    mngPrtcpt_add_participants: "પાર્ટિસિપેંટ્સ ઉમેરો",
    mngPrtcpt_participants_list: "પાર્ટિસિપેંટ્સ લિસ્ટ્સ",
    mngPrtcpt_import_participants: " પાર્ટિસિપેંટ્સ આયાત કરો",
    mngPrtcpt_download_sample: "સૅંપલ ડાઉનલોડ કરો",
    mngPrtcpt_no_participants_added:
      "હજી સુધી કોઈ પાર્ટિસિપેંટ્સ ઉમેરવામાં આવ્યા નથી!",
    mngPrtcpt_add_new_participant:
      "એક નવો પાર્ટિસિપેંટ્સ ઉમેરવા માટે ઉપરોક્ત પાર્ટિસિપેંટ્સ બટનને ક્લિક કરો",
    //modal-add-participants
    addPrtcpt_select_participants: "પાર્ટિસિપેંટ્સ પસંદ કરો",
    addPrtcpt_model_add_participants: "પાર્ટિસિપેંટ્સ ઉમેરો",
    //partipantGradeView
    prtcptGrde_participant_grade: "પાર્ટિસિપેંટ્સ ગ્રેડ વિગતો",
    prtcptGrde_grade_participants_list: "પાર્ટિસિપેંટ્સ લીસ્ટ",
    //content - components - ContentQuestionnaire
    //managequestionnaire
    mngQuesnr_create_questionnaire: "પ્રશ્નાવલિ બનાવો",
    questionnaire_list: "પ્રશ્નાવલિ  લીસ્ટ",
    //managequestions
    mngQues_question_details: "પ્રશ્નાવલિ વિગતો",
    mngQues_no_question_created: "હજી સુધી કોઈ પ્રશ્ન બનાવવામાં આવ્યો નથી!",
    mngQues_create_new_question:
      "એક નવો પ્રશ્ન બનાવો, બનાવવા માટે ઉપરના પ્રશ્ન બનાવો બટનને ક્લિક કરો",
    //modal-create-quest-group
    mdlGrp_questionnaire_name: "પ્રશ્નાવલિ નામ",
    mdlGrp_update: "અપડેટ",
    mdlGrp_create: "બનાવો",
    //modal-create-questions
    mdlCrtQues_question_type: "પ્રશ્નનો પ્રકાર",
    mdlCrtQues_sel_question_type: "પ્રશ્ન પ્રકાર પસંદ કરો",
    mdlCrtQues_single_sel_multiple_choice: "સિંગલ સિલેક્ટ મલ્ટીપલ ચોઇસ",
    mdlCrtQues_multiselect_multiple_choice: "મલ્ટિસિલેક્ટ મલ્ટીપલ ચોઇસ",
    mdlCrtQues_ture_false: "સાચું / ખોટું",
    mdlCrtQues_enter_answer_choice:
      "જવાબ પસંદગીઓ દાખલ કરો, અને કયો જવાબ સાચો છે તે ચિહ્નિત કરો",
    mdlCrtQues_add_another_choice: "+ બીજી ચોઇસ ઉમેરો",
    //viewQuestionnaire
    viewQues_add_questions: "પ્રશ્નો ઉમેરો",
    viewQues_no_question_created: "હજી સુધી કોઈ પ્રશ્ન બનાવવામાં આવ્યો નથી!",
    viewQues_create_new_question:
      "એક નવો પ્રશ્ન બનાવો, બનાવવા માટે ઉપરના પ્રશ્ન બનાવો બટનને ક્લિક કરો",

    //content - components - createContent
    //createcontent
    crteContent_create_new_content: "નવી કૉન્ટેંટ બનાવો",
    crteContent_update_content: "કૉન્ટેંટ સુધારો",
    crteContent_save_content: "કૉન્ટેંટ સાચવો",
    crteContent_content_list: "કૉન્ટેંટ લિસ્ટ્સ",
    edit_content: "ઍડિટ કૉન્ટેંટ",
    crteContent_create_content: " કૉન્ટેંટ બનાવો",
    crteContent_create_your_content_like:
      "ઇમેજ, વિડિઓ ફાઇલો, ઑડિઓ ફાઇલો અને દસ્તાવેજો જેવા મીડિયા ઉમેરીને તમારી કૉન્ટેંટ બનાવો.",
    crteContent_upload_document: "દસ્તાવેજો અપલોડ કરો",
    crteContent_upload_media: "મીડિયા અપલોડ કરો",
    crteContent_document: "દસ્તાવેજો",
    crteContent_media_files: "મીડિયા  ફાઇલો",
    //view-content
    viewCon_content_view: "કૉન્ટેંટ વ્યૂ",
    viewCon_content_list: "કૉન્ટેંટ લિસ્ટ્સ",
    viewCon_View_content: "વ્યૂ કૉન્ટેંટ",
    viewCon_enable: "સક્ષમ કરો: ",
    viewCon_document: "દસ્તાવેજો",
    viewCon_media_files: "મીડિયા  ફાઇલો",

    //content - components - contentRow
    conRow_by: "By: ",

    //content - components - managecontent
    create_new_content: "નવી કૉન્ટેંટ બનાવો",
    mngCon_all: "તમામ",
    mngCon_content_list: "કૉન્ટેંટ લિસ્ટ્સ",
    mngCon_no_content_created: "હજી સુધી કોઈ કન્ટેન્ટ બનાવવામાં આવી નથી!",
    mngCon_create_new_content:
      "એક નવી કન્ટેન્ટ બનાવો, બનાવવા માટે ઉપરના બનાવો કન્ટેન્ટ બટનને ક્લિક કરો",
    //content - components - model-access-right
    mdlAccRight_share_access: "અન્ય  ઇનસ્ટરકટર્સ સાથે ઍક્સેસ શેર કરો",
    mdlAccRight_type_id_add: "ઇમેઇલ આઈડી લખો અને ઉમેરો",
    mdlAccRight_no_instructor_added:
      "હજી સુધી કોઈ ઇનસ્ટરકટર્સ  ઉમેરવામાં આવ્યા નથી!.",
    mdlAccRight_add_people_from_addressbok:
      "લોકોને તમારી એડ્રેસ બુકમાંથી અથવા ઇમેઇલ સરનામું લખીને ઉમેરો.",
    mdlAccRight_contacts: "સંપર્કો",
    mdlAccRight_add_contacts:
      "તમારા અડ્રેસ બુક સંપર્કોમાંથી, સામગ્રી જૂથમાં સંપર્કો ઉમેરો",
    mdlAccRight_no_contacts_added: "હજી કોઈ સંપર્કો ઉમેર્યા નથી!.",
    //content - components - model-confirm-delete
    mdlConfDel_confirmation: "પુષ્ટિ",
    mdlConfDel_are_you_sure_delete: "શું તમે ખરેખર આને કાઢી નાખવા માંગો છો",
    mdlConfDel_delete: "કાઢી નાખવા",
    //content - components - model-create-content-group
    mdlCrtConGrp_alert_enter_group_title: "કૃપા કરીને ગ્રૂપ ટાઇટલ દાખલ કરો",
    mdlCrtConGrp_alert_enter_group_description:
      "કૃપા કરીને ગ્રૂપ ડિસ્ક્રિપ્ષન દાખલ કરો",
    mdlCrtConGrp_group_name: "ગ્રૂપ નેમ",
    //content - components - model-upload-doc
    mdlUpldoc_alert_enter_title_doc: "કૃપા કરીને દસ્તાવેજનું શીર્ષક દાખલ કરો",
    mdlUpldoc_upload_document: "દસ્તાવેજો અપલોડ કરો",
    mdlUpldoc_document_title: "દસ્તાવેજ શીર્ષક",
    mdlUpldoc_upload_doc_from_system:
      "તમારી સિસ્ટમમાંથી દસ્તાવેજ અપલોડ કરો, તે પીડીએફ, એક્સેલ, વર્ડને સપોર્ટ કરે છે.",
    mdlUpldoc_upload_doc: "દસ્તાવેજો અપલોડ કરો",
    mdlUpldoc_added_doc: "દસ્તાવેજો ઉમેર્યા",
    //content - components - model-upload-media
    mdlUplMedia_alert_enter_title_media: "કૃપા કરી મીડિયાનું શીર્ષક દાખલ કરો",
    mdlUplMedia_alert_enter_title_url: "કૃપા કરી શીર્ષક અને યુઆરએલ દાખલ કરો",
    mdlUplMedia_alert_enter_youtube_vimeo_url:
      "કૃપા કરી માન્ય અને URL દાખલ કરો (યુટ્યુબ / વિમેઓ)",
    mdlUplMedia_upload_media: "મીડિયા અપલોડ કરો",
    mdlUplMedia_upload_url: " યુઆરએલ અપલોડ કરો",
    mdlUplMedia_Upload_media_system:
      "તમારી સિસ્ટમમાંથી ઉચ્ચ રીઝોલ્યુશન ફાઇલો અપલોડ કરો, તે .jpg, .png, .jpeg, .mp3, .mp4 ને સપોર્ટ કરે છે",
    mdlUplMedia_add_media_url:
      "મીડિયાને જોડવા માટે મીડિયા યુઆર એલ સરનામાં ઉમેરો ",
    mdlUplMedia_upload_media_url: "મીડિયા યુઆરએલ અપલોડ કરો",
    mdlUplMedia_upload_youtube_url: "નોંધ: યુટ્યુબ યુઆરએલ ને અપલોડ કરો",
    mdlUplMedia_Add_media_file: "મીડિયા ફાઇલો ઉમેરી",

    //content - managecontent - index
    // "mngContent_content" : "કન્ટેન્ટ",
    mngContent_participants: "સહભાગીઓ",
    mngContent_grade_settings: "ગ્રેડ સેટિંગ્સ",

    //content - index
    content_all_content_group: "બધા કન્ટેન્ટ ગ્રૂપ",
    create_new_group: " ગ્રૂપ બનાવો",
    content_no_group_created: "હજી સુધી કોઈ ગ્રૂપ બનાવવામાં આવ્યા નથી!",
    content_create_new_group:
      "એક નવું ગ્રૂપ બનાવો, બનાવવા માટે ઉપરના ગ્રૂપ બનાવો બટનને ક્લિક કરો",

    //ContentShare - contentList
    conList_all_group: "બધાગ્રૂપ",
    conList_content_list: "કન્ટેન્ટ લિસ્ટ્સ",
    conList_no_content_created: "હજી સુધી કોઈ કૉન્ટેંટ બનાવવામાં આવી નથી!",
    //contentShare - grouplist
    grpList_all_content_group: "બધા કન્ટેન્ટ ગ્રૂપ",
    grpList_no_group_created: "હજી સુધી કોઈ ગ્રૂપ બનાવવામાં આવ્યા નથી!",

    //ContentShare - questionStepper
    queStepper_cant_skip: "તમે એક પગલું છોડી શકતા નો વૈકલ્પિક નથી.",
    queStepper_back: "બૅક",
    queStepper_next: "નેક્સ્ટ",
    queStepper_skip: "સ્કિપ",
    queStepper_finish: "ફિનિશ",
    queStepper_submit_next: "સબ્મિટ & નેક્સ્ટ",
    //contentshare - showContent
    conList_content_list: "કૉંટેંટ લીસ્ટ",
    showCont_document: "દસ્તાવેજો",
    showCont_previous: "પહેલાનું",
    showCont_next: "નેક્સ્ટ",
    showCont_have_completed_topic: "મેં આ કન્ટેન્ટમાં વિષયો પૂર્ણ કર્યા છે",
    //contentShare - showMedia
    showMedia_page: "પેજ",
    showMedia_of: "ઓફ",
    showMedia_previous: "પૂર્વ",

    //contentShare - showquestions
    showQues_min_left: "મિન લેફ્ટ",
    showQues_completed_test: "તમે આ પ્રશ્નાવલીમાં પરીક્ષણ પૂર્ણ કર્યું છે.",
    showQues_go_back_content_group: "કૉંટેંટ ગ્રૂપ પર પાછા જાઓ",
    //contentShare - viewUserScore
    viewUserScore_view_score: "વ્યૂ સ્કોર",
    viewUserScore_total_marks: "કુલ ગુણ:",
    viewUserScore_scored_marks: "સ્કોર્ડ ગુણ:",
    viewUserScore_GPA_score: "તમારું જી.પી.એ. સ્કોર:",
    viewUserScore_below_list_of_answer:
      "નીચે આ સામગ્રી જૂથના બધા પ્રશ્નાવલિ માટે જવાબોની સૂચિ છે.",
    viewUserScore_answered: "જવાબ આપ્યો",
    viewUserScore_correct_answer: "સાચો જવાબ",

    //schedule - components
    //ConfirmCancelInvite
    confCancle_confirmation: "પુષ્ટિ",
    confCancle_are_you_sure: "શું તમને ખાતરી છે??",
    confCancle_delete_user: "યૂજ઼ર કાઢી નાખો",
    //confirmscheduledelete
    confSche_are_you_sure_delete:
      "શું તમે ખરેખર આ શેડ્યૂલને કાઢી નાખવા માંગો છો?",
    confSche_no: "નો",
    //PastMeetingitem
    // "pastMtnItem_rn" : "આર.એન.",
    // "pastMtnItem_room_name" : "રૂમ નેમ: ",
    // "pastMtnItem_webinar_list" : "વેબિનાર લીસ્ટ",
    // "pastMtnItem_list_webinar" : "નીચે વેબિનાર્સની  લીસ્ટછે.",
    // "pastMtnItem_today" : "આજે",
    // "pastMtnItem_webinar_title_falls" : "વેબિનાર શીર્ષક અહીં પડે છે",
    // "pastMtnItem_view" : "જુઓ",
    // "pastMtnItem_upcoming" : "આગામી",

    //SchedulesView
    //"scheView_edit_content" : "ઍડિટ કૉંટેંટ",
    scheView_scheduled_by: "દ્વારા સુનિશ્ચિત થયેલ: ",
    scheView_delete: "કાઢી નાંખવું",
    scheView_download_calander: "કેલેન્ડર ડાઉનલોડ કરો",
    scheView_invite_participants: "સહભાગીઓને આમંત્રણ આપો",
    scheView_start_conference: "કોન્ફરન્સ શરૂ કરો",
    scheView_event_details: "ઇવેંટ ડીટેલ્સ",
    scheView_room_name: "રૂમ નેમ",
    scheView_minutes: "મિનિટ્સ",
    scheView_conference_password: "કોન્ફરન્સ પાસવર્ડ",
    scheView_settings: "સેટિંગ્સ",
    scheView_webinar_event: "વેબિનર ઇવેન્ટ",
    scheView_list_webinar:
      "આ વેબિનાર ઇવેન્ટને ઇન્સ્ટાવીસી.કોમ/વેબિનર માં સૂચિબદ્ધ કરો અને નોંધણીઓ સ્વીકારો.",
    scheView_guest_login_anonymous: "ગેસ્ટ અનામિક તરીકે લૉગ ઇન કરી શકે છે",
    scheView_allow_invities: "ફક્ત આમંત્રણોને કન્ફરન્સમાં જોડાવાની મંજૂરી આપો",
    scheView_enable_webinar_chat: "વેબિનાર ચેટને સક્ષમ કરો",
    scheView_enable_hand_rise: "વેબિનાર હૅંડ રેઈસને સક્ષમ કરો",
    scheView_list_of_people_invited: "નીચે આમંત્રિત લોકોની લીસ્ટ છે",
    scheView_alert_err_to_join: "ઍરર ટૂ જ઼ોઇન",
    //WebinarDetails
    webnrDtls_upcoming_webinar_room: "નીચે આ રૂમ માટે આગામી વેબિનાર છે.",
    // Webinar 1
    // Webinar 2
    // Webinar 3
    webnrDtls_webinar_details: "વેબિનાર વિગતો",
    webnrDtls_webinar_list: "વેબિનાર લીસ્ટ",
    webnrDtls_webinar_title: "વેબિનાર ટાઇટલ",
    webnrDtls_webinar_title_falls: "વેબિનાર ટાઇટલ અહીં છે",
    webnrDtls_get_more_joining: "આ વેબિનારમાં જોડાવાથી વધુ મેળવો.",
    webnrDtls_join_webinar: "વેબિનારમાં જોડાઓ",
    //webinarList
    webnrList_webinar_list: "વેબિનાર લીસ્ટ",
    webnrList_below_list_of_webinar: "નીચે વેબિનાર્સની લીસ્ટ છે.",
    webnrList_today: "આજે",
    webnrList_webinar_title_falls: "વેબિનાર ટાઇટલ અહીં પડે છે",
    webnrList_view: "જુઓ",
    webnrList_upcoming: "આગામી",

    //schedule -
    //AddressBook
    addBook_address_book: "અડ્રેસ બુક",
    addBook_contact: "સંપર્કો",
    addBook_add_contact_to_meeting:
      "તમારી સરનામાં પુસ્તિકાના સંપર્કોમાંથી સત્રમાં સંપર્કો ઉમેરો",
    //MeetingList
    meetingList_past_meetings: "પાછલા સત્રો",
    meetingList_past_meetings_list: "ભૂતકાળના સત્રોની સૂચિ",
    meetingList_room_name: "રૂમ નેમ: ",
    meetingList_view_content: "કૉંટેંટ જુઓ",
    meetingList_recording: "રેકોર્ડિંગ્સ",
    meetingList_view: "જુઓ",
    //scheduleInvite
    scheInvt_err_invalid_id: "અમાન્ય ઇમેઇલ આઈડી",
    scheInvt_invite_participants: "સહભાગીઓને આમંત્રણ આપો",
    scheInvt_address_book: "અડ્રેસ બુક",
    scheInvt_invite_people_to_meeting:
      "લોકોને આ સત્રમાં આમંત્રિત કરો. તમારી એડ્રેસ બુકમાંથી અથવા ઈમેલ એડ્રેસ ટાઈપ કરીને લોકોને ઉમેરો.",
    scheInvt_start: "શરૂ થાય છે @ ",
    scheInvt_below_list_of_answer:
      "નીચે આ કૉંટેંટ ના બધા પ્રશ્નાવલિ માટે જવાબોની  લીસ્ટ છે.",
    scheInvt_host: "હોસ્ટ:",
    scheInvt_minutes: "મિનિટ્સ",
    //Webinar 1
    scheInvt_add: "ઉમેરો",
    scheInvt_no_participants_added: "કોઈ સહભાગીઓ ઉમેર્યા નથી",
    scheInvt_add_ppl_to_meetings:
      "તમારી એડ્રેસ બુકમાંથી લોકોને આ સત્રમાં સહભાગીઓ તરીકે ઉમેરો અથવા તેમને શોધ દ્વારા ઉમેરો.",
    scheInvt_send_invitation: "આમંત્રણ મોકલો",
    scheInvt_send_passcodes: "પાસકોડ્સને અલગ મેલમાં મોકલો.",

    //Invitation - component - invitationbody
    invitBody_invite_only_upto: "તમે ફક્ત 10 લોકોને આમંત્રિત કરી શકો છો",
    invitBody_invite_ppl_meeting_email_add:
      " લોકોને આ સત્રમાં આમંત્રિત કરો, તમારી એડ્રેસ બુકમાંથી લોકોને ઉમેરો અથવા ઈમેલ એડ્રેસ દ્વારા ઉમેરો.",
    invitBody_copy: "કૉપી",
    invitBody_enter_emailid: "ઇમેઇલ આઈડી દાખલ કરો",
    invitBody_close: "બંધ",
    invitBody_send_invitation: "આમંત્રણ મોકલો",

    //documentShare
    //index,js
    docShare_doc_sharing: "દસ્તાવેજ શેરિંગ",
    docShare_upload_doc_system_pdf:
      "તમારી સિસ્ટમમાંથી દસ્તાવેજ અપલોડ કરો, તે પીડીએફ, એક્સેલ, વર્ડ ડૉક્યુમેંટને સપોર્ટ કરે છે.",
    docShare_upload_doc: "ડૉક્યુમેંટ અપલોડ કરો",
    docShare_no_doc: "નો ડૉક્યુમેંટ",
    docShare_no_doc_in_list: "લીસ્ટમાં હજી સુધી કોઈ ડૉક્યુમેંટ ઉમેર્યા નથી.",
    docShare_add_doc: "ડૉક્યુમેંટ  ઉમેર્યા",
    docShare_alert_title_doc: "કૃપા કરીને ડૉક્યુમેંટનું શીર્ષક દાખલ કરો",
    docShare_alert_something_went_wrong:
      "કંઈક ખોટું થયું છે કૃપા કરીને ફરીથી પ્રયાસ કરો",
    //components - PermitDocShare
    permitDocShr_permit_doc_share_access: "પરવાનગી દસ્તાવેજ શેર ઍક્સેસ",
    permitDocShr_req_permission_doc_share:
      "ડૉક્યુમેંટ શેરને ઍક્સેસ કરવાની પરવાનગીની વિનંતી કરી છે.",
    permitDocShr_deny: "નામંજૂર કરો",
    permitDocShr_allow: "મંજૂરી આપો",
    //components - RequestDocShare
    reqDocShr_req_doc_share_access: "વિનંતી ડૉક્યુમેંટ શેર ઍક્સેસ",
    reqDocShr_access_permission_host:
      "ડૉક્યુમેંટ શેરને સક્ષમ કરવા માટે, તમારે હોસ્ટની પરવાનગીની જરૂર છે.",
    reqDocShr_plz_wait: "કૃપા કરીને રાહ જુઓ",
    reqDocShr_permission_start_doc_share:
      "(હોસ્ટ) ડૉક્યુમેંટ વહેંચણી શરૂ કરવાની મંજૂરી.",
    reqDocShr_doc_share: "ડૉક્યુમેંટ શેર!",
    //components - ShowDocument View
    showDocViewback: "બૅક",
    showDocViewdoc_title_name: "ડૉક્યુમેંટ ટાઇટલ નેમ",
    showDocViewnext: "આગામી",
    showDocViewprevious: "પૂર્વ",

    //Broadcast -
    //boradcastScreenShare
    borcstScreen_alert_unsupported:
      "અસમર્થિત પ્લે ઓર્ડરની વિનંતી કરી. સપોર્ટેડ ફોર્મેટ્સ વેબઆરટીસી અને એચએલએસ છે. પ્લેઓર્ડર = વેબ આરટીસી, એચએલએસ જેવી કંઈક વાપરો",
    borcstScreen_alert_no_stream_spec:
      "કોઈ સ્ટ્રીમ ઉલ્લેખિત નથી. કૃપા કરીને યુઆરએલમાં? આઈડી = {સ્ટ્રીમ_આઈડી.} ઉમેરો",
    borcstScreen_Plz_enable_js:
      "આ વિડિઓ જોવા માટે, કૃપા કરીને જાવાસ્ક્રિપ્ટને સક્ષમ કરો, અને વેબ બ્રાઉઝરમાં અપગ્રેડ કરવાનું વિચારો",
    borcstScreen_support_HTML5: "એચટીએમએલ 5 વિડિઓને સપોર્ટ કરે છે",
    borcstScreen_steam_play_when_live:
      "જ્યારે વિડિઓ લાઇવ થાય ત્યારે સ્ટ્રીમ ચાલશે",
    //broadcast
    broadcast_alert_unsupported:
      "અસમર્થિત પ્લે ઓર્ડરની વિનંતી કરી. સપોર્ટેડ ફોર્મેટ્સ વેબઆરટીસી અને એચએલએસ છે. પ્લેઓર્ડર = વેબ આરટીસી, એચએલએસ જેવી કંઈક વાપરો",
    broadcast_alert_no_stream_spec:
      "કોઈ સ્ટ્રીમ ઉલ્લેખિત નથી. કૃપા કરીને યુઆરએલમાં? આઈડી = {સ્ટ્રીમ_આઈડી.} ઉમેરો",
    broadcast_enter_your_name: "કૃપા કરીને તમારું નામ દાખલ કરો",
    broadcast_enter_your_email: "કૃપા કરીને તમારું ઇમેઇલ દાખલ કરો",
    broadcast_user_details: "યૂજ઼ર ડીટેલ્સ",
    broadcast_submit_next: "સબમિટ કરો",
    broadcast_Plz_enable_js:
      "આ વિડિઓ જોવા માટે, કૃપા કરીને જાવાસ્ક્રિપ્ટને સક્ષમ કરો, અને વેબ બ્રાઉઝરમાં અપગ્રેડ કરવાનું વિચારો ",
    broadcast_support_HTML5: "એચટીએમએલ 5 વિડિઓને સપોર્ટ કરે છે",
    broadcast_steam_play_when_live:
      "જ્યારે વિડિઓ લાઇવ થાય ત્યારે સ્ટ્રીમ ચાલશે",
    //broadcastConference
    brdcstConf_whiteboard: "વ્હાઇટબોર્ડ",
    brdcstConf_screen_share: "સ્ક્રીન શેર",
    // "brdcstConf_participants" : "સહભાગીઓ",
    brdcstConf_broadcast: "બ્રોડકાસ્ટ",
    brdcstConf_right: "બરાબર",
    //broadcast - component
    //broadcasterParicipants
    brdcstPart_broadcast_list: "બ્રોડકાસ્ટર લીસ્ટ",

    //Containers - calender
    //index
    calender_scheduled_calendar: "શેડ્યૂલ કૅલંડર",
    calender_select_all: "બધા પસંદ કરો",
    calender_calender: " કૅલંડર",
    calender_daily: "રોજનું",
    calender_weekly: "સાપ્તાહિક",
    calender_month: "મહિનો",
    calender_today: "આજે",

    //Dashboard - componenet

    //MeetingReminder
    meetReminder_scheduled_confirm: "શેડ્યૂલ પુષ્ટિ",
    meetReminder_meeting_has_been_scheduled:
      "આ ક્ષણે નીચેનું સત્ર સુનિશ્ચિત કરવામાં આવ્યું છે",
    meetReminder_start_meeting: "આ સત્ર શરૂ કરો",
    meetReminder_join_meeting: "આ સત્રમાં જોડાઓ",
    meetReminder_quick_start_another_meeting: "બીજા સત્રની ઝડપી શરૂઆત કરો",
    //MyMeetingItem
    myMeetItem_start: " શરૂ કરો",
    myMeetItem_for: "માટે",
    myMeetItem_minutes: "મિનિટ",
    myMeetItem_host: "હોસ્ટ: ",
    //MyMeeting
    myMeet_my_meetings: "મારા સત્રો",
    myMeet_search_my_meetings: "મારા સત્રો શોધો",
    //NoScheduledMeeting
    noScheMeet_no_meeting_scheduled: "કોઈ સત્રો શેડ્યૂલ કરેલ નથી",
    noScheMeet_no_upcoming_meetings:
      "તમે હજુ સુધી કોઈ આગામી સત્રો શેડ્યૂલ કરેલ નથી. તમે નવું શેડ્યૂલ બનાવી શકો છો અથવા તમારી કોન્ફરન્સને હમણાં જ ઝડપથી શરૂ કરી શકો છો.",
    noScheMeet_create_schedule: "શેડ્યૂલ બનાવો",
    noScheMeet_quick_start: "ઝડપી શરૂઆત",
    noScheMeet_or: "અથવા",
    //RoomSettings
    roomSet_alert_select_license: "કૃપા કરીને લાઇસેંસ પસંદ કરો",
    roomSet_manage_licenses: "લાઇસેંસિસ મેનેજ કરો",
    roomSet_package: "પેકેજ",
    roomSet_no_of_rooms: "રૂમની સંખ્યા",
    roomSet_no_of_user: "વપરાશકર્તાઓની સંખ્યા",
    roomSet_purchased_on: "ખરીદી પર ",
    roomSet_expired_on: "પર સમાપ્ત થાય છે",
    roomSet_create_room: "રૂમ બનાવો",

    //conference - component
    //AddSipDevice
    addSipDev_add_sip_details: "એસઆઈપી વિગતો ઉમેરો",
    addSipDev_sip_address: "એસઆઈપી સરનામું:",
    addSipDev_connect: "જોડવું",
    addSipDev_enter_sip_address: "એસઆઈપી સરનામું દાખલ કરો",
    //ConfNotification
    confNotf_notification: "સૂચનાઓ",
    confNotf_user_name: "યૂજ઼ર નેમ",
    confNotf_want_to_join: "આ સત્ર ખંડમાં જોડાવા માંગે છે.",
    confNotf_allow: "મંજૂરી ",
    confNotf_deny: "નામંજૂર",
    confNotf_ask_question: "એક પ્રશ્ન પૂછ્યો.",
    confNotf_send_msg_lobby: "લોબી તરફથી એક સંદેશ મોકલ્યો.",
    //Loddy
    lobby_participants_loddy: "લોબીમાં ભાગ લેનારા",
    lobby_pramote_all: "બધાને પ્રમોટ કરો",
    lobby_user_name: "યૂજ઼ર નેમ",
    //RemoveUserDialog
    removeUserDlg_manage_user_selecting:
      "આમાંના કોઈપણ વિકલ્પોની પસંદગી કરીને આ યૂજ઼રને મેનેજ કરો:",
    removeUserDlg_user_name: "યૂજ઼ર નેમ",
    removeUserDlg_block_participant: "બ્લૉક પાર્ટિસિપેંટ",
    removeUserDlg_send_to_lobby: "લોબીમાં મોકલો",
    removeUserDlg_remote_participant: "પાર્ટિસિપેંટને દૂર કરો",
    removeUserDlg_close: "બંધ",
    //participantsList
    PartList_participants_in_lobby: "લોબીમાં પાર્ટિસિપેંટ",
    PartList_alert_something_went_wrong:
      "કંઈક ખોટું થયું, કૃપા કરી ફરીથી પ્રયત્ન કરો",
    PartList_in_webinar: "વેબિનારમાં",
    PartList_promote_all: "બધાને પ્રોત્સાહન આપો",
    //participants2020	Retry
    //WaitingRoom
    waitingRoom_waiting_room: "વેટિંગ રૂમ",
    waitingRoom_plz_wait_host_allow:
      "કૃપા કરીને ત્યાં સુધી રાહ જુઓ જ્યાં સુધી હોસ્ટ તમને કાન્ફરેન્સમાં જોડાવા દે નહીં.",
    waitingRoom_chat: "વાતચીત",
    waitingRoom_mins: "મિન્સ",
    waitingRoom_no_msg_yet: "હજી સુધી કોઈ સંદેશા નથી!",
    waitingRoom_no_msg_from_host: "હોસ્ટ તરફથી કોઈ સંદેશા નથી.",
    //userRemoved
    userRemoved_you_removed_by_host:
      "તમને હોસ્ટ દ્વારા પાર્ટિસિપેંટની લીસ્ટમાંથી દૂર કરવામાં આવ્યો છે",

    //invitationSlide
    invitSlide_invite: "આમંત્રિત",
    invitSlide_add_email: "ઇમેઇલ્સ ઉમેરો",
    invitSlide_add: "ઉમેરો",
    invitSlide_broadcast_list: "બ્રોડકાસ્ટ લિંક",
    invitSlide_invite_people_to_meeting:
      "લોકોને આ સત્રમાં આમંત્રિત કરો. લોકોને તેમનું ઇમેઇલ સરનામું લખીને ઉમેરો અને આમંત્રણ મોકલવા માટે સૂચિમાં ઉમેરો.",

    invitSlide_err_invalid_id: "અમાન્ય ઇમેઇલ આઈડી",
    //participantsChat
    particiChat_no_chat_msg: "હજી સુધી કોઈ ચેટ સંદેશા નથી!",
    particiChat_start_conversation:
      "સંદેશાઓ અહીં જોવા માટે વાતચીત પ્રારંભ કરો.",

    //components - lobbyparticipants
    lobbyPartici_no_participants: "નો પાર્ટિસિપેંટ્સ",
    lobbyPartici_no_participants_lobby: "લોબીમાં કોઈ પાર્ટિસિપેંટ્સ નથી.",

    //conference
    //simulcast
    simulcast_alert_decline_access: "હોસ્ટે ઍક્સેસ નકારી",
    simulcast_invalid_url: "અમાન્ય યુઆર.એલ.",
    simulcast_no_host_available:
      "આ ક્ષણે કોઈ હોસ્ટ ઉપલબ્ધ નથી લાગતું, કૃપા કરીને સ્ક્રીનને શેર કરવા માટે હોસ્ટ બનો",
    //simulcastVAD & // Conference.js
    conference_access_to_participants: "ઍક્સેસ ટૂ પાર્ટિસિપેંટ્સ",
    conference_screen_share: "સ્ક્રીન શેર",
    conference_chat: "વાતચીત",
    conference_lock_all: "બધાને લોક કરો",
    conference_lock_conf: "લૉક કાન્ફરેન્સ",
    conference_become_host: "હોસ્ટ બનો",
    conference_you_are_host: "તમે હોસ્ટ છો",
    conference_share: "શેર",
    conference_document_share: "ડૉક્યુમેંટ શેર",
    conference_content_share: "કૉંટેંટ શેર",
    conference_more: "વધુ...",
    conference_become_host: "હોસ્ટ બનો",
    conference_alert_no_host_aval_screen:
      "આ ક્ષણે કોઈ હોસ્ટ ઉપલબ્ધ નથી લાગતું, કૃપા કરીને સ્ક્રીનને શેર કરવા માટે હોસ્ટ બનો",
    conference_alert_no_host_aval_doc:
      "આ ક્ષણે કોઈ હોસ્ટ ઉપલબ્ધ નથી લાગતું, કૃપા કરીને ડૉક્યુમેંટ  શેર કરવા માટે હોસ્ટ બનો",
    conference_alert_err_sip_device: "એસઆઈપી ડિવાઇસને કનેક્ટ કરતી વખતે ભૂલ ",
    conference_alert_host_decline_access: "હોસ્ટે ઍક્સેસ નકારી",
    conference_alert_invalid_url: "અમાન્ય યુઆર.એલ",
    conference_unmute_mic_start_talk:
      "વાત શરૂ કરવા માટે તમારા માઇક્રોફોનને અવાજ દૂર કરો",

    // tools
    confTools_new_whiteboard: "તમારું નવું વ્હાઇટબોર્ડ અહીં આવે છે",
    confTools_video_sync: "તમારું વિડિઓ સિંક",
    confTools_microphone: "માઇક્રોફોન",
    confTools_type_text_here: "તમારા લખાણ લખો...",
    whiteboard: " વ્હાઇટબોર્ડ ",

    //meetingRecording
    meetRec_video_rec_meeting_name: "સત્રના નામની વિડિયો રેકોર્ડિંગ્સ",
    meetRec_page_view: "પેજ વ્યૂ:",
    //meetingRecording- recordinglistview
    recListView_title_name_rec: "રેકોર્ડિંગનું શીર્ષક નામ",
    recListView_name_user: "યૂજ઼ર્સનું નામ",

    // /////////////////////////////////////////////////////////////////////
    //Src
    //component - common - BrowserUpgrade
    brwUpg_req_fun_not_avail: "આવશ્યક કાર્યક્ષમતા તમારા બ્રાઉઝરમાં ઉપલબ્ધ નથી",
    brwUpg_meeting_req_fun_sup:
      "આ સત્ર સેવાને તમારા બ્રાઉઝર દ્વારા સમર્થિત ન હોય તેવા કાર્યકારીની જરૂર છે.",
    brwUpg_plz_upgrade:
      "કૃપા કરીને અપગ્રેડ કરો, બીજા બ્રાઉઝર પર સ્વિચ કરો અથવા તમારી સેટિંગ્સ તપાસો. સપોર્ટેડ બ્રાઉઝર્સ:",
    //"    Samsung Internet
    //component - common - header - header.js
    header_content: "કૉંટેંટ",
    header_loading: "લોડ કરી રહ્યું છે...",

    //containers/admin/plans/components/createPlan.js
    crtePln_plz_enter_name: "કૃપા કરી પ્લાનનું નામ દાખલ કરો",
    crtePln_plz_amount_Plan: "કૃપા કરીને પ્લાનની રકમ દાખલ કરો",
    crtePln_plz_enter_des: "કૃપા કરી ડિસ્ક્રિપ્ષન દાખલ કરો",
    crtePln_Plz_sel_product: "કૃપા કરીને પ્રૉડક્ટ પસંદ કરો",
    crtePln_plz_sel_no_host: "કૃપા કરીને નંબર ઓફ હોસ્ટ પસંદ કરો",
    crtePln_plz_enter_no_participants:
      "કૃપા કરીને પાર્ટિસિપેંટની સંખ્યા દાખલ કરો. ",
    crtePln_plz_enter_roomno: "કૃપા કરીને રૂમની સંખ્યા દાખલ કરો",
    crtePln_select_period: "કૃપા કરીને સમયગાળો પસંદ કરો",
    crtePln_sel_interval: "કૃપા કરીને અંતરાલ પસંદ કરો",
    crtePln_update_succ: "સફળતાપૂર્વક અપડેટ કર્યું",
    crtePln_err_creating_plan: "યોજના બનાવવામાં ભૂલ",

    //containers/broadcast/components/BroadcastHandRaise.js
    brdcRaise_alert_question_50_char:
      "તમારા પ્રશ્નમાં ન્યૂનતમ 50 અક્ષરોની ચેટ હોવી જોઈએ",
    //containers/conference/components/components
    cofCom_no_part_lobby: "લોબીમાં કોઈ પાર્ટિસિપેંટ નથી.",
    //containers/conference/components/ConfirmUserDetails.js
    confmUser_plz_provide_name_email: "કૃપા કરીને તમારું નામ અને ઇમેઇલ આપો",
    confmUser_notes: "નોટ્સ",
    //containers/conference/ConferenceSetup.js
    confSetup_telepresence: "ટેલિપ્રિન્સન્સ",
    confSetup_alert_not_generate_meetingID:
      "સત્ર ID જનરેટ કરવામાં સક્ષમ નથી, થોડા સમય પછી પ્રયાસ કરો",
    confSetup_auth_part_can_join: "ફક્ત અધિકૃત પાર્ટિસિપેંટ જ જોડાઈ શકે છે!.",
    confSetup_invalid_link: "અમાન્ય લિંક",
    confSetup_meeting_notyet_started:
      "આ સત્ર હજુ શરૂ થયું નથી. કૃપા કરીને પછીથી જોડાઓ!. જો તમે હોસ્ટ છો, તો કૃપા કરીને instaVC માં લોગિન કરો અને મીટિંગ શરૂ કરો",
    confSetup_meeting_locked_byhost: "આ સત્ર યજમાન દ્વારા લૉક કરેલ છે",
    confSetup_meeting_notyet_started_wait_host:
      "આ સત્ર હજુ શરૂ થયું નથી. મહેરબાની કરીને યજમાન સત્ર શરૂ થાય તેની રાહ જુઓ!",
    //containers/conference/components/NewChat.js",
    newChat_panel_chat: "પૅનલ ચૅટ",
    //containers/conference/libs/InstaVC.js
    instaVc_server_busy:
      "લાગે છે કે સર્વર વ્યસ્ત છે! બીજા સર્વરને કનેક્ટ કરવાનો પ્રયાસ કરી રહ્યાં છે...",
    //"    load-message",
    instaVc_server_busy_reload_tojoin:
      "લાગે છે કે સર્વર વ્યસ્ત છે! કોન્ફરન્સમાં જોડાવા માટે ફરીથી લોડ કરો",
    instaVc_broadcast_scr_failed: "બ્રોડકાસ્ટ સ્ક્રીન નિષ્ફળ",
    instaVc_broadcast_failed: "બ્રોડકાસ્ટ  નિષ્ફળ",
    instaVc_waiting_for_host: "હોસ્ટ વિડિઓની રાહ જુએ છે",
    //containers/content/components/contentQuestionnaire/modal-create-quest-group.js
    modlCreate_plz_enter_title: "કૃપા કરીને શીર્ષક દાખલ કરો",
    modlCreate_poll: "મતદાન",
    poll_submitted: "મતદાન સફળતાપૂર્વક સબમિટ કર્યું.",
    //containers/content/components/contentQuestionnaire/modal-create-poll-question.js
    mdlCretPoll_plz_enter_quest: "કૃપા કરી પ્રશ્ન દાખલ કરો",
    mdlCretPoll_option_should_not_same: "વિકલ્પો સમાન ન હોવા જોઈએ",
    mdlCretPoll_plz_enter_option: "કૃપા કરીને વિકલ્પો દાખલ કરો",
    mdlCretPoll_plz_select_type_option: "કૃપા કરીને વિકલ્પોનો પ્રકાર પસંદ કરો",
    alert_server_error: "આંતરિક સર્વર ભૂલ, કૃપા કરી ફરીથી પ્રયત્ન કરો",
    mdlCretPoll_update_ques: "મતદાન પ્રશ્નો અપડેટ કરો",
    mdlCretPoll_create_ques: "પ્રશ્ન બનાવો",
    mdlCretPoll_enter_que_here: "તમારો પ્રશ્ન અહીં દાખલ કરો",
    mdlCretPoll_end: "અંત",
    //containers/content/components/contentQuestionnaire/viewQuestionnaire.js
    delete_successfully: "સફળતાપૂર્વક કાઢીનાખ્યું",

    //containers/content/components/hozContentNavBlock.js / managecontent-index.js
    // "mngContent_mngContent_content" : "કૉન્ટેંટ",
    // "mngContent_mngContent_participants" : "પાર્ટિસિપેંટ્સ",
    mngContent_mngContent_fav_prog_lang: "તમે પ્રિય પ્રોગ્રામિંગ ભાષા શું છે??",
    mngContent_mngContent_pollings: "પોલિંગ્સ",

    //containers/contentShare/showQuestions.js
    showQue_obtained_marks: "ગુણ મેળવ્યા:",
    //containers/contentShare/viewUserScore.js
    viewUser_your_grade: "તમારું ગ્રેડ:",
    //containers/packages/Package.js
    package_one_host: "1 હોસ્ટ અને",
    //"package_participants" : "પાર્ટિસિપેંટ્સ",
    // SOHO
    //"    SMB 300
    package_concurrentUser_room2: "20 કંકરંટ યૂજ઼ર્સ – 2 રૂમ્સ",
    package_concurrentUser_room5: "30 કંકરંટ યૂજ઼ર્સ -5 રૂમ્સ",
    package_concurrentUser_room20: "100 કંકરંટ યૂજ઼ર્સ – 20 રૂમ્સ",
    package_concurrentUser_room30: "200 કંકરંટ યૂજ઼ર્સ - 30 રૂમ્સ",
    package_concurrentUser_room50: "500 કંકરંટ યૂજ઼ર્સ – 50 રૂમ્સ",

    //containers/schedule/components/PastMeetingItem.js
    pastMeeting_rn: "આર.એન.",
    pastMeeting_chat_history_deleted: "ચેટ હિસ્ટરી સફળતાપૂર્વક કાઢી નાખ્યો",
    pastMeeting_past_meeting_dtls: "પાછલા સત્રની વિગતો",
    pastMeeting_duration: "સમયગાળો",
    pastMeeting_download_parti_atten:
      "પાર્ટિસિપેંટ અને ભાગ લેનારાઓને ડાઉનલોડ કરો",
    pastMeeting_download_webinar: "વેબિનાર ડાઉનલોડ કરો",
    // "pastMeeting_participants" : "પાર્ટિસિપેંટ",
    pastMeeting_attendees: "ભાગ લેનારાઓ",
    pastMeeting_chat_history: "ચેટ હિસ્ટરી",
    pastMeeting_recordings: "રેકોર્ડિંગ્સ",
    pastMeeting_webinar_user: "વેબિનાર યૂજ઼ર્સ",
    pastMeeting_webinar_chat: "વેબિનાર  ચેટ",
    pastMeeting_no_participants_in_meeting: "આ સત્રમાં કોઈ સહભાગીઓ નથી!",
    pastMeeting_no_parti_attended_meeting:
      "આ સત્રમાં હાજરી આપનાર કોઈ સહભાગીઓ ન હતા.",
    pastMeeting_guest_list: "ગેસ્ટ લીસ્ટ",
    pastMeeting_no_guest_in_meeting: "આ સત્રમાં કોઈ મહેમાનો નથી!",
    "pastMeeting_no_guests_were_invited ":
      "આ સત્રમાં આમંત્રિત કે હાજરી આપનાર કોઈ મહેમાનો નહોતા.",
    pastMeeting_meeting_chat_history: "સત્ર ચેટ ઇતિહાસ",
    pastMeeting_delete_all: "બધું કાઢી નાંખો",
    pastMeeting_no_chat_msg_inmeeting: "આ સત્રમાં કોઈ ચેટ સંદેશા નથી!",
    pastMeeting_no_conver_during_meeting:
      "સત્ર દરમિયાન ચેટમાં કોઈ વાતચીત થઈ ન હતી.",
    pastMeeting_no_user_inwebinar: "આ વેબિનારમાં કોઈ યૂજ઼ર્સ નથી!",
    pastMeeting_no_user_attand_webinar: "આ વેબિનારમાં  કોઈ યૂજ઼ર્સ હાજર નથી.",
    pastMeeting_webinar_chat_history: "વેબિનાર ચેટ  હિસ્ટરી",
    pastMeeting_no_chat_msg_inwebinar: "આ વેબિનરમાં કોઈ ચેટ સંદેશા નથી!",
    pastMeeting_no_conver_during_webinar:
      "વેબિનાર દરમિયાન ચેટમાં કોઈ વાતચીત થઈ ન હતી.",
    pastMeeting_del_chat_history: "ચેટ હિસ્ટરી કાઢી ",
    pastMeeting_delete_all_chat_history:
      "શું તમને ખાતરી છે કે, તમે બધા ચેટ હિસ્ટરી કાયમી ધોરણે  કાઢી નાખવા માંગો છો?",
    pastMeeting_delete: "કાઢી નાખવા",
    //containers/schedule/components/Schedules.js
    schedul_webinar_description: "વેબિનાર ડિસ્ક્રિપ્ષન",
    schedul_upload_custom_banner:
      "તમારી વેબિનર ઇવેન્ટ માટે કસ્ટમ બેનર અપલોડ કરો.",
    schedul_setting: "સેટિંગ્સ",
    //containers/schedule/components/SchedulesView.js
    schedulView_time: "સમય",
    schedulView_edit: "ઍડિટ",
    schedulView_enable_training_mode: "ઍનેબલ ટ્રેનિંગ મોડ",
    schedulView_audio_conference: "ઑડિયો કાન્ફરેન્સ",
    schedulView_enable_mix_video: "ઍનેબલ મિક્સ વીડિયો બાઇ ડિફૉલ્ટ",

    //class components
    //content - components - hozContentNavBlock
    // "hozConNav_content" : "કૉંટેંટ",
    //scheduleMeeting
    scheMeet_room_reserved_from: "રૂમ રિજ઼ર્વ્ડ છે ",
    scheMeet_meeting_name: "સત્રના નામ સાથે",
    //dashboard - component -Contact
    contact_alert_already_in_call:
      "તમે બીજા યૂજ઼ર્સ ને કોલ કરી શકતા નથી, જ્યારે તમે પહેલેથી કોલમાં છો",
    contact_alert_user_offline: "યૂજ઼ર્સ ઑફલાઇન",
    //dashboard - dashboard.js
    dashboard_alert_cannot_start:
      "જ્યારે તમે બીજા કોલમાં હોવ ત્યારે તમે કોન્ફરન્સ શરૂ કરી શકતા નથી",
    dashboard_alert_cannot_join:
      "જ્યારે તમે બીજા કોલમાં હોવ ત્યારે તમે કોન્ફરન્સમાં જોડાઈ શકતા નથી",
    dashboard_quick_start_conf: "ઝડપી પ્રારંભ કોન્ફરન્સ",
    dashboard_maintenance_msg:
      "કૃપા કરીને નોંધો કે આપણે નિયમિત જાળવણીને કારણે 22 મી એપ્રિલ 2020 ના રોજ 8.30 વાગ્યે આઈએસટી થી 9.00 વાગ્યેઆઈએસટી સુધી સર્વર ડાઉનટાઇમનો અનુભવ કરીશું.",
    //coBrowsing
    "coBrows_host_share-video":
      "મહેરબાની કરી રાહ જુવો! હોસ્ટ વિડિઓ શેર કરવા જઇ રહ્યો છે",
    //Additionalcamera
    addCam_add_device: "ઍડ ડિવાઇસ",

    // genral same lang
    answer_list: "જવાબોની લીસ્ટ",
    answer: "જવાબો",
    answered: "જવાબ આપ્યો",
    correct_answer: "સાચો જવાબ",
    please_try_again: "મેહરબાની કરી ને ફરી થી પ્રયાસ કરો",
    question: "સવાલ",
    cancel: "રદ કરો",
    questionnaire: "પ્રશ્નાવલી",
    content: "કૉંટેંટ",
    address_book: "અડ્રેસ બુક",
    view: "વ્યૂ",
    rn: "આર.એન.",

    // new langs
    plz_enter_marks: "મહેરબાની કરીને પ્રશ્નોના ગુણ દાખલ કરો",
    plz_sel_crtans: "કૃપા કરીને સાચું જવાબ પસંદ કરો",
    truefalse_choice: "સાચું / ખોટું ચોઇસ",
    questionnarie: "પ્રશ્નાવલી",
    content_title: "કૉંટેંટ ટાઇટલ",
    media_title: "મીડીયા_ટાઇટલ",
    add_url_add: "યુઆરએલ સરનામું ઉમેરો...",
    val_shuld_grtr_from_val: "ની કિંમત વેલ્યુ કરતા વધારે હોવી જોઈએ",
    val_shuld_grtr_grade: " મૂલ્યમાંથી ગ્રેડ કરતા વધારે હોવું જોઈએ ",
    to_val: "કિંમત",
    enable_hand_raise: "વેબિનારમાં હેન્ડ રાઇઝ /  પ્રશ્નને કહો સક્ષમ કરો",
    enable_waiting_room: "પ્રતીક્ષા રૂમ સક્ષમ કરો",
    allow_only_invite: "ફક્ત આમંત્રિતોને જ કોન્ફરન્સમાં જોડાવા દો",
    guest_login_anonymous: "ગેસ્ટ કૅન લોગીન અસ અનૉનિમસ",
    give_name_webinar: "તમારા વેબિનરને એક નામ આપો",
    Webinar: "વેબિનર",
    video_syn: "વીડિયો સિંક",
    notepad: "નોટપેડ",
    enable_handraise: "વેબિનરમાં હેન્ડ રાઇઝને સક્ષમ કરો",
    //new one venkatesh
    polls_list: "પોલ્સ લીસ્ટ",
    no_poll_assign: "હજી સુધી કોઈ પોલ સોંપાયો નથી!",
    poll_view: "પોલ વ્યૂ",

    // new Prudhvi
    filter_block: "ફિલ્ટર બ્લૉક",
    file_size: "ફાઇલ સાઇજ઼",
    select_room: "કૃપા કરીને એક રૂમ પસંદ કરો",
    provide_event_name: "કૃપા કરીને કોઈ ઇવેન્ટ નામ આપો",
    end_time_greater_start_time:
      "સમાપ્તિ સમય પ્રારંભ સમય કરતા વધારે હોવો જોઈએ!",
    invite_people_meeting: "લોકોને આ સત્રમાં આમંત્રિત કરો",
    download_ical: "આઈકલ ડાઉનલોડ કરો",
    download: "ડાઉનલોડ કરો",
    delete_meeting: "આ સત્ર કાઢી નાખો",
    room: "રૂમ",
    new_event: "નવી ઇવેંટ",
    end_repeat: "અંત પુનરાવર્તન",
    invite_users_timezone: "નીચેના ટાઇમઝોનવાળા યૂજ઼ર્સને આમંત્રિત કરો",
    update_event: "અપડેટ ઇવેન્ટ",
    create_event: "ઇવેન્ટ બનાવો",
    wrong_password: "ખોટો પાસવર્ડ",
    college: "કૉલેજ",
    university: "યુનિવર્સિટી",
    country: "દેશ",
    time_period: "સમયગાળો:",
    currently_working_here: "હાલમાં અહીં કામ કરે છે",
    from: "ફ્રોમ:",
    to: "ટૂ:",
    graduated: "સ્નાતક થયા છે",
    enter_description: "તમારું ડિસ્ક્રિપશન અહીં દાખલ કરો...",
    concentration: "એકાગ્રતા",
    school: "શાળા",
    poll_question: "મતદાન પ્રશ્નો",
    create_poll_ques: "મતદાન પ્રશ્ન બનાવો",
    options: "વિકલ્પો",
    no_ques_assigned_yet: "હજી સુધી કોઈ પ્રશ્નો સોંપાયા નથી!",
    create_new_ques_click_create_ques:
      "ઉપરના પ્રશ્ન બનાવો બટનને ક્લિક કરવા માટે, નવા પ્રશ્નો બનાવો",
    enter_room_name: "કૃપા કરીને રૂમનું નામ દાખલ કરો",
    billed_annually: "* વાર્ષિક બિલ",
    subscribe_now: "સબસ્ક્રાઇબ નાઉ",
    group: "ગ્રૂપ",
    sample_webinar: "સૅંપલ વેબિનર",
    webinar_affiliate: "એફિલિએટ્સ વિશે વેબિનાર",
    webinar_one: "વેબિનર વન",
    workspace: "વર્ક સ્પેસ",
    company: "કંપની",
    add_another: "બીજો ઉમેરો",

    instavc_branchname: "બેંક શાખા નામ",
    pastMeeting_notes: "નોટ્સ",
    assignment: "અસાઇનમેંટ",
    assignments: "અસાઇનમેંટ",
    create_new_poll: "અસાઇનમેંટ શરૂ કરવા માટે એક નવો મતદાન પ્રશ્ન બનાવો.",
    plz_title_url: "કૃપા કરીને શીર્ષક અને યુઆર એલ દાખલ કરો",
    votes: "મતો",
    enter_content_title: "કૃપા કરીને માહિતીનું શીર્ષક દાખલ કરો",
    failed_result: "નિષ્ફળ પરિણામ",
    removed_successfully: "સફળતાપૂર્વક દૂર કર્યું",
    enter_duration: "કૃપા કરીને સમયગાળો દાખલ કરો",
    select_questionnarie: "કૃપા કરીને પ્રશ્નાવલિ પસંદ કરો",
    no_assignments: "કોઈ અસાઇનમેંટ નહીં",
    create_new_assignment:
      "નવી અસાઇનમેંટ બનાવો, બનાવા માટે  નવી અસાઇનમેંટ બનાવો  બટન ઉપર ક્લિક કરો",
    create_assignment: "અસાઇનમેંટ બનાવો",
    assignments_list: "અસાઇનમેંટઓ યાદી",
    assignment_description: "અસાઇનમેંટ વર્ણન",
    assignment_name: "અસાઇનમેંટ નામ",
    update_assignment: "અસાઇનમેંટ સુધારો",
    add_new_assignment: "નવી અસાઇનમેંટ ઉમેરો",
    assignment_list: "અસાઇનમેંટ સૂચિ",
    assign_assignments: "અસાઇનમેંટ શોપો",
    assigned_assignments_list: "સોંપેલ અસાઇનમેંટ સૂચિ",
    assignment_answer: "અસાઇનમેંટ જવાબ",
    no_assig_submitted: "હજી સુધી કોઈ અસાઇનમેંટ સબમિટ નથી.",
    no_assig_submitted_participants:
      "કોઈપણ સહભાગીઓ દ્વારા હજી સુધી કોઈ અસાઇનમેંટ સબમિટ નથી.",
    view_assignment: "અસાઇનમેંટ જુઓ",
    assigned_participants: "સહભાગીઓને સોંપેલ",
    select_assignment: "અસાઇનમેંટ પસંદ કરો",
    fill_your_assignment: "તમારી અસાઇનમેંટ ભરો",
    submit_assignment: "અસાઇનમેંટ સબમિટ કરો",
    assignment_details: "અસાઇનમેંટ વિગતો",
    assignment_submit_success: "અસાઇનમેંટ સફળતાપૂર્વક સબમિટ થઈ",
    assignment_saved_success: "સોંપણી સફળતાપૂર્વક સાચવી",
    how_to_get_started: "કેવી રીતે પ્રારંભ કરવું.",
    create_new_room: "નવું ઓરડો બનાવો",
    create_room_add_participants:
      "એક નવો ઓરડો બનાવો અને રૂમમાં સહભાગીઓને ઉમેરો.",
    repeats_every: "દરેક પુનરાવર્તન",
    now: "હવે",
    Plz_enter_title_meeting: "કૃપા કરીને સત્રનું શીર્ષક દાખલ કરો",
    no_start_time: "કોઈ પ્રારંભ સમય મળ્યો નથી",
    no_end_time: "કોઈ અંત સમય મળ્યો નથી",
    item_id_not_found: "આઇટમ આઈડી મળી નથી",
    msg_title_not_found: "સંદેશ શીર્ષક મળ્યું નથી",
    plz_join_conf_clicking_link:
      "કૃપા કરીને નીચેની લિંકને ક્લિક કરીને પરિષદમાં જોડાઓ",
    hi_there: "હાય ",
    room_permanently: "કાયમ રૂમ ?",
    sure_want_to_delete_participants:
      "શું તમે ખરેખર આ સહભાગીને કાઢી નાખવા માંગો છો??",
    delete_participant: "સહભાગીને કાઢી નાખો",
    add_email: "ઇમેઇલ ઉમેરો",
    add_participants_to_the_room:
      "નીચેના ઇનપુટ બૉક્સમાં સહભાગીઓનો ઇમેઇલ સરનામું લખીને આ રૂમમાં જોડાઓ.",
    no_of_users: "વપરાશકર્તાઓની સંખ્યા",
    edit_the_name:
      "તમે નામ અને આ રૂમના વપરાશકર્તાઓની સંખ્યા સંપાદિત કરી શકો છો.",
    delete_room: "રૂમ કાઢી નાખો",
    are_you_sure_delete: "શું તમે ખરેખર, તમે કાઢી નાખવા માંગો છો",
    delete_this_room: "આ રૂમ કાઢી નાખો",
    delete_room_will_parmanently:
      " કાઢી નાંખો ક્લિક કરીને, આ રૂમને કાયમી રીતે કાઢી નાખવામાં આવશે",
    enable_storage: "સંગ્રહ સક્ષમ કરો",
    enable_recordings: "રેકોર્ડિંગ્સને સક્ષમ કરો",
    enable_SIP: "એસઆઈપી સક્ષમ કરો",
    addons: "ઉમેરો",
    expires_on: "પૂરું થવું",
    purchased_on: "ખરીદવું",
    more_storage: "વધુ સંગ્રહ",
    total_storage: "કુલ સંગ્રહ",
    storage_occupied: "સંગ્રહ કબજો",
    added: "ઉમેર્યું",
    open_graphs: "ગ્રાફ ખોલો",
    participant_controls: "સહભાગી નિયંત્રણ",
    "dashboard_controls ": "ડેશબોર્ડ નિયંત્રણ ",
    start_meeting: " સત્ર શરૂ કરો",
    join_a_meeting: "સત્રમાં જોડાઓ",
    meeting_settings: "મીટિંગ સેટિંગ્સ",
    videos_to_get_started: "વિડિઓઝ પ્રારંભ કરવા માટે ",
    if_you_are_host:
      "જો તમે હોસ્ટ છો, તો સત્ર શરૂ કરવા માટે નીચેના બટનને ક્લિક કરો",
    guest_link: "ગેસ્ટ લિંક",
    pay_now: "હવે પૈસા આપો",
    promo_code_apply_here: "પ્રોમો કોડ છે? અહીં અરજી કરો",
    per_month: "પ્રતિ મહિના",
    billed_for: "બિલ માટે ",
    gst_applicable:
      "સરકારના ધારાધોરણોના પાલન મુજબ, ભારતમાં ગ્રાહકો માટે વધારાના 18% જીએસટી લાગુ થશે.",
    select_country_code: "દેશ કોડ પસંદ કરો",
    country_code: "દેશ કોડ",
    enter_email_id: "ઇમેઇલ આઈડી દાખલ કરો ...",
    downLoad_chat: "ડાઉનલોડ ચેટ",
    allow_guest_control_their:
      "અતિથિને તેમના વિડિઓ / ઑડિઓને નિયંત્રિત કરવાની મંજૂરી આપો",
    below_list_people_invited: "નીચે આમંત્રિત લોકોની સૂચિ છે",
    verification_code: "ચકાસણી કોડ",
    open_link_enter_verify_code:
      "નીચેની યુઆર એલ લિંકને ખોલો, અને જોડાણ માટે તમારો ચકાસણી કોડ દાખલ કરો",
    social_media_integration: "સોશિયલ મીડિયા જોડાણ",
    integrate_social_media_platform:
      "તમે સોશિયલ મીડિયા પ્લેટફોર્મ સાથે જોડાઈ શકો છો, એક બટન ક્લિક કરીને, તમને ચકાસણી કોડ મળશે, જોડવા માટે તેનો ઉપયોગ કરશે.",
    plz_enter_val_email: "કૃપા કરીને માન્ય ઇમેઇલ દાખલ કરો",
    record: "રેકોર્ડ",
    in_conference: "કોન્ફરન્સમાં",
    password_if_any: "પાસવર્ડ (જો કોઈ હોય તો)",
    stop_send: "રોકો અને મોકલો",
    broadcast_not_enabled_meeting: "આ સત્ર માટે બ્રોડકાસ્ટ સક્ષમ નથી",
    facebook_url: "ફેસબુક યુઆરએલ",
    enter_facebook_url: "ફેસબુક આરટીએમબી યુઆરએલ દાખલ કરો",
    add_facebook_url: "ફેસબુક આરટીએમપી યુઆરએલ ઉમેરો",
    youtube_url: "યુટ્યુબ યુઆરએલ",
    enter_youtube_url: "યુટ્યુબ આરટીએમબી યુઆરએલ દાખલ કરો",
    add_youtube_url: "યુટ્યુબ આરટીએમપી યુઆરએલ ઉમેરો",
    register: "રજિસ્ટર",
    time_of_program: "કાર્યક્રમનો સમય",
    date_of_program: "કાર્યક્રમની તારીખ",
    name_program_interested: "રુચિ ધરાવતા પ્રોગ્રામનું નામ",
    email_id: "ઇમેઇલ આઈડી",
    dob: "જન્મ તારીખ",
    applicant_address: "અરજદારનું સરનામું",
    qualification: "લાયકાત",
    designation: "હોદ્દો",
    org_name_address: "સંસ્થાનું નામ અને સરનામું",
    fullname_participant: "સહભાગીનું સંપૂર્ણ નામ",
    registration_form: "રેજિસ્ટ્રેશન ફોર્મ",
    thanks_submitting_data: "તમારો ડેટા સબમિટ કરવા બદલ આભાર",
    manage_content: "કોન્ટેંટ મેનેજ કરો",
    API_settings: "એપીઆઇ સેટિંગ્સ",
    schedule_API: "શેડ્યૂલ એપીઆઇ",
    image_upload_success: "ઇમેજ સફળતાપૂર્વક અપલોડ થઈ",
    less_than_10MB: "કૃપા કરી 10એમબી કરતા ઓછી ફાઇલ અપલોડ કરો",
    at_time_of_event: "ઇવેંટ સમયે",
    min_5: "5 મિનિટ પહેલાં",
    min_10: "10 મિનિટ પહેલાં",
    min_15: "15 મિનિટ પહેલાં",
    min_30: "30 મિનિટ પહેલાં",
    hrs_1: "1 કલાક પહેલાં",
    hrs_2: "2 કલાક પહેલાં",
    day_1: "1 દિવસ પહેલા",
    day_2: "2 દિવસો પહેલા",
    jan: "જાન",
    feb: "ફેબ્રુ",
    mar: "માર્ચ",
    apr: "એપ્રિલ",
    may: "મે",
    jun: "જૂન",
    jul: "જુલાઈ",
    aug: "ઓગસ્ટ",
    sep: "સપ્ટેમ્બર",
    oct: "ઓક્ટોબર",
    nov: "નવેમ્બર",
    dec: "ડિસેમ્બર",
    mon: "સોમ",
    tue: "મંગળ",
    wed: "બુધ",
    thu: "ગુરુ",
    fri: "શુક્ર",
    sat: "શનિ",
    sun: "રવિ",
    all_day: "બધા દિવસ",
    starts_ddmmyyyy: "શરૂ (ડી.ડી./એમએમ/વાયવાયવાયવાય)",
    ends_ddmmyyyy: "અંત (ડી.ડી./એમએમ/વાયવાયવાયવાય)",
    ddmmyyyy: "(ડી.ડી./એમએમ/વાયવાયવાયવાય)",
    by_dayweek: "દિવસ / અઠવાડિયા દ્વારા",
    never: "ક્યારેય નહીં",
    on_date: "તારીખે",
    alert: "ચેતવણી",
    multi_factor_auth: "મલ્ટિ ફેક્ટર પ્રમાણીકરણ સક્ષમ કરો (એમ.એફ.એ.)",
    advanced_settings: "અદ્યતન સેટિંગ્સ",
    verify_Otp: "ઓટીપી ચકાસો",
    resend_Otp: "ઓટીપીને ફરીથી મોકલો",
    otp_sent_mobile: "તમારા મોબાઇલ નંબર પર મોકલેલો ઓટીપી દાખલ કરો",
    update_mobile: "મોબાઇલ અપડેટ કરો",
    verify_mobile: "મોબાઇલ ચકાસો",
    mob_verfi_pending: "તમારું મોબાઇલ ચકાસણી બાકી છે.",
    mobile_number: "મોબાઇલ નંબર",
    enter_Otp: "ઓટીપી દાખલ કરો",
    enter_mob_no: "મોબાઇલ નંબર દાખલ કરો",
    sure_want_to_delete_rec: "શું તમે રેકોર્ડિંગ કાઢી નાખવા માંગો છો?",
    delete_recording: "રેકોર્ડિંગ કાઢી નાખો",
    invalid_credentials: "અમાન્ય ઓળખાણપત્ર",
    join_conf_by_clicking_link:
      "કૃપા કરીને નીચેની લિંકને ક્લિક કરીને પરિષદમાં જોડાઓ",
    hi_there: "હાય,",
    valid_room_name: "કૃપા કરીને માન્ય રૂમ નામ દાખલ કરો",
    internal_server_error: "આંતરિક સર્વર ભૂલ, કૃપા કરી ફરીથી પ્રયત્ન કરો",
    room_limit_exceed: "રૂમની મર્યાદા ઓળંગી ગઈ",
    cant_start_meeting_already_goingon:
      "તમે સત્ર શરૂ કરી શકતા નથી, કારણ કે ત્યાં પહેલેથી જ એક સત્ર ચાલી રહ્યું છે.",

    //new
    social_integration: "સામાજિક એકીકરણ",
    advanced: "અદ્યતન",
    add_youtube: "યુટ્યુબ ઉમેરો",
    plugins: "પ્લગઇન્સ",
    subtitles: "ઉપશીર્ષકો",
    view_local: "સ્થાનિક જુઓ",
    hide_local: "સ્થાનિક છુપાવો",
    switch_conf_mode: "કોન્ફરન્સ મોડ પર સ્વિચ કરો",
    switch_pres_mode: "પ્રસ્તુતકર્તા મોડ પર સ્વિચ કરો",
    conference_locked: "કોન્ફરન્સ લkedક",
    conference_unlocked: "સંમેલન અનલockedક કર્યું",
    sharing_tools: "શેરિંગ ટૂલ્સ",
    record: "રેકોર્ડ",
    recording: "રેકોર્ડિંગ",
    plz_wait_host_shr_video:
      "મહેરબાની કરી રાહ જુવો! હોસ્ટ વિડિઓ શેર કરવા જઇ રહ્યો છે",
    supported_sources_include: "આધારભૂત સ્ત્રોતો સમાવેશ થાય છે",

    team_plugins: "ટીમ પ્લગઇન્સ",
    open: "ખુલ્લા",
    click: "ક્લિક કરો",
    more_app: "વધુ એપ્લિકેશનો",
    upload_custom_app: "કસ્ટમ એપ્લિકેશન અપલોડ કરો",
    download_team_plugin: "ટીમ પ્લગઇન ડાઉનલોડ કરો",
    install_mng_app_microsoft_team:
      "માઇક્રોસ .ફ્ટ ટીમ્સમાં એપ્લિકેશન કેવી રીતે ઇન્સ્ટોલ અને સંચાલિત કરવી",
    microsoft_step1: "પગલું 1: માઇક્રોસ .ફ્ટ ટીમ્સ ખોલો",
    microsoft_step1_para1:
      "પ્રારંભ કરવા માટે, તમારે આ પૃષ્ઠની ટોચ પર ઉપલબ્ધ તમારી સિસ્ટમ પર ટીમ પ્લગઇનને ડાઉનલોડ કરવાની જરૂર છે. પછી તમારી માઇક્રોસ .ફ્ટ ટીમ્સ ખોલો અને પસંદ કરો ",
    microsoft_step1_para2:
      " ટીમ એપ્લિકેશન્સ જોવા માટે બાજુના સંશોધકમાંથી વિકલ્પો.",
    microsoft_step2: "પગલું 2: વધુ એપ્લિકેશનો પર જાઓ",
    microsoft_step2_para1:
      "અહીં તમને વધુ એપ્લિકેશન્સ નામના બટન સાથે થોડી એપ્લિકેશનો મળી શકે છે. ઉપર ક્લિક કરો",
    microsoft_step2_para2:
      "કસ્ટમ અપલોડ વિકલ્પ અને અન્ય સ્ટોર વિકલ્પોની વધુ તપાસ માટે.",
    microsoft_step3: "પગલું 3: એપ્લિકેશન અપલોડ કરો",
    microsoft_step3_para1: "એકવાર તમે સ્ટોર ખોલી લો, પછી તમે એક શોધી શકો છો",
    microsoft_step3_para2:
      "ડાબી સંશોધક વિકલ્પ. તેના પર ક્લિક કરો અને તમારી ડાઉનલોડ કરેલી પ્લગઇન એપ્લિકેશનને અહીં અપલોડ કરો.",
    microsoft_step4: "પગલું 4: સ્ટોરેજમાંથી ઇન્સ્ટાવીસી એપ્લિકેશન પસંદ કરો",
    microsoft_step4_para1:
      "જ્યારે વિંડો પૂછે ત્યારે, તમારી સિસ્ટમમાંથી ઇન્સ્ટાવીસી પ્લગઇન એપ્લિકેશન પસંદ કરો કે જે (પગલું 1) માં ડાઉનલોડ કરવામાં આવી હતી અને ક્લિક કરો.",
    microsoft_step5: "પગલું 5: માઇક્રોસ .ફ્ટ ટીમમાં અપલોડ કરેલી એપ્લિકેશન",
    microsoft_step5_para1:
      "ફાઇલ અપલોડ કર્યા પછી, તે માઇક્રોસ .ફ્ટ ટીમ એપ્લિકેશન સૂચિમાં અપલોડ થાય છે. તે પછી તમે તેને ટીમોમાં જોવા અને ઉમેરવા માટે એપ્લિકેશનને ક્લિક કરી શકો છો.",
    microsoft_step6: "પગલું 6: ઇન્સ્ટાવીસી એપ્લિકેશન ખોલો",
    microsoft_step6_para1:
      "એકવાર તમે ઇન્સ્ટાવીસી એપ્લિકેશન પર ક્લિક કરો, હવે તમે પ્લગઇન એપ્લિકેશનની સંપૂર્ણ વિગતો સાથેના બટનને જોઈ શકો છો",
    microsoft_step6_para2:
      "આ એપ્લિકેશનને માઇક્રોસamsફ્ટ ટીમમાં ઉમેરવા માટે બટન.",
    microsoft_step7: "પગલું 7: ઇન્સ્ટાવીસી માઇક્રોસ .ફ્ટ ટીમમાં ઉમેર્યું",
    microsoft_step7_para1:
      "હવે તમારી એપ્લિકેશન સરળ અને કસ્ટમાઇઝ ઉપયોગ માટે ડાબી બાજુ નેવિગેશન પર માઇક્રોસ .ફ્ટ ટીમોમાં ઉમેરવામાં આવશે.",

    ddyymm: "ડી.ડી./એમ.એમ./વાયવાયવાયવાય",
    fill_details_for_webinar:
      "કૃપા કરીને અહીં વેબિનર માટે તમારી નોંધણી વિગતો ભરો",
    microsoft_teams: "માઇક્રોસોફ્ટ ટીમ્સ",
    microsoft_outlook: "માઇક્રોસોફ્ટ આઉટલુક",
    select_the_plan: "કૃપા કરીને પ્લાન પસંદ કરો",
    enter_company_code: "કૃપા કરીને કંપની કોડ દાખલ કરો",
    enter_code: "કૃપા કરીને કોડ દાખલ કરો",
    enter_valid_coupon_code: "કૃપા કરી માન્ય કૂપન કોડ દાખલ કરો",
    coupon_alreadt_taken: "આ કૂપન કોડ પહેલેથી જ લેવામાં આવ્યો છે",
    error_updating_plan: "યોજનાને અપડેટ કરવામાં ભૂલ",
    unit: "યૂનિટ",
    referrals: "સંદર્ભો",
    sel_coupon: "કૃપા કરીને કૂપન પસંદ કરો",
    share_val_0_99: "શેર મૂલ્ય 0 થી 99 ની વચ્ચે હોવું જોઈએ",
    enter_share_val: "કૃપા કરીને શેર કિંમત દાખલ કરો",
    valid_commission_per: "કૃપા કરીને માન્ય કમિશન ટકાવારી દાખલ કરો",
    enter_commission_per: "કૃપા કરીને કમિશન ટકાવારી દાખલ કરો",
    enter_commission_name: "કૃપા કરીને કમિશન નામ દાખલ કરો",
    sync_successfully: "વપરાશકર્તાઓ સફળતાપૂર્વક સમન્વય કરે છે",
    room_deleted_suc: "રૂમ સફળતાપૂર્વક કાઢી નાખ્યો",
    lic_deleted_suc: "લાઇસેંસ સફળતાપૂર્વક કાઢી નાખ્યું",
    female: "સ્ત્રી",
    male: "પુરુષ",
    insta_conference: "ઈન્સ્ટા કાન્ફરેન્સ",
    quick_meeting_by: "દ્વારા ઝડપી સત્ર",
    in_lobby: "લોબીમાં",
    switch_to_broadcast: "બ્રોડકાસ્ટ પર સ્વિચ કરો",
    Broadcasters_5: "બ્રોડકાસ્ટર્સ (5)",
    Participants_5: "સહભાગીઓ (5)",
    search_participants: "સહભાગીઓ શોધો",
    host_controls: "હોસ્ટ કંટ્રોલ્સ",
    deleteroom: "રૂમ કાઢી નાખો",
    pm: "પી.એમ.",
    am: "એ.એમ.",
    email_exist_inroom: "આ રૂમમાં ઇમેઇલ પહેલાથી અસ્તિત્વમાં છે",
    type_a_message: "એક સંદેશ લખો...",
    please_enter_user_limit: "કૃપા કરીને વપરાશકર્તા મર્યાદા દાખલ કરો",
    user_limit_exceeded: "વપરાશકર્તા મર્યાદા ઓળંગી ગઈ છે",
    sel_country_code: "કૃપા કરીને દેશનો કોડ પસંદ કરો",
    available_storage: "ઉપલબ્ધ સ્ટોરેજ",
    enter_phone_number: "ફોન નંબર દાખલ કરો",
    startdate_less_enddate: "કૃપા કરીને સમાપ્તિ તારીખ કરતાં ઓછી તારીખ પસંદ કરો",
    havent_add_data:
      "તમે હજી સુધી કોઈ ડેટા ઉમેર્યો નથી, કૃપા કરીને ડેટા ઉમેરો.",
    professional_skills: "વ્યવસાયિક કૌશલ્યો",
    enter_prof_skills: "વ્યવસાયિક કુશળતા દાખલ કરો",
    Present_Invitations: "આમંત્રણો રજૂ કરો",
    sending: "મોકલી રહ્યું છે...",
    sent: "મોકલેલો",
    invite_10ppl_only: "તમે ફક્ત 10 લોકોને આમંત્રિત કરી શકો છો",
    join_meeting: "સત્રમાં જોડાઓ",
    enter_doc_title: "દસ્તાવેજ શીર્ષક દાખલ કરો",
    meeting_name: "સત્રનું નામ",
    select_the_weeks: "કૃપા કરીને અઠવાડિયા પસંદ કરો",
    grade: "ગ્રેડ",
    coference_ID: "કોન્ફરન્સ આઈડી...",
    dont_find_room_meetingid:
      "અમને આ સત્ર આઈડી સાથે સંકળાયેલો કોઈ રૂમ મળ્યો નથી",
    wireless_share: "વાયરલેસ શેર",
    video_layout: "વિડિઓ લેઆઉટ",
    speaker_screen: "સ્પીકર સ્ક્રીન",
    presentation_screen: "પ્રસ્તુતિ સ્ક્રીન",
    multiple_display: "મલ્ટીપલ ડિસ્પ્લે",
    hellow: "હેલો",
    enter_passcode: "પાસકોડ દાખલ કરો",
    another_meeting_stillon:
      "બીજું સત્ર હજી ચાલુ છે, તમે અત્યારે આ સત્ર શરૂ કરી શકતા નથી",
    SIP_device: "એસઆઈપી ડિવાઇસ",
    instavc_whiteBoard: "ઇન્સ્ટાવીસી વ્હાઇટબોર્ડ",
    speaker: "સ્પીકર",
    instavc_notepad: "ઇન્સ્ટાવીસી નોટપેડ",
    promote_in: "પ્રમોટ ઇન",
    guest: "અતિથિ",
    breakout_rooms: "બ્રેકઆઉટ રૂમ",
    stop_broadcast: "બ્રોડકાસ્ટ રોકો",
    noise_suppress: "નોઇસ સપ્રેશન",
    echo_cancel: "ઇકો રદ:",
    enter_name_here: "અહીં નામ દાખલ કરો",
    Viewer: "દર્શક",
    SIP_user: "એસઆઈપી વપરાશકર્તા",
    remove_participants: "સહભાગીઓને દૂર કરો",
    disable_audio_video: "રિમોટ ઑડિઓ અને વિડિઓને અક્ષમ કરો",
    disable_audio: "ઑડિઓ અક્ષમ કરો",
    enable_audio: "ઑડિઓ સક્ષમ કરો",
    disable_video: "વિડિઓ અક્ષમ કરો",
    enable_video: "વિડિઓ સક્ષમ કરો",
    audio_video: "ઑડિઓ અને વિડિઓ",
    audio_only: "ફક્ત ઑડિઓ",
    video_only: "ફક્ત વિડિઓ",
    outlook_addins: "આઉટલુક એડ-ઇન્સ",
    install_microsoft:
      "માઇક્રોસોફ્ટ આઉટલુકમાં એડ-ઇન્સને કેવી રીતે ઇન્સ્ટોલ અને મેનેજ કરવું",
    outlook_step1: "સ્ટેપ 1 : લિંકની કોપિ કરો અને આઉટલુક ખોલો",
    first_copy_link: "પહેલા લિંક કોપિ  કરો",
    add_plugin_oulook: "અહીંથી તમારા આઉટલુકમાં પ્લગઇન ઉમેરો",
    outlook_step2: "સ્ટેપ 2: એડ-ઇન્સ મેળવો",
    outlook_step2_para:
      "હવે આઉટલુક  ખોલો અને  હોમ ટેબ હેઠળ તમને એડ-ઇન્સ વિકલ્પ મળશે. એડ-ઇન્સ અને અન્ય કસ્ટમ વિકલ્પો જોવા માટે તેના પર ક્લિક કરો. ",
    outlook_step3: "સ્ટેપ 3: મારા એડ-ઇન્સ",
    outlook_step3_para:
      "હવે તમે ડાબી સંશોધક સાથે એડ-ઇન્સ પૃષ્ઠ જોઈ શકો છો. તમારા એડ-ઇન્સને મેનેજ કરવા માટે મારા એડ-ઇન્સ પર જાઓ.",
    outlook_step4: "સ્ટેપ 4: કસ્ટમ એડ-ઇન્સ ઉમેરો",
    outlook_step4_para:
      "અહીં તમે મારા એડ-ઇન્સ પૃષ્ઠમાં કસ્ટમ એડ-ઇન્સ હેઠળ કસ્ટમ એડ-ઇન્સ  ડ્રોપડાઉનમાં  ઉમેરી શકો છો. . ડ્રોપ ડાઉન  યુઆર એલ માંથી ઉમેરો પસંદ કરો.",
    outlook_step5: "સ્ટેપ 5: યુઆર એલ  માંથી ખાનગી એડ-ઇન ઉમેરો",
    outlook_step5_para:
      "હવે તમે યુઆર એલ  માંથી ખાનગી એડ-ઇન ઉમેરવાનું કહેતા પોપઅપને જોઈ શકો છો. હવે તમે ઇનપુટ ક્ષેત્રમાં કોપિ કરેલી લિંક (પગલું 1) ને પેસ્ટ કરો અને ઑકે ક્લિક કરો, જે આઉટલુકમાં એડ-ઇનને ઇન્સ્ટોલ કરે છે. ",
    outlook_step6: "સ્ટેપ 6: મારા એડ-ઇન્સમાં ઇન્સ્ટાવીસી ઉમેરવામાં",
    outlook_step6_para:
      "ઉમેર્યા પછી, તમે તમારી મારી એડ-ઇન્સ સૂચિમાં ઉમેરવામાં આવેલા એડને ચકાસી શકો છો.અહીંથી તમે તમારા એડ-ઇન્સને વધુ મેનેજ કરી શકો છો.",
    outlook_step7: "સ્ટેપ 7: આઉટલુક બંધ કરો અને ફરીથી ખોલો",
    outlook_step7_para:
      "ઇન્સ્ટોલ કર્યા પછી, ખાતરી કરો કે તમે એકવાર સંપૂર્ણ આઉટલુક બંધ કરો છો અને એડ-ઇન જોવા માટે ફરીથી ખોલો છો.",
    outlook_step8: "સ્ટેપ 8: નવી આઇટમ્સ પર જાઓ",
    outlook_step8_para:
      "આઉટલુક ખોલ્યા પછી, હવે તમે નવી મીટિંગ્સ & # 62 પર જઈ શકો છો ; આઉટલુકમાં ઉમેરવામાં ઇન્સ્ટાવીસીને જોવા માટે બેઠક.",
    outlook_step9: "સ્ટેપ 9: ઇન્સ્ટાવીસી બેઠક ખોલો",
    outlook_step9_para:
      "એકવાર તમે મીટિંગ્સ ખોલશો, પછી મીટિંગ્સ ટેબ હેઠળ ટોચની પટ્ટીમાં ઇંસ્ટાવીસી મીટિંગ એડ-ઇન સક્ષમ સાથે તમને કંપોઝ મેઇલ વિંડો સાથે ખોલવામાં આવશે. ",
    outlook_step10: "સ્ટેપ 10: શેડ્યૂલ બનાવો",
    outlook_step10_para:
      "કંપોઝ મેઇલ લેઆઉટમાંથી, નવું શેડ્યૂલ બનાવવા માટે ઇન્સ્ટાવાક મીટિંગ્સ પર ક્લિક કરો. જો પહેલીવાર આવી હોય તો તમને જમણી બાજુએ ઇન્સ્ટાવીસી મીટિંગ લોગિનથી ખોલવામાં આવશે.પહેલાથી લોગ ઇન કરેલા વપરાશકર્તાઓ માટે, તેઓને રૂમની સૂચિમાં નિર્દેશિત કરવામાં આવશે અને શેડ્યૂલ બનાવી શકાય છે.",
    outlook_step11: "સ્ટેપ 11:ઇન્સ્ટાવીસી બેઠક ખોલો",
    outlook_step11_para:
      "તમે ડાબી બાજુએ એક શેડ્યૂલ બનાવી શકો છો અને કોઈ ચોક્કસ રૂમમાં મીટિંગ સુનિશ્ચિત કરવા માટે જમણી બાજુએ એક રૂમ પસંદ કરી શકો છો. એકવાર તમે શેડ્યૂલ બનાવો, તમે હમણાં જ મીટિંગ પ્રારંભ કરો બટન જોઈ શકો છો. અહીંથી તમે મીટિંગને ક્લિક કરી અને પ્રારંભ કરી શકો છો.",
    outlook_step12: "સ્ટેપ 12:કલેન્ડરમાં સમયપત્રક જુઓ",
    outlook_step12_para:
      "એકવાર તમે શેડ્યૂલ બનાવ્યા પછી, આગલી વખતે જ્યારે તમે કેલેન્ડર ખોલો, તમે કલેન્ડરમાં તમારા સમયપત્રક પણ જોઈ શકો છો. ",
    outlook_step13: "સ્ટેપ 13: શેડ્યૂલ બનાવ્યું",
    outlook_step13_para:
      "એકવાર તમે શેડ્યૂલ બનાવો, પછી તમે જમણી બાજુએ પ્રારંભ મીટિંગ બટન સાથે બનેલા મેઇલને જોઈ શકો છો.",
    sel_declaration: "કૃપા કરીને ઘોષણાને પસંદ કરો",
    enter_company_code: "કૃપા કરીને કંપની કોડ દાખલ કરો",
    invalid_company_code: "અમાન્ય કંપની કોડ",
    affiliate_acc: "તમારું સંલગ્ન એકાઉન્ટ મંજૂરી માટે બાકી છે.",
    aff_acc_approved: "તમારું એફિલિએટ એકાઉન્ટ માન્ય છે.",
    aff_acc_rej: "તમારું એફિલિએટ એકાઉન્ટ નકારી લીધુ છે.",
    aff_TC: "સંલગ્ન નિયમો અને શરતો",
    ref_par_agreement: "રેફરલ પાર્ટનર એગ્રીમેન્ટ",
    aff_partner_agreement:
      'આ ભાગીદાર કરાર, જેમાં આ કવર પેજ અને જોડાયેલ વ્યાપારની શરતો (સામૂહિક રીતે, આ "કરાર") હોય છે, અને પીપલલિંક યુનિફાઇડ કમ્યુનિકેશંસ પ્રા.લિ. (જેને પીપલલિંક તરીકે ઓળખવામાં આવે છે) અને "પાર્ટનર" અથવા "તમે" વચ્ચે દાખલ કરવામાં આવે છે . "પાર્ટનર" અથવા "તમે" નો અર્થ સબમિટ કરેલા ફોર્મમાં વિગતવાર વ્યક્તિ અથવા કંપની (કંપનીનું નામ અને અન્ય માહિતી સહિત) છે. આ કરારની સ્વીકૃતિ સૂચવવા માટે તમે રેફરલ પાર્ટનર પ્રોગ્રામ ફોર્મ ("ફોર્મ") પૂર્ણ અને સબમિટ કર્યા પછી કરાર બંધનકર્તા બનશે.પીપલિંક અને પાર્ટનરને કેટલીકવાર "પાર્ટી" તરીકે ઓળખવામાં આવે છે, અને ક્યારેક "પાર્ટીઓ" તરીકે પણ ઓળખવામાં આવે છે.',
    background: "બૅકગ્રાઉંડ",
    aff_market_advertise:
      'પીપલિંક ઇન્સ્ટાવીસી યુનિફાઇડ કમ્યુનિકેશન સેવાઓ અને ઉકેલો પ્રદાન કરે છે. પાર્ટનર, આ કરાર અનુસાર, તેની વેબસાઇટ (ઓ) અને અન્ય માર્કેટિંગ ચેનલો દ્વારા, પીપલલિંક ઉત્પાદનો અને તેના સંભવિત પીપલિંક ગ્રાહકો ("રેફરલ્સ") ના ઉકેલો, માર્કેટિંગ અને જાહેરાત કરવા માંગે છે..',
    agreement: "અગ્રીમેંટ",
    aff_parties_agree: "પક્ષો નીચે મુજબ સંમત:",
    heading1: "પ્રોગ્રામ સમિતિઓ",
    heading2: "લાયક રેફરલ્સ, કમિશન.",
    heading3: "મુદત અને અવધિ.",
    heading4: "સામાન્ય",
    the_program: "કાર્યક્રમ. ",
    to_participate_program_partner:
      'પ્રોગ્રામમાં ભાગ લેવા માટે પાર્ટનરએ પીપલલિંક અથવા તેની સાથે સંકળાયેલ વેબસાઇટ્સ ("સાઇટ") પર મળેલા પ્રોગ્રામમાં ભાગ લેવા માટે ઑનલાઇન એપ્લિકેશન પૂર્ણ કરવી જોઈએ અને આ કરાર દાખલ કરવો આવશ્યક છે. પીપલિંક કોઈપણ વિનંતીને તેના સંપૂર્ણ વિવેકથી સ્વીકારી અથવા નકારી શકે છે.',
    aff_str11: "કાનૂની કરાર.",
    aff_str12: "પ્રમોશન, રેફરલ પ્રવૃત્તિઓ:",
    aff_str13: "પ્રતિબંધિત પ્રવૃત્તિઓ.",
    aff_str14: "પીપલિંક માર્ક્સનો અનુમતિપૂર્ણ ઉપયોગ",
    aff_str15: "જવાબદારીઓ.",
    aff_str16: "ગ્રાહક સંબંધો.",
    aff_str11_para:
      "પ્રોગ્રામમાં તેની ભાગીદારીના ભાગ રૂપે અને પીપલિંકના ભાગીદાર તરીકે કામ કરવા માટે, ભાગીદાર અહીંથી આ કરારની શરતો અને પ્રોગ્રામ, માર્ગદર્શિકાઓ, અને પીપલલિંક દ્વારા સમયાંતરે સેટ કરેલી અન્ય વિનંતીઓ અને નિયમોને વાજબી રૂપે સંમત થાય છે અને સંમતિ આપે છે. પ્રોગ્રામમાં ભાગીદારની સતત ભાગીદારી અને પીપલલિંક ઉત્પાદનોના પ્રમોશન, સોલ્યુશન્સ અને સર્વિસ ટુ રેફરલ્સના સંદર્ભમાં મુનસફી.પ્રોગ્રામમાં તેની ભાગીદારીના ભાગ રૂપે અને પીપલિંકના ભાગીદાર તરીકે કામ કરવા માટે, ભાગીદાર અહીંથી આ કરારની શરતો અને પ્રોગ્રામ, માર્ગદર્શિકાઓ, અને પીપલલિંક દ્વારા સમયાંતરે સેટ કરેલી અન્ય વિનંતીઓ અને નિયમોને વાજબી રૂપે સંમત થાય છે અને સંમતિ આપે છે. પ્રોગ્રામમાં ભાગીદારની સતત ભાગીદારી અને પીપલલિંક ઉત્પાદનોના પ્રમોશન, સોલ્યુશન્સ અને સર્વિસ ટુ રેફરલ્સના સંદર્ભમાં મુનસફી.",
    aff_str12_para:
      "પાર્ટનર લાઇસન્સ પ્રાપ્ત માર્ક્સ અને માર્કેટિંગ મટિરિયલ્સનો ઉપયોગ કરીને વિવિધ માર્કેટિંગ ચેનલોમાં પીપલલિંક પ્રોડક્ટ્સ અને સોલ્યુશન્સના સતત, સક્રિય પ્રમોશનમાં સામેલ થવા સંમત થાય છે, અને આ કરારની શરતોનું પાલન કરે છે. ",
    aff_str13_para:
      'પાર્ટનર માર્કેટિંગ સામગ્રીને એવી સામગ્રી સાથે જોડવાની સંમતિ આપે છે કે જે કોઈપણ રીતે ગેરકાયદેસર છે, અથવા જે નુકસાનકારક, ધમકી આપનાર, માનહાનિ, અશ્લીલ, અપમાનજનક, સતામણી કરનાર, જાતીય સ્પષ્ટ, હિંસક, ભેદભાવવાળું અથવા પીપલલિંકના વિવેકબુદ્ધિથી વાંધાજનક છે.પાર્ટનર, પીપલિંક સેવાઓ અને ઉકેલોને પ્રોત્સાહન આપવા માટે બહુવિધ અસંબંધિત પ્રાપ્તિકર્તાઓ ("સ્પામિંગ") ને ગેરવાજબી ઇલેક્ટ્રોનિક સંદેશાઓ ન મોકલવા સંમત થાય છે, અથવા અન્યથા આ કરાર હેઠળની પ્રવૃત્તિઓ સાથે જોડાણમાં કાયદા દ્વારા પ્રતિબંધિત માસ ઇલેક્ટ્રોનિક સંદેશાવ્યવહારના કોઈપણ અન્ય પ્રકારમાં સામેલ થવા માટે સંમત છે. ',
    aff_str14_para1:
      "પાર્ટનર, લાઇસન્સ પ્રાપ્ત માર્ક્સનો ઉપયોગ કરીને અને માર્કેટિંગ સામગ્રી બનાવવા માટે અહીંની તમામ શરતોનું પાલન કરવા સ્પષ્ટપણે સંમત થાય છે. ",
    aff_str14_para2:
      "દિશાનિર્દેશો દ્વારા અને અન્યથા, પીપલલિંક સમયાંતરે માર્કેટિંગ મટિરીયલ્સ બનાવવા અને પીપલલિંક સર્વિસને પ્રોત્સાહન આપવા માટેના લાઇસન્સ પ્રાપ્ત ગુણનો પાર્ટનર દ્વારા પરવાનગી મુજબની વિશિષ્ટતાઓ અને અન્ય સૂચનો પ્રદાન કરશે. પાર્ટનર આવી તમામ સ્પષ્ટીકરણો અને સૂચનોનું પાલન કરવા માટે સંમત થાય છે. ",
    aff_str14_para3:
      "પાર્ટનર ખાતરી કરશે કે તેની માર્કેટિંગ સામગ્રી પર દેખાતા તમામ લાઇસન્સ પ્રાપ્ત માર્ક્સ માર્ગદર્શિકાઓમાં પીપલલિન્ક દ્વારા મંજૂર કરેલા ફોર્મમાં છે અથવા અન્યથા, કોઈપણ પીપલિંક માર્ક્સને સુધારશે નહીં અથવા અન્ય માર્કેટિંગ સામગ્રીને પીપલલિંક દ્વારા પૂરી પાડવામાં આવેલ વાજબી સૂચનાઓ વિરુદ્ધ નોંધપાત્રરૂપે ફેરફાર કરશે નહીં, અને વધુ પાલન કરશે પીપલલિંક તરફથી માર્કેટિંગ મટિરિયલ્સના ફોર્મ, સામગ્રી અને પ્રદર્શનની વાજબી સૂચનાઓ સાથે. કોઈપણ કારણોસર આ કરારની સમાપ્તિ પર, અથવા પીપલિંક દ્વારા લેખિત વિનંતી પર, અહીં આપવામાં આવેલ લાઇસન્સ સમાપ્ત થઈ જશે અને ભાગીદાર તરત જ આ કરાર હેઠળ તેની બધી પ્રવૃત્તિઓ બંધ કરશે. ",
    aff_str15_para:
      "પાર્ટનર આ કરાર હેઠળ કાર્ય કરવા માટેના તેના ઓપરેશન્સ માટે સંપૂર્ણપણે જવાબદાર રહેશે, જેમાં કોઈપણ કરારની મર્યાદા વિના, આ કરાર સાથે જોડાણમાં બનાવવામાં આવેલ અને ઉપયોગમાં લેવામાં આવતી ભાગીદારની કામગીરી અને સામગ્રીની કાયદેસરતા શામેલ છે. પીપલ્સલિંક માર્ક કોઈ તૃતીય પક્ષના ટ્રેડમાર્ક અધિકારોનું ઉલ્લંઘન કરે છે તેવો દાવો કરવા સિવાય, પીપલલિંક પાર્ટનરના માર્કેટિંગ મટિરીયલ્સના વિકાસ, કામગીરી અથવા સામગ્રી માટે જવાબદાર નથી અને ભાગીદાર કોઈ પણ દાવા, ક્રિયાઓ અને કારણો સામે પીપલલિંકને હાનિકારક નહીં રાખવા, ક્ષતિભંગ કરવા અને પકડવાની સંમતિ આપે છે.પાર્ટનરના માર્કેટિંગ સામગ્રીના વિકાસ, કામગીરી, સામગ્રી અને જાળવણીથી સંબંધિત ક્રિયા, નુકસાન અથવા ખર્ચ (એટર્ની ફી સહિત). ",
    aff_str16_para:
      "કાર્યકાળ દરમિયાન અને તે પછી, પીપલિંક સેવાના ઉપયોગ માટે પીપલલિંક સાથે કરાર કરનાર રેફરલ્સને ઓળખી કાઢીતી કોઈપણ અને તમામ માહિતી સહિત, પીપલિંક સેવાના સંદર્ભમાં ભાગીદાર દ્વારા બનાવવામાં આવેલા બધા સંબંધોના વિશિષ્ટ માલિક હશે. પીપલ્સલિંક સેવા માટેની શરતો, ગોપનીયતા નીતિ અને પીપલલિંકના નિયમો અને કાર્યવાહી આ રેફરલ્સ પર લાગુ થશે અને ભાગીદારને અગાઉની સૂચના આપ્યા વિના પીપલલિન્ક દ્વારા બદલી શકાય છે, અને ભાગીદાર શરતો હેઠળ પીપલલિંક સાથેના તેમના સંબંધોના પ્રકારને સંદર્ભ આપવા સંમત થાય છે. ",
    aff_str20_para1:
      "પાર્ટનર દ્વારા પીપલિંકને સંદર્ભિત અને જેઓ નીચે વિભાગ 3 (બી) માં વર્ણવેલ પ્રક્રિયા અનુસાર સાઇન-અપ પ્રક્રિયા પૂર્ણ કરે છે; ",
    aff_str20_para2:
      "પીપલલિંક સેવા સાથેના સંબંધમાં જેનો પીપલ્સલિંક પાસે કોઈ રેકોર્ડ નથી, અથવા જે તે સમયે, પાર્ટનર દ્વારા પીપલલિંકનો ઉલ્લેખ કરવામાં આવ્યો છે, તે કોઈપણ કરાર સંબંધો અથવા પીપલલિંક સેવા સાથેના સંબંધમાં પીપલલિંક સાથે ચાલી રહેલી વાટાઘાટોમાં; ",
    aff_str20_para3:
      "શરતો સ્વીકારે છે અને રેફરલના પોતાના મુનસફી પ્રમાણે અને ભાગીદાર પાસેથી કોઈપણ નાણાકીય અથવા અન્ય પ્રોત્સાહન પ્રાપ્ત કર્યા વિના, પીપલલિંક વેબસાઇટ્સ પર સૂચિબદ્ધ નીચેના પીપલલિંક સેવા યોજના બંડલ્સની ઓછામાં ઓછી વાર્ષિક સબ્સ્ક્રિપ્શન્સ અથવા (iv) જે નામંજૂર નથી પીપલિંક્સ સેવા પ્રાપ્ત કરવા માટે ઓછામાં ઓછા એક ચુકવણી (વાર્ષિક પ્રીપે) અથવા ત્રણ ચુકવણી (વાર્ષિક મુદત, માસિક બિલિંગ) કરો. ",
    aff_str21: "રેફરલ કાર્યવાહી.",
    aff_str22: "કમિશન. જવાબદારીઓ.",
    aff_str221: "રેફરલ ફી.",
    aff_str222: "એક રેફરલ પ્રતિ ચાલુ વેચાણ",
    aff_str223: "સંકળાયેલ ખર્ચ.",
    aff_str23: "વેચાણ / કમિશન રિપોર્ટ્સ.",
    aff_str21_para:
      "દરેક રેફરલને પીપલલિંકને ભાગીદારને ઑનલાઇન યુઆરએલ દ્વારા પ્રદાન કરવામાં આવે છે, જે પીપલલિંક તમામ રેફરલ્સને વેચાણ પ્રક્રિયા માટે જવાબદાર રહેશે, જે વેચાણ પ્રક્રિયાને રેફરલમાં પ્રોત્સાહન આપવા માટે પક્ષોની સતત સદ્ભાવના સહકારને આધિન રહેશે. ",
    aff_str22_para:
      "પીપલલિંક સીધા જ રેફરલ્સમાંથી પીપલલિંક સર્વિસ માટે રેફરલ્સ પાસેથી તમામ ફી એકત્રિત કરશે. ",
    aff_str22_para1:
      'ક્વોલિફાઇડ રેફરલ બન્યા પછી રેફરલ પર, પીપલ્સ લિંક "પર સ્થિત લિસ્ટેડ ફીના આધારે બાકી ભાડામાં ભાગીદાર રેફરલ ફી ચૂકવશે.',
    aff_str22_para12:
      "(કોઈપણ ડિસ્કાઉન્ટને બાદ કરતાં) ક્વોલિફાઇડ રેફરલ દ્વારા ચૂકવવાપાત્ર. આવી રેફરલ ફી ચુકવણીપાત્ર બનશે અને ચૂકવેલ સેવા પ્રારંભ તારીખની ચુકવણી જવાબદારીઓ પ્રાપ્ત થયાના લગભગ (<એડ) નેવું (90) દિવસની અંદર ભાગીદારને ચૂકવવામાં આવશે. ",
    aff_str22_para2:
      "- ભાગીદારને ક્વોલિફાઇડ રેફરલ પાસેથી વધારાના વેચાણ માટે રેફરલ ફી પ્રાપ્ત થશે જે રેફરલ શરૂઆતમાં રજૂ કરવામાં આવી હતી તે તારીખના પ્રથમ 90 દિવસની અંદર થાય છે. ",
    aff_str22_para3:
      "ભાગીદાર, તમામ કર, ફરજો, સરકારી ચાર્જ અને રેફરલ ફીઝ પર લાદવામાં આવતા અન્ય ચાર્જની ચુકવણી માટે જવાબદાર રહેશે, અને ભાગીદાર પીપલલિંકની ચુકવણીથી નીકળેલા તમામ ચાર્જને લગતા અથવા દાવાઓ સામે અને તેના સામે દાવા સામે, પીપલલિંકને હાનિકારક, બચાવ અને પકડશે રેફરલ ફી. ",
    aff_str23_para:
      "પીપલિંક્સ, તેમના dનલાઇન ડેશબોર્ડ અહેવાલમાં ભાગીદાર અને રેફરલ્સમાંથી મેળવેલા ક્વોલિફાઇડ રેફરલ્સ માટેના કમિશનની વેચાણ પ્રવૃત્તિઓનો સારાંશ આપતા અહેવાલમાં પ્રદાન કરશે. પીપલિંક્સ રેફરલ્સ અને લાયકાતવાળા રેફરલ્સ વિશે નામો અથવા અન્ય વ્યક્તિગત માહિતી જાહેર કરશે નહીં. ",
    aff_str31: "પ્રારંભિક મુદત.",
    aff_str32: "નવીકરણની મુદત.",
    aff_str33: "પ્રારંભિક સમાપ્તિ. કારણ વિના.",
    aff_str34: "કારણ માટે.",
    aff_str35: "સમાપ્તિની અસર.",
    aff_str31_para:
      'આ કરાર અસરકારક તારીખથી અસરકારક બનશે અને ત્યારબાદ બાર (12) મહિના ("પ્રારંભિક મુદત") સુધી ચાલુ રહેશે, જ્યાં સુધી પીપલિંક્સ કાર્યક્રમમાં ભાગ લેવા માટે ભાગીદારોની અરજીને નકારે નહીં',
    aff_str32_para:
      'પ્રારંભિક મુદતની સમાપ્તિ પછી, આ કરારમાં બાર (12) મહિના (દરેક, "નવીકરણની મુદત") ની વધારાની સતત શરતો માટે આપમેળે નવીકરણ કરવામાં આવશે, સિવાય કે કોઈ પક્ષ અન્ય પક્ષને સમાપ્તિની લેખિત સૂચના ઓછામાં ઓછી ત્રીસ (30) નહીં આપે ) પ્રારંભિક મુદત અથવા કોઈપણ નવીકરણ અવધિના સમાપ્તિના દિવસો પહેલા આપે. ',
    aff_str33_para:
      "પીપલલિંકને પાર્ટનરને પાંચ (5) દિવસ અગાઉની લેખિત સૂચના આપીને કોઈપણ સમયે અથવા કોઈપણ કારણોસર આ કરારને સમાપ્ત કરવાનો અધિકાર હશે. ",
    aff_str34_para:
      "ક્યાં તો પક્ષ આ કરારને કોઈપણ સમયે સમાપ્ત કરી શકે છે, જે અન્ય પક્ષને આ કરારનો ભૌતિક ભંગ કર્યો છે તેની લેખિત સૂચના પછી તરત જ અસરકારક છે, જો કે આ કરારને સમાપ્ત કરતા પહેલા ટર્મિનેટીંગ પક્ષ આવી સામગ્રી ભંગની લેખિત સૂચના આપશે અને  ભંગ પક્ષને આવા ઉલ્લંઘનને મટાડવાની ત્રીસ (30૦) દિવસની તક આપશે. ",
    aff_str35_para:
      "આ કરારની સમાપ્તિની તારીખથી અને તેના પછીના ભાગીદારના આ કરાર હેઠળના અધિકારો સમાપ્ત થશે, અને ભાગીદાર આ કરારની સમાપ્તિ પહેલા કમાયેલી કમાણી અથવા ચૂકવણી સિવાય આ કરાર હેઠળ કોઈપણ રેફરલ ફી અથવા કોઈપણ અન્ય ચુકવણી પ્રાપ્ત કરવા માટે હકદાર રહેશે નહીં ",
    aff_str41: "સોંપણી.",
    aff_str42: "ઇંટેલેક્ચુયલ પ્રૉપર્ટી રાઇટ્સ.",
    aff_str43: "કોઈ માફી નથી.",
    aff_str44: "મર્યાદિત વોરંટી.",
    aff_str45: "વોરંટી નામંજૂર.",
    aff_str46: "જવાબદારીની મર્યાદા.",
    aff_str47: "સ્વતંત્ર કૉંટ્રૅક્ટર.",
    aff_str48: "વળતર.",
    aff_str49: "કુદરતી આપત્તિ.",
    aff_str410: "સમગ્ર કરાર; ગંભીરતા.",
    aff_str411: "કાઉન્ટરપાર્ટ્સ; સૂચનાઓ.",
    aff_str412: "શાસન કાયદો; અધિકારક્ષેત્ર; વિવાદનું નિરાકરણ.",
    aff_str41_para:
      "પીપલિંક કોઈપણ સમયે આ કરારને સોંપી શકે છે. પાર્ટનર પીપલલિંકની અગાઉની લેખિત સંમતિ વિના આ કરારને સોંપશે નહીં અથવા સ્થાનાંતરિત કરી શકશે નહીં, આવી સંમતિ ગેરવાજબી રૂપે રોકી ન શકાય. ",
    aff_str42_para:
      "પીપલિંક માર્ક્સ, પીપલિંક સર્વિસ અને વિશ્વભરની સંબંધિત સામગ્રી અને તકનીકી (પીપલિંક આઈપી રાઇટ્સ) માંના તમામ બૌદ્ધિક સંપત્તિ અધિકારો (જેમ કે ટ્રેડમાર્ક્સ, ટ્રેડ નામો, લોગો, પેટન્ટ, કોપિરાઇટ્સ, ડોમેન નામો અને વ્યુત્પન્ન અધિકાર સુધી મર્યાદિત નથી) અને પીપલિંક અને તેની સહાયક કંપનીઓની વિશિષ્ટ સંપત્તિ રહેશે.લાઇસન્સ પ્રાપ્ત માર્ક્સનો ઉપયોગ કરવાનો પાર્ટનરનો અધિકાર પીપલલિંકના મુનસફી પર છે અને આ કરારની શરતો, દિશાનિર્દેશો અને તમામ લાગુ કાયદાઓ અને નિયમો સાથે ભાગીદારના પાલનને પાત્ર છે. પાર્ટનર સંમત થાય છે (એ) આ કરારનું ઉલ્લંઘન કરે તેવી સંભવિત કોઈપણ રીતે કોઈપણ પીપલિંક આઇપી રાઇટ્સનો ઉપયોગ નહીં કરે; (બી) કોઈપણ પીપલલિંક આઇપી રાઇટ્સની લડત અથવા ક્ષતિ બક્ષે તેવું ન કરો; (સી) કોઈપણ બૌદ્ધિક સંપત્તિ અધિકારો બનાવશો નહીં અથવા મેળવશો નહીં (જેમ કે ટ્રેડમાર્ક્સ, ટ્રેડ નામો, લોગોઝ, પેટન્ટ્સ, કrપિરાઇટ્સ, ડોમેન નામો અને વ્યુત્પન્ન અધિકાર સુધી મર્યાદિત નથી) જે કોઈપણ પીપલિંક આઇપી રાઇટ્સ સાથે સમાન છે; (ડી) પાર્ટનરને વાસ્તવિક જ્ જ્ઞાન હોય તેવા કોઈપણ પીપલલિંક આઇપી રાઇટ્સના કોઈપણ અનધિકૃત ઉપયોગની તુરંત જ પીપલલિંકને જાણ કરો; અને ()) હંમેશાં માર્ગદર્શિકાઓના પાલન માટે લાઇસન્સ પ્રાપ્ત ગુણ અને કોઈપણ અન્ય પીપલિંક માર્ક્સનો ઉપયોગ કરો. પીપલિંક પાર્ટનર દ્વારા પ્રસ્તુત કોઈપણ માર્કેટિંગ મટિરીયલ્સની સમયાંતરે સમીક્ષાઓ કરી શકે છે, અને ભાગીદાર દ્વારા પ્રસ્તુત કોઈપણ માર્કેટિંગ મટિરીયલ્સને દૂર કરવા અને / અથવા સુધારવાનો આદેશ આપવા માટે એકમાત્ર અધિકાર અને વિવેકબુદ્ધિ હશે. ",
    aff_str43_para:
      "ક્યાં તો પક્ષ દ્વારા આ કરારની કોઈપણ જોગવાઈના બીજા પક્ષના કડક પ્રદર્શનને લાગુ કરવામાં નિષ્ફળતા, પછીથી આ કરારની કોઈ જોગવાઈ અથવા અન્ય જોગવાઈઓ લાગુ કરવાના પ્રથમ પક્ષના અધિકારને માફી આપશે નહીં.",
    aff_str44_para:
      "બંને પક્ષો બાંહેધરી આપે છે કે ટર્મ દરમ્યાન દરેક સમયે તેઓ બધા લાગુ કાયદા, નિયમો, આચારસંહિતા તેમજ આ કરાર, શરતો, ગોપનીયતા નીતિ અને દિશાનિર્દેશોનું પાલન કરશે.. ટર્મ દરમિયાન અને કોઈ પણ કારણસર તેને સમાપ્ત કર્યા પછી, ભાગીદાર સ્પષ્ટપણે એવું કશું ન કરે કે જે પીપલલિન્કના વ્યવસાય, હિતો અથવા પ્રતિષ્ઠાને નુકસાન પહોંચાડે તેવી અપેક્ષા રાખી શકાય અને પીપલલિન્ક, તેના પ્રતિનિધિઓ અથવા પીપલલિંક સર્વિસ વિશે કોઈ પણ અપમાનજનક ટિપ્પણી કરવા, પ્રકાશિત કે પ્રકાશિત કરવાની મંજૂરી આપશે નહીં..",
    aff_str45_para:
      "અગાઉના પેટાવિભાગ (ઇ) હેઠળ પીપલલિન્કની એક્સપ્રેસ વોરન્ટી સિવાય, પીપલલિન્ક અન્ય કોઈ વોરંટી, એક્સપ્રેસ અથવા ગર્ભિત નથી અને પીપલલિન્ક કોઈ પણ પ્રકારની વોરંટી અને શરતોનો સ્પષ્ટ પણે દાવો કરે છે, જેમાં વેપારીક્ષમતા, ફિટનેસની કોઈ પણ સૂચિત વોરંટી, ઉપલબ્ધતા, સુરક્ષા, શીર્ષક અને/અથવા બિન-ઉલ્લંઘનનો સમાવેશ થાય છે.",
    aff_str46_para:
      "પીપલલિન્ક કે કોઈ પણ અધિકારી, કર્મચારી, ડિરેક્ટર અથવા પીપલલિન્કના અન્ય કોઈ પ્રતિનિધિ ભાગીદાર અથવા આ કરાર હેઠળ અથવા તેના ટર્મિનેશનના સંદર્ભમાં, કરાર, પૂર્વ-કરાર, ટોર્ટ અથવા અન્ય રીતે કોઈ પણ આર્થિક નુકસાન (મહેસૂલ, નફા, કોન્ટ્રાક્ટ, વેપાર અથવા અપેક્ષિત બચત સહિત) ભાગીદાર અથવા તેના સંદર્ભમાં ભાગીદાર અથવા તેના સંદર્ભમાં જવાબદાર રહેશે નહીં. આવા નુકસાનમાં કોઈ પણ વિશેષ, પરોક્ષ, પ્રાસંગિક, વૈધાનિક, શિક્ષાત્મક અથવા પરિણામલક્ષી નુકસાન અથવા નુકસાન તેમજ કામગીરીમાં વિક્ષેપને કારણે થતા નુકસાન અથવા નુકસાનનો સમાવેશ થાય છે. અન્ય કોઈ સંજોગો કે સમજ હોવા છતાં, આ સમજૂતી હેઠળ ભાગીદાર પ્રત્યે પીપલલિન્કની સંપૂર્ણ જવાબદારી આ સમજૂતી હેઠળ ભાગીદાર દ્વારા કરવામાં આવેલા કોઈ પણ પ્રકારના નુકસાન માટે આઈ.એન.આર (ભારતીય રૂપિયા એક હજાર રૂપિયા)થી વધુ નહીં હોય.",
    aff_str47_para:
      "અહીં પક્ષો સ્વતંત્ર કોન્ટ્રાક્ટર તરીકે પોતાના વતી કામ કરે છે. આ કરારમાં કોઈ પણ સંયુક્ત સાહસ, એજન્સી, ફ્રેન્ચાઇઝી, વેચાણ પ્રતિનિધિ, રોજગાર અથવા આ કરારમાં નિર્ધારિત સંબંધો સિવાયના પક્ષો વચ્ચે કોઈ પણ સંયુક્ત સાહસ, એજન્સી, ફ્રેન્ચાઇઝી, વેચાણ પ્રતિનિધિ, રોજગાર અથવા અન્ય કોઈ પણ સંબંધ નું નિર્માણ નહીં થાય અને ભાગીદારને પીપલલિન્ક વતી કામ કરવાથી સ્પષ્ટ પણે બાકાત રાખવામાં આવે છે. આ સમજૂતી હેઠળ લાઇસન્સવાળા માર્ક્સનું પ્રદર્શન, ભાગીદાર દ્વારા રજૂ કરવામાં આવેલી અન્ય સામગ્રી અથવા ભાગીદાર અને તૃતીય પક્ષો વચ્ચેસંપર્ક અહીં વર્ણવેલા સંબંધોને ખોટી રીતે રજૂ કરશે નહીં.",
    aff_str48_para:
      'ભાગીદાર પીપલલિન્ક અને તેની પેટા કંપનીઓ, સહયોગીઓ, અધિકારીઓ અને કર્મચારીઓ ("પીપલલિન્ક ઇન્ડેમ્ફાઇડ પાર્ટીઓ")ને નુકસાન કરશે અને તેની સામે કોઈ પણ ખર્ચ, જવાબદારીઓ, નુકસાન અને ખર્ચ (સહિત) કોઈ પણ દાવાને પરિણામે વાજબી વકીલો સુધી મર્યાદિત રહેશે. : (i) ભાગીદાર દ્વારા સમજૂતીનો ભંગ; (ii) ભાગીદાર અથવા તેના કર્મચારીઓ, એજન્ટો અથવા કોન્ટ્રાક્ટરોની બેદરકારી, ઘોર બેદરકારી અથવા ઇરાદાપૂર્વકની ગેરવર્તણૂક; અથવા (૩) ભાગીદાર અથવા તેના કર્મચારીઓ, એજન્ટો, કોન્ટ્રાક્ટરો અથવા આમંત્રિતો દ્વારા અગાઉ અહીં ઉલ્લેખ કરવામાં આવેલા કાયદાઓ અને નિયમોનું પાલન કરવામાં નિષ્ફળતા.',
    aff_str49_para:
      'જો બળજબરીની  પરિસ્થિતિ દ્વારા આમ કરતા અટકાવવામાં આવે તો કોઈ પણ પક્ષને અહીં પોતાની કોઈ પણ જવાબદારી નિભાવવાની ફરજ પડશે નહીં. "ફોર્સ મેજર" ઘટનાઓમાં ઈશ્વરના કૃત્યો, સરકારના કૃત્યો, પ્રકૃતિ, હડતાળ અથવા રમખાણો તેમજ પીપલલિન્ક્સ સપ્લાયર્સ દ્વારા અયોગ્ય કામગીરી અથવા ત્રીજા પક્ષકારોના સોફ્ટવેરમાં ખામીઓ સહિત પક્ષોના વાજબી નિયંત્રણ બહારની ઘટનાઓનો સમાવેશ થાય છે. જો બળની સ્થિતિ ત્રીસ (30) દિવસ સુધી ચાલે તો કોઈ પણ પક્ષ અન્ય પક્ષને લેખિત નોટિસ પર આ સમજૂતી રદ કરી શકે છે.',
    aff_str410_para:
      "આ સમજૂતી આ વિષય અને પક્ષકારોની જવાબદારીઓ અને પ્રતિબદ્ધતાઓ અંગે પક્ષકારો વચ્ચે સંપૂર્ણ સમજૂતીનું પ્રતિનિધિત્વ કરે છે. આ સમજૂતીમાં નિર્ધારિત સમજૂતીઓ પર પક્ષકારો વચ્ચે અન્ય કોઈ દસ્તાવેજો કે મૌખિક અથવા લેખિત સમજૂતીઓ કોઈ પણ રીતે પ્રતિબિંબિત થતી નથી અને બંને પક્ષો દ્વારા અમલમાં મૂકવામાં આવેલા લેખન સિવાય આ કરારમાં ફેરફાર કરી શકાય નહીં. . જ્યારે પણ શક્ય હોય ત્યારે, આ સમજૂતીની દરેક જોગવાઈનું અમલીકરણ કાયદા હેઠળ અસરકારક અને માન્ય હોય તે રીતે અર્થઘટન કરવામાં આવશે, પરંતુ જો આ સમજૂતીની કોઈ પણ જોગવાઈ લાગુ કાયદા હેઠળ અથવા અયોગ્ય હશે તો આવી જોગવાઈ માત્ર આવી જોગવાઈ અથવા અમાન્યતાની હદ સુધી જ બિનઅસરકારક રહેશે. ",
    aff_str411_para:
      "આ સમજૂતી પર સમકક્ષોમાં હસ્તાક્ષર થઈ શકે છે અને આવા સમકક્ષો અહીંના પક્ષકારો ને માન્ય અને બંધનકર્તા રહેશે, જેમ કે મૂળ સહીઓનું આદાન-પ્રદાન કરવામાં આવ્યું હોય.",
    aff_str412_para:
      "આ સમજૂતીનું સંચાલન હૈદરાબાદના, તેલંગાણા, ભારતના અધિકારક્ષેત્રના કાયદાઓ દ્વારા કરવામાં આવશે, જે કાયદાના ટકરાવના કોઈ પણ સિદ્ધાંતોને અસર કર્યા વિના. અધિકારક્ષેત્ર માત્ર હૈદરાબાદ, તેલંગાણા, ભારતની જિલ્લા અદાલતોમાં જ રહેશે. આ સમજૂતીમાંથી ઉદ્ભવતા કોઈ પણ કેસ માટે એકમાત્ર અને વિશેષ અધિકારક્ષેત્ર અને સ્થળ હૈદરાબાદ, તેલંગાણા, ભારત ખાતે સ્થિત યોગ્ય જિલ્લા અથવા રાજ્યની અદાલત હશે અને પક્ષકારો ઉઠાવવા સંમત થશે નહીં અને આ રીતે માફી, કોઈ પણ વાંધા અથવા સંરક્ષણને માફ કરો. આ સમજૂતી હેઠળ અથવા સંબંધિત કોઈ પણ કાનૂની કાર્યવાહી શરૂ કરતા પહેલા, એક પક્ષ વિવાદની અન્ય પક્ષને લેખિત નોટિસ આપશે અને પક્ષકારો આ પ્રકારના વિવાદના ઝડપી ઉકેલ માટે સક્રિય અને સારી રીતે વાટાઘાટો કરશે.",
    aff_str40: "કરારમાં ફેરફાર.",
    aff_str40_para:
      "પીપલિંક આ કરારને સમય-સમય પર તેના વાજબી મુનસફીથી સાઇટ પર ફેરફાર પોસ્ટ કરી શકે છે (ડબ્લ્યૂડબ્લ્યૂડબ્લ્યૂ.પીપલલિંકવીસી.કૉમ/ઍફીલીઍટસટર્મસઓફસર્વિસ પર) અથવા ઇમેઇલ દ્વારા ભાગીદારને સૂચિત કરી શકે છે. જો ભાગીદાર આવા કોઈપણ બદલાવ સામે વાંધો ઉભો કરે છે, તો જીવનસાથી કારણસર આ કરારને સમાપ્ત કરી શકે છે. આ કરારમાં બદલાવ અંગેની સૂચના પ્રાપ્ત થયા બાદ પ્રોગ્રામમાં ભાગીદારની સતત ભાગીદારી, સુધારેલ તરીકે, આ કરારની બંધનકર્તા સ્વીકૃતિની રચના કરશે.",
    qualified_ref: "લાયક રેફરલ્સ",
    mean_referrals: "મતલબ રેફરલ્સ",
    apply: "લાગુ કરો",
    company_code_validate: "માન્ય કરવા માટે કંપની કોડ દાખલ કરો",
    golive_company_code: "ગોલાઈવ કંપની કોડ",
    accept_TC: "હું ઉપરોક્ત નિયમો અને શરતો સ્વીકારું છું",
    by_sub_referral:
      "રેફરલ પાર્ટનર એપ્લિકેશન સબમિટ કરીને, ભાગીદાર રજૂ કરે છે અને વોરંટ આપે છે કે જેણે આ કરાર વાંચ્યું છે, સમજે છે અને સ્વીકારે છે.",
    term: "શરતો",
    found_at: "પર મળી",
    our_privacy_policy: "અને અમારી ખાનગી નીતિ ",
    privacy_policy: "ખાનગી નીતિ  ",
    as_applicable: "લાગુ પડે છે  .",
    "screen-sharing": "સ્ક્રીન શેરિંગ",
    whiteboard_access: "વ્હાઇટબોર્ડ .ક્સેસ",
    Document_access: "દસ્તાવેજ .ક્સેસ",
    share_the_screen: "સ્ક્રીન શેર કરો!",
    to_collaborate: "સહયોગ માટે!",
    share_document: "દસ્તાવેજ શેર કરો!",

    exit_or_end: "બહાર નીકળો કે સત્ર સમાપ્ત કરો?",
    exit_from_meeting: "સત્રમાંથી બહાર નીકળીએ?",
    are_sure_exit_meeting_everyone:
      "શું તમે ખરેખર સત્રમાંથી બહાર નીકળવા માંગો છો? તમે કાં તો દરેક માટે મીટિંગ સમાપ્ત કરી શકો છો અથવા તમે સત્રમાંથી બહાર નીકળી શકો છો.",
    are_sure_exit_meeting: "શું તમે ખરેખર સત્રમાંથી બહાર નીકળવા માંગો છો?",
    exit_meeting: "સત્રમાંથી બહાર નીકળો",
    end_for_all: "બધા માટે સત્ર સમાપ્ત કરો",
    end_meeting: "સત્ર સમાપ્ત કરો",
    will_let_alone_exit: "તમને એકલા બહાર નીકળવા દેશે અથવા સત્ર છોડશે.",
    will_end_for_everyone:
      "કોન્ફરન્સમાં દરેક માટે સત્ર સમાપ્ત થશે (બધા સહભાગીઓ અને પ્રતિભાગીઓ).",
    user_already_exists: "વપરાશકર્તાઓ પહેલેથી અસ્તિત્વમાં છે",
    already_user_avail: "કોન્ફરન્સમાં પહેલાથી જ કેટલાક વપરાશકર્તાઓ ઉપલબ્ધ છે.",
    if_like_continue: "જો તમે ચાલુ રાખવા માંગતા હોવ તો ક્લિક કરો",
    force_start_meetinh: "અન્ય સત્ર શરૂ કરવા દબાણ કરો",
    otherwise_click: "નહિંતર, પર ક્લિક કરો ",
    to_go_back: "પાછા જવામાટે.",

    //New by Keerthi - 17th Sep 2020
    lang_settings: "ભાષા સેટિંગ્સ",
    lang_info: "એપ્લિકેશનનો ઉપયોગ કરવા માટે તમારી પસંદગીની ભાષા પસંદ કરો.",
    select_language: "ભાષા પસંદ કરો",
    settings_languages: "ભાષાઓ",

    rec_plugin: "Recording Plugin",
    rec_heading1:
      "How to install and manage InstaVC Screen-Video Recorder with the plugin",
    rec_step1: "Step 1: Copy & open Link in Chrome",
    rec_step1_para: "First copy the link ",
    rec_step1_para_br:
      "from here and open it in chrome to add the plugin to your browser. Click on ",
    rec_step1_para_bold: "Add to Chrome",
    rec_step1_para_ct: "to add this extension.",

    rec_step2: "Step 2: Pop Up for Permission",
    rec_step2_para_br:
      "When you click on Add to chrome, here appears a popup asking for permission to display notification access your content. Click on ",
    rec_step2_para_bold: "Add Extension",
    rec_step2_para_ct: "to proceed.",

    rec_step3: "Step 3: Extension Added to Chrome",
    rec_step3_para:
      "When the extension is added to chrome, it shows a window giving you an information with a plugin icon and how to manage this plugin from here.",

    rec_step4: "Step 4: Pin the plugin on the toolbar",
    rec_step4_para_br:
      "To pin the plugin to your toolbar, you need to click on manage extensions, go to ",
    rec_step4_para_bold: "InstaVC Screen-Recording",
    rec_step4_para_ct: "and click on the pin icon to add.",

    rec_step5: "Step 5: Extension/Plugin Pinned to Toolbar",
    rec_step5_para:
      "Once the extension is pinned, you can now see an instavc recording icon in your browser toolbar and start using it for easy access.",

    rec_step6: "Step 6: InstVC Recorder Setup",
    rec_step6_para_br:
      "Once you have installed the plugin and the next time when you open it, you can now see the ",
    rec_step6_para_bold: "InstaVC Recorder Setup",
    rec_step6_para_ct:
      "page to enable or disable the recording tools. By default both the options will be enabled. Click on ",
    rec_step6_para_bold1: "Next",
    rec_step6_para_ct1: "to continue.",

    rec_step7: "Step 7: Additional Permissions",
    rec_step7_para_br:
      "Once the Next button is clicked, system will then show you a popup asking for additional permissions to read and change your data. Click ",
    rec_step7_para_bold: "Allow",
    rec_step7_para_ct: "to continue.",

    rec_step8: "Step 8: Permissions Allowed",
    rec_step8_para:
      "After allowing the permission, this page now gets frozen or in a disabled mode from where you can now start exploring recording options now.",

    rec_heading2: "Desktop Screen-Recording Plugin",

    rec_step9: "Step 9: Desktop Screen-Recording",
    rec_step9_para_br:
      "After allowing all permissions, you can now access recording menus from the plugin extension in your toolbar. Click on it to see further options. Here we have selected ",
    rec_step9_para_bold: "Desktop Screen Recording",
    rec_step9_para_ct: "and click on the",
    rec_step9_para_bold1: "Record",
    rec_step9_para_ct1: "button to start.",

    rec_step9a: "Step 9(a): Share your Screen Popup",
    rec_step9a_para_br:
      "Now the system shows up this popup asking to select the contents of your screen, whether its an Entire Screen or only application window. Click on the tab which you want to share and click on ",
    rec_step9a_para_bold: "Share",
    rec_step9a_para_ct:
      "button and go to that screen which you want to start recording.",

    rec_step9b: "Step 9(b): Desktop Screen Recording Started",
    rec_step9b_para_br:
      "The Desktop Screen recording is now started and you can see a blink in the toolbar while its in recording mode. Also, you can see a tab at the bottom showing buttons for ",
    rec_step9b_para_bold: "Stop Sharing",
    rec_step9b_para_ct: "or",
    rec_step9b_para_bold1: "Hide",
    rec_step9b_para_ct1:
      ". You can see the bottom message on any screen you are opening until you are in the desktop screen recording mode.",

    rec_step9c: "Step 9(c): Restart / Pause or Stop Desktop Screen Recording",
    rec_step9c_para_br:
      "Once you want to stop Recording. Click on the plugin in the toolbar and here you can see the options to ",
    rec_step9c_para_bold: "Restart, Pause",
    rec_step9c_para_ct: "and",
    rec_step9c_para_bold1: "Stop",
    rec_step9c_para_ct1: "buttons. You can click any of those accordingly.",

    rec_step9d: "Step 9(d):Recent Recording View",
    rec_step9d_para_br:
      "Once you stop the recording from the toolbar, the recent recording will now automatically open the recording in a new tab along with Title and ",
    rec_step9d_para_bold: "Download",
    rec_step9d_para_ct:
      "option in the top and the recording details in the right column.",

    rec_heading3: "Browser Tab Screen-Recording Plugin",

    rec_step10: "Step 10: Browser Tab Screen-Recording",
    rec_step10_para_br: "When we want to select ",
    rec_step10_para_bold: "Browser Tab",
    rec_step10_para_ct:
      "option for recording your browser screen. First open your screen(url) in chrome whichever you want to record and then open the plugin and click on Browser Tab, adjust microphone options and then click",
    rec_step10_para_bold1: "Record",
    rec_step10_para_ct1: "button to start recording.",

    rec_step10a: "Step 10(a): Browser Tab is being Recorded",
    rec_step10a_para:
      "Once the Browser tab is started recording, you can see a red dot blinking in your toolbar which indicates the tab is being recorded and also a blue box blinking in your browser title bar",

    rec_step10b: "Step 10(b): Record another tab",
    rec_step10b_para_br:
      "At the time of current screen recording, if you open another url and open the plugin, it will show you the recording status along with an option",
    rec_step10b_para_bold: "Record This Tab",
    rec_step10b_para_ct:
      "if you want to change the recording scree to the new url. Meanwhile the blue box blinking in the title bar of the browser indicates the tab that is being recorded at the moment.",

    rec_step10c: "Step 10(C): Stop and View recording",
    rec_step10c_para_br:
      "Later, when you stop the recording, the browser itself opens the recording in a new tab along with Title and",
    rec_step10c_para_bold: "Download",
    rec_step10c_para_ct:
      "Option at the top and the recording details in the right column.",

    rec_heading4: "Webcam Recording",

    rec_step11: "Step 11: Start Webcam Screen Recording",
    rec_step11_para_br:
      "When you start with Webcam screen recording, make sure to select the microphone & camera settings among the devices detected by the plugin. and then click on the",
    rec_step11_para_bold: "Record",
    rec_step11_para_ct: "button to start with.",

    rec_step11a: "Step 11(a): Webcam opens Self Video and starts Recording",
    rec_step11a_para_br:
      "The recording opens a web page with yourself video with",
    rec_step11a_para_bold: "Pause",
    rec_step11a_para_ct: "and",
    rec_step11a_para_bold1: "Stop",
    rec_step11a_para_ct1: "recording options at the bottom.",

    rec_step11b: "Step 11(b): View Webcam Recorded Video",
    rec_step11b_para:
      "When you stop the recording in the previous screen, the browser then opens the recording in a new tab to view and download along with the recording details.",

    rec_heading5: "Top Menus in Recording Plugin",

    rec_step12: "Step 12: Navigation Menus",
    rec_step12_para_br:
      "The plugin has few navigation menus to fetch your data as well as manage different actions related to the plugin. One of them is a",
    rec_step12_para_bold: "Hamburger Menu",
    rec_step12_para_ct: "Click on it to open.",

    rec_step12a: "Step 12(a): Open Hamburger Menu",
    rec_step12a_para_br: "On click of",
    rec_step12a_para_bold: "Hamburger Menu",
    rec_step12a_para_ct: ", you can find 2 tabs named",
    rec_step12a_para_bold1: "My Recordings",
    rec_step12a_para_ct1: "and",
    rec_step12a_para_bold2: "Options",
    rec_step12a_para_ct2:
      "which manages all the data you have been recording and options you have enabled or disabled for that plugin. Click on",
    rec_step12a_para_bold3: "My Recordings",
    rec_step12a_para_ct3: "to see the videos you have recorded till date.",

    rec_step12b: "Step 12(b): Access My Recordings",
    rec_step12b_para_br: "There is another way of accessing",
    rec_step12b_para_bold: "My Recordings",
    rec_step12b_para_ct:
      ", page from the top menu in the plugin which can be considered as a shortcut to navigate.",

    rec_step12c: "Step 12(c): My Recordings",
    rec_step12c_para:
      "Here will be the detailed list of videos(recordings) you have recorded till date. Each video contains the date, duration, size of the video along with delete icon in the thumbnail view. When you click on any video it opens the details in the view recording page. Note that all the videos will be stored locally here.",

    rec_step12d: "Step 12(d): Delete All recordings",
    rec_step12d_para_br:
      "Looking at My recordings Page, there is a more icon in the top right corner which opens the",
    rec_step12d_para_bold: "Delete All",
    rec_step12d_para_ct:
      "option to easily delete all recordings with a single click.",

    rec_step12e: "Step 12(e): Side Navigation",
    rec_step12e_para_br:
      "Instead of opening the plugin again and change, You can directly navigate to another tab from here using the Hamburger Menu in the top left corner of the page that opens the navigation to navigate to the",
    rec_step12e_para_bold: "Options",
    rec_step12e_para_ct: "page",

    rec_heading6: "Plugin Options",

    rec_step13: "Step 13: Plugin Options",
    rec_step13_para_br:
      "On click on Hamburger Menu, you can find another tab named Options which manages all the options you have enabled or disabled for that plugin. Click on",
    rec_step13_para_bold: "Options",
    rec_step13_para_ct: "to see the options that are enabled for you.",

    rec_step13a: "Step 13(a): Recorder Options",
    rec_step13a_para:
      "Recorder Options ask you for various options like video storage, Notifications, Keyboard Shortcuts",

    rec_step13b: "Step 13(b): Recorder Options",
    rec_step13b_para:
      "Recorder Options contain various other options like Recording Settings and advanced.",

    rec_heading7: "Plugin Notifications",

    rec_step14: "Step 14: Plugin Notifications",
    rec_step14_para:
      "On the top navigation part, you can find a bell icon for notifications if any related to instavc screen recording plugin.",

    rec_step14a: "Step 14(a): Open Notifications",
    rec_step14a_para:
      "On click on the notification icon, you can find the list of notifications if any or it shows an empty slide in.",

    rec_heading8: "Recording Settings",

    rec_step15: "Step 15: Settings",
    rec_step15_para_br:
      "Then comes the last navigation menu on the top right corner named",
    rec_step15_para_bold: "Settings",
    rec_step15_para_ct:
      "where you can open and manage the recording settings accordingly.",

    rec_step15a: "Step 15(a): Advanced Settings Options",
    rec_step15a_para:
      "Here you can adjust the settings based on the Resize tab, Limit resolution and maximum frame rate which are given by plugin.",

    crteContent_upload_medialist: "Uploaded Media List",
    content_upld_desc_txt:
      "The files you upload here will be available to users who view content.",
    content_browse_txt: "Browse Files to Upload",
    content_upld_types:
      "Files with only .jpg, .jpeg, .png, and .pdf are allowed limiting the max size upto 15MB",

    video_qlty: "વિડિઓ ગુણવત્તા",
    audio_qlty: "Audioડિઓ ગુણવત્તા",
    cntnt_shrng: "સામગ્રી શેરિંગ",
    fdb_poor: "ગરીબ",
    fdb_good: "સારું",
    fdb_avg: "સરેરાશ",
    fdb_excellent: "ઉત્તમ",
    share_feedback: "તમારી ફીડબેક શેર કરો",
    ovrl_rating: "એકંદર ગુણ",
    fdb_cmnts: "તમારી ટિપ્પણીઓની ખૂબ પ્રશંસા કરવામાં આવે છે",
    no_thnks: "ના આભાર",
    upload_size_max_15mb: "તમે અપલોડ કરી શકો છો મહત્તમ કદની મર્યાદા 15MB છે",

    pastMeeting_feedback: "પ્રતિસાદ",
    pastMeeting_comments: "ટિપ્પણીઓ",

    microsoft_webplugin: "માઇક્રોસ .ફ્ટ આઉટલુક વેબ પ્લગઇન",
    microsoft_installable: "માઇક્રોસ .ફ્ટ આઉટલુક ઇન્સ્ટલેબલ પ્લગઇન",
    outlook_installable: "આઉટલુક ઇન્સ્ટોલ કરી શકાય તેવું",
    customization_installer: "કસ્ટમાઇઝેશન ઇન્સ્ટોલરને કેવી રીતે .ક્સેસ કરવું",
    plugin_step1: "પગલું 1: ફાઇલ ડાઉનલોડ કરવા માટે લિંકને ક્લિક કરો",
    click_link_download: "ફાઇલ ડાઉનલોડ કરવા માટે લિંકને ક્લિક કરો",
    first_click_link: "પહેલા નીચે આપેલ લીંક ઉપર ક્લિક કરો",
    to_download_file:
      "તમારી સિસ્ટમમાં ફાઇલ ડાઉનલોડ કરવા. પછી ઇન્સ્ટોલેશન શરૂ કરવા માટે ડાઉનલોડ કરેલી ફાઇલને ખોલો અને ક્લિક કરો",
    install_txt: "સ્થાપિત કરો",
    plugin_step2: "પગલું 2: કસ્ટમાઇઝેશન ઇન્સ્ટોલ કર્યું",
    plugin_step2_para:
      "Once you start installing, wait untill the file gets installed and you get a popup showing successfully Installed and then close.",
    plugin_step3: "પગલું 3: આઉટલુક ખોલો અને મીટિંગ્સ પર જાઓ",
    plugin_step3_para:
      "ઇન્સ્ટોલેશન પછી, માઈક્રોસોફ્ટ આઉટલુક ખોલો અને સત્ર પર જાઓ.",
    plugin_step3_para1: "નવા ઈમેલ > સત્રો પર જાઓ",
    plugin_step4: "પગલું 4: સત્ર ખોલો",
    plugin_step4_para:
      "એકવાર સત્રોની વિન્ડો ઉપરોક્ત ટેબની સૂચિ પર ખુલ્લી ચાલ મેળવે અને પછી તમે ટેબ પર ક્લિક કરી શકો છો",
    plugin_step4_para1: "પીપલિંક",
    plugin_step5: "પગલું 5: શેડ્યૂલ કોન્ફરન્સ",
    plugin_step5_para: "પીપલિંક હેઠળ તમારી પાસે એક સબ ટ Tabબ નામ છે",
    plugin_step5_para1: "શેડ્યૂલ કોન્ફરન્સ.",
    plugin_step5_para2:
      "તેના પર ક્લિક કરો અને તમે વિંડોની જમણી બાજુએ શેડ્યૂલ વિકલ્પો જોઈ શકો છો. અહીં તમે ઇનવીસી સૂચિનું સંચાલન કરી શકો છો.",
    plugin_step6: "પગલું 6: ગોઠવો અથવા કસ્ટમાઇઝ કરો સૂચિ",
    plugin_step6_para:
      "અહીં તમે ઓરડાઓ, સમયની સૂચિ દ્વારા સમયપત્રકનું સંચાલન કરી શકો છો અથવા કસ્ટમાઇઝ કરી શકો છો અને અહીંથી એક નવું શેડ્યૂલ બનાવી શકો છો જે તમને બ્રાઉઝર પર રીડાયરેક્ટ કરે છે અને આઉટલુક પર પાછા ફરે છે.",
    plugin_step6_para1:
      "એકવાર તમે શેડ્યૂલ સાથે ઠીક થઈ ગયા પછી તમે ક્લિક કરી શકો છો",
    plugin_step6_para2: "લિંક મેળવો",
    plugin_step7: "લિંક જનરેટ થયેલ",
    plugin_step7_para:
      "તે પછી અહીં મેલમાં જનરેટ કરેલી અને બનેલી લિંક મળે છે જેનો તમે sharingનલાઇન શેરિંગ માટે ઉપયોગ કરી શકો છો અથવા આગળ વધો.",

    instavc_schedulemeeting_namesplchar:
      "No special characters allowed except @ # $ % ^ & * _ - ?",

    sessions: "સત્રો",
    schedule_session: "શેડ્યૂલ સત્ર",
    join_session: "સત્રમાં જોડાઓ",
    no_of_sessions_attended_by_teacher:
      "શિક્ષકો દ્વારા હાજરી આપેલ સત્રોની સંખ્યા",
    no_of_sessions_attended_by_student:
      "વિદ્યાર્થીઓ દ્વારા હાજરી આપેલ સત્રોની સંખ્યા",
    teacher_attendance: "શિક્ષક હાજરી",
    students_attendance: "વિદ્યાર્થીઓની હાજરી",
    virtual_classroom:
      "અપ્રતિમ અનુભવ સાથેનું ઓનલાઈન વર્ચ્યુઅલ ક્લાસરૂમ પ્લેટફોર્મ",
    today_sessions: "આજે સત્રો",
    no_sessions: "કોઈ સત્રો નથી...",
    session_quote:
      "મૂળભૂત અને અદ્યતન મીટિંગ સુવિધાઓ સાથે, સત્ર પાસવર્ડ બનાવવા અથવા ડાયનેમિક મીટિંગ આઈડીને સક્ષમ કરવા જેવા વિકલ્પો સાથે એક નવું સત્ર શેડ્યૂલ કરો.",
    session_title: "સત્રનું શીર્ષક",
    create_session_name: "સત્રનું નામ બનાવો",
    session_password: "સત્ર પાસવર્ડ",
    meeting_password: "સત્ર પાસવર્ડ બનાવો",
    selectClass: "વર્ગ પસંદ કરો",
    selectSubject: "વિષય પસંદ કરો",
    select_time: "સમય પસંદ કરો",
    select_meeting_date_time: "સત્રની તારીખ અને સમય પસંદ કરો",
    select_slot: "સ્લોટ પસંદ કરો",
    select_numberof_participant_seats: "સહભાગી બેઠકોની સંખ્યા પસંદ કરો",
    advanced_options: "અદ્યતન વિકલ્પો",
    custom_registration_url: "કસ્ટમ નોંધણી URL",
    custom_feedback_url: "કસ્ટમ પ્રતિસાદ URL",
    allow_guest_control: "મહેમાનોને નિયંત્રિત કરવાની મંજૂરી આપો",
    meeting_details: "સત્રની વિગતો",
    meeting_title: "સત્રનું શીર્ષક",
    meeting_type: "સત્રનો પ્રકાર",
    seats: "બેઠકો",
    meeting_Password: "સત્ર પાસવર્ડ",
    meeting_only_url: "ફક્ત સત્ર URL:",
    join_meeting_quote: "સહભાગીઓ સાથે અથવા આમંત્રિત કર્યા વિના સત્રમાં જોડાઓ",
    copy_invitation: "આમંત્રણની નકલ કરો",
    invite_users_list: "આમંત્રિત કરો - વપરાશકર્તાઓની સૂચિ",
    update_meeting: "અપડેટ સત્ર",
    custom: "કસ્ટમ",
    frequency: "આવર્તન",
    occurences_end: "ઘટના સમાપ્ત થાય છે",
    occurences: "ઘટનાઓ",
    hr: "કલાક",
    every_day: "દરરોજ",
    hours: "કલાક",
    hour: "કલાક",
    errorTxt_slots: "તમારે કસ્ટમ સમય - કલાક અથવા મિનિટ ભરવાનો રહેશે",
    participantSeats: "સહભાગી બેઠકો",
    participant_seat: "સહભાગી બેઠક",
    subjects: "વિષયો",
    visible: "દૃશ્યમાન",
    hidden: "છુપાયેલ",
    create_topic: "વિષય બનાવો",
    edit_topic: "વિષય સંપાદિત કરો",
    topicName: "વિષયનું નામ",
    topicDescripiton: "વિષયનું વર્ણન",
    public: "જાહેર",
    classDescription: "વર્ગ વર્ણન",
    editNewClass: "નવા વર્ગમાં ફેરફાર કરો",
    topics: "વિષયો",
    topicView: "વિષય દૃશ્ય",
    no_of_sessions_conducted: "આયોજિત સત્રોની સંખ્યા",
    no_of_students_attended_session:
      "તમારા સત્રોમાં ભાગ લીધેલ વિદ્યાર્થીઓની સંખ્યા",
    yourAssignments: "તમારી સોંપણીઓ",
    attendance: "હાજરી",
    recent_topics: "તાજેતરના વિષયો",
    no_subjects: "હજુ સુધી કોઈ વિષયો બનાવવામાં આવ્યા નથી!",
    no_subjects_create: "ઉપરોક્ત વિષય બનાવો બટન પર ક્લિક કરીને નવો વિષય બનાવો",
    no_topics: "હજુ સુધી કોઈ વિષયો બનાવવામાં આવ્યા નથી!",
    no_topics_create: "ઉપરોક્ત વિષય બનાવો બટન પર ક્લિક કરીને વિષય બનાવો",
    assgnlist_noassignments: "હજુ સુધી કોઈ સોંપણીઓ સોંપવામાં આવી નથી!",
    assgnlist_assign_new_assign:
      "ઉપરોક્ત અસાઇનમેન્ટ બટનને ક્લિક કરવા માટે નવી અસાઇનમેન્ટ સોંપો",
    start_date_time: "પ્રારંભ તારીખ અને સમય",
    end_date_time: "સમાપ્તિ તારીખ અને સમય",
    join_conference_quote:
      "સત્રમાં જોડાવા માટે, નીચેના ઇનપુટ બોક્સમાં સત્ર ID પ્રદાન કરો",
    edit_student: "વિદ્યાર્થી સંપાદિત કરો",
    editTeacher: "શિક્ષક સંપાદિત કરો",
    subject_name: "વિષયનું નામ",
    subject_description: "વિષય વર્ણન",
    select_type: "પ્રકાર પસંદ કરો",
    others: "અન્ય",
    Institute_name: "સંસ્થાનું નામ",
    first_name_contact: "સંપર્કનું પ્રથમ નામ",
    last_name_contact: "સંપર્કનું છેલ્લું નામ",
    institute_type: "સંસ્થાનો પ્રકાર",
    institute_name: "સંસ્થાનું નામ",
    contact_number: "સંપર્ક નંબર",
    signup_as_institute: "સંસ્થા તરીકે સાઇન અપ કરો",
    signup_as_student: "વિદ્યાર્થી તરીકે સાઇન અપ કરો",
    state: "રાજ્ય",
    city: "શહેર",
    institute_name_error: "સંસ્થાના નામ માત્ર અક્ષરો હોવા જોઈએ",
    institute_type_error: "સંસ્થાનો પ્રકાર પસંદ કરવો જોઈએ",
    address_error: "સરનામું વિશિષ્ટ અક્ષરો સ્વીકારી શકે છે",
    student: "વિદ્યાર્થી",
    institute: "સંસ્થા",
    signUpas: "તરીકે સાઇન અપ કરો",
    submitted: "સબમિટ કર્યું",
    notSubmitted: "સબમિટ કરેલ નથી",
    review: "સમીક્ષા",
    inReview: "સમીક્ષામાં",
    questionTitle: "પ્રશ્ન શીર્ષક",
    questionDescription: "પ્રશ્ન વર્ણન",
    questionnaireTitle: "શીર્ષક છે",
    started: "શરૂ કર્યું",
    testName: "ટેસ્ટનામ",
    timeTaken: "સમય લીધો",
    showAnswers: "જવાબો બતાવો",
    downloadCertificate: "પ્રમાણપત્ર ડાઉનલોડ કરો",
    startTime: "પ્રારંભ સમય",
    endTime: "સમાપ્તિ સમય",
    assignmentTitle: "સોંપણી શીર્ષક",
    editor: "સંપાદક",
    save_submit: "સાચવો અને સબમિટ કરો",
    assigned_students: "સોંપેલ વિદ્યાર્થીઓ",
    total_marks: "કુલ ગુણ",
    not_yet_Submitted: "હજુ સુધી સબમિટ કરેલ નથી",
    completed: "પૂર્ણ થયું",
    due_date: "નિયત તારીખ",
    marks_obtained: "ગુણ મેળવ્યા",
    assign_marks: "માર્કસ સોંપો",
    home_inclass_copyright: "© 2022 InstaVC Inc. All Rights Reserved.",
    // " © 2022 InstaVC Inc. સર્વ અધિકાર આરક્ષિત |દ્વારા સંચાલિત People Unified Communications Pvt. Ltd.",
    back_to_classes: "વર્ગો પર પાછા",
    className: "વર્ગનું નામ",
    attendanceReports: "હાજરી અહેવાલો",
    present: "હાજર",
    absent: "ગેરહાજર",
    ratio: "ગુણોત્તર",
    sessionsAttended: "સત્રોમાં હાજરી આપી",
    totalSessions: "કુલ સત્રો",
    filters: "ફિલ્ટર્સ",
    teacher: "શિક્ષક",
    userType: "વપરાશકર્તા પ્રકાર",
    class: "વર્ગ",
    clear: "ચોખ્ખુ",
    sessionsConducted: "સત્રો યોજાયા",
    Topic: "વિષય",
    uploadMediaSizeLimit: "15MB સુધીની કદ મર્યાદા સાથે.",
    assessments: "આકારણીઓ",
    assessment: "આકારણી",
    totalStudents: "કુલ વિદ્યાર્થીઓ",
    totalAssignments: "કુલ સોંપણીઓ",
    assignmentsCompleted: "સોંપણીઓ પૂર્ણ",
    assignmentsPending: "સોંપણીઓ બાકી છે",
    score: "સ્કોર",
    submittedDate: "સબમિટ કરવાની તારીખ",
    dueDateOfSubmission: "સબમિશનની નિયત તારીખ",
    clearSelections: "પસંદગીઓ સાફ કરો",
    noschedule_meetings: "તમારી પાસે કોઈ આગામી સત્રો નથી.",
    nopast_meetings: "તમારી પાસે કોઈ પાછલા સત્રો નથી",
    id: "ID",
    sample_excel: "નમૂના એક્સેલ",
    export: "નિકાસ કરો",
    import: "આયાત કરો",
    subject_access: "વિષય ઍક્સેસ",
    submitted_date_time: "સબમિટ કરેલ તારીખ/સમય",
    passed: "પાસ થયા",
    failed: "નિષ્ફળ",
    average_score: "સરેરાશ સ્કોર",
    total_reviewed: "કુલ સમીક્ષા",
    pending_review: "અનિર્ણિત સમીક્ષા",
    total_students_finished: "કુલ વિદ્યાર્થીઓ સમાપ્ત",
    total_students_passed: "કુલ વિદ્યાર્થીઓ પાસ થયા",
    total_students_failed: "કુલ વિદ્યાર્થીઓ નાપાસ થયા",
    total_students_absent: "કુલ ગેરહાજર વિદ્યાર્થીઓ",
    time_exceed: "સમય મર્યાદા ઓળંગાઈ",
    time_exceed_assgn_msg: "આ સોંપણી સબમિટ કરવાની સમય મર્યાદા ઓળંગાઈ ગઈ છે",
    time_exceed_quess_msg: "આ પ્રશ્નપત્ર સબમિટ કરવાની સમય મર્યાદા ઓળંગાઈ ગઈ છે",
    class_code: "વર્ગનું નામ",
    updateQuestion: "અપડેટ પ્રશ્ન",
    subject_code: "વિષય કોડ",
    actions: "ક્રિયાઓ",
    enroll: "નોંધણી કરો",
    create_new_passwd: "નવો પાસવર્ડ બનાવો",
    please_enter_topic_name: "કૃપા કરીને વિષયનું નામ દાખલ કરો",
    please_enter_topic_description: "કૃપા કરીને વિષયનું વર્ણન દાખલ કરો",
    plz_select_questionary: "કૃપા કરીને પ્રશ્નાર્થ પસંદ કરો.",
    plz_select_duration_checkbox: "કૃપા કરીને સમયગાળો ચેકબોક્સ પસંદ કરો.",
    Plz_select_assignment: "કૃપા કરીને સોંપણી પસંદ કરો.",
    plz_select_valid_date_time: "કૃપા કરીને માન્ય તારીખ સમય પસંદ કરો.",
    Plz_enter_valid_marks: "કૃપા કરીને માન્ય ગુણ દાખલ કરો.",
    Plz_enter_subject_title: "કૃપા કરીને વિષયનું શીર્ષક દાખલ કરો.",
    class_code:"વર્ગ કોડ",
    Plz_enter_class_name: "કૃપા કરીને વર્ગનું નામ દાખલ કરો",
    Plz_enter_subject_description: "કૃપા કરીને વિષયનું વર્ણન દાખલ કરો.",
    Plz_enter_subject_type: "કૃપા કરીને વિષયનો પ્રકાર દાખલ કરો.",
    Plz_enter_subject_code: "કૃપા કરીને વિષય કોડ દાખલ કરો.",
    Plz_enter_valid_subject_code: "કૃપા કરીને માન્ય વિષય કોડ દાખલ કરો",
    Plz_enter_class_code: "કૃપા કરીને વર્ગ કોડ દાખલ કરો.",
    Plz_enter_valid_class_code: "કૃપા કરીને માન્ય વર્ગ કોડ દાખલ કરો",
    plz_enter: "કૃપા કરીને દાખલ કરો",
    Plz_enter_valid: "કૃપા કરીને માન્ય દાખલ કરો",
    Plz_enter_title: "કૃપા કરીને શીર્ષક દાખલ કરો.",
    Plz_enter_description: "કૃપા કરીને વર્ણન દાખલ કરો.",
    Plz_select_class: "કૃપા કરીને વર્ગ પસંદ કરો",
    Plz_select_subject: "કૃપા કરીને વિષય પસંદ કરો.",
    something_went_wrong: "કંઈક ખોટું થયું.",
    data_is_not_selected: "ડેટા પસંદ કરેલ નથી",
    data_added_successfully: "ડેટા સફળતાપૂર્વક ઉમેરાયો",
    plz_enter_question: "કૃપા કરીને પ્રશ્ન દાખલ કરો",
    plz_enter_marks: "કૃપા કરીને ગુણ દાખલ કરો",
    Plz_select_type: "કૃપા કરીને પ્રકાર પસંદ કરો",
    opt_should_have_minimum: "વિકલ્પોમાં ઓછામાં ઓછા 2 હોવા જોઈએ",
    opt_should_not_empty: "વિકલ્પો ખાલી ન હોવા જોઈએ",
    opt_should_not_duplicate: "વિકલ્પો ડુપ્લિકેટ ન હોવા જોઈએ",
    plz_select_the_answer: "કૃપા કરીને જવાબ પસંદ કરો",
    question_updated_successfully: "પ્રશ્ન સફળતાપૂર્વક અપડેટ થયો",
    question_created_successfully: "પ્રશ્ન સફળતાપૂર્વક બનાવવામાં આવ્યો",
    marks_less_than_total_marks: "દાખલ કરેલ ગુણ કુલ ગુણ કરતા ઓછા હોવા જોઈએ",
    marks_not_negative: "ગુણ નકારાત્મક ન હોવા જોઈએ",
    assgn_successfully_verifed: "સોંપણી સાચવી સફળતાપૂર્વક ચકાસાયેલ.",
    assgn_save_submited_succes: "સોંપણી સાચવી અને સફળતાપૂર્વક સબમિટ કરી",
    assgn_save_succes: "સોંપણી સફળતાપૂર્વક સાચવી",
    Plz_enter_valid_content: "કૃપા કરીને માન્ય સામગ્રી દાખલ કરો.",
    Assgn_updated_success: "સોંપણી સફળતાપૂર્વક અપડેટ થઈ",
    Assgn_created_success: "સોંપણી સફળતાપૂર્વક બનાવવામાં આવી",
    Assgn_assigned_success: "સોંપણી સફળતાપૂર્વક સોંપાઈ",
    Assgn_disabled_success: "સોંપણી સફળતાપૂર્વક અક્ષમ કરી.",
    Assgn_enabled_success: "સોંપણી સફળતાપૂર્વક સક્ષમ કરી.",
    Assgn_deleted_success: "સોંપણી સફળતાપૂર્વક કાઢી નાખી.",
    Quest_creat_success: "પ્રશ્નાવલી સફળતાપૂર્વક બનાવવામાં આવી",
    Quest_updated_success: "પ્રશ્નાવલી સફળતાપૂર્વક અપડેટ થઈ",
    Poll_created_success: "મતદાન સફળતાપૂર્વક બનાવવામાં આવ્યું",
    Poll_updated_success: "મતદાન સફળતાપૂર્વક અપડેટ થયું",
    opt_minimum: "વિકલ્પોમાં ઓછામાં ઓછા 2 વિકલ્પો હોવા જોઈએ",
    Poll_deleted_success: "મતદાન સફળતાપૂર્વક કાઢી નાખ્યું",
    Poll_enabled_success: "મતદાન સફળતાપૂર્વક સક્ષમ",
    Poll_disabled_success: "મતદાન સફળતાપૂર્વક અક્ષમ કર્યું",
    Quest_deleted_success: "પ્રશ્ન સફળતાપૂર્વક કાઢી નાખ્યો",
    Invit_send_success: "આમંત્રણ સફળતાપૂર્વક મોકલ્યું",
    teacher_deleted_success: "શિક્ષક સફળતાપૂર્વક કાઢી નાખ્યો",
    error_some_thing_went_wrong: "ભૂલ, કંઈક ખોટું થયું.",
    user_updated_success: "વપરાશકર્તા સ્થિતિ સફળતાપૂર્વક અપડેટ થઈ",
    teacher_updated_success: "શિક્ષક સફળતાપૂર્વક અપડેટ થયા",
    student_remove_success: "વિદ્યાર્થીને સફળતાપૂર્વક દૂર કર્યો",
    teachers_created_success: "શિક્ષકો સફળતાપૂર્વક બનાવવામાં આવ્યા",
    error_occured_try_again: "એક ભૂલ આવી, ફરી પ્રયાસ કરો!",
    please_select_less: "કૃપા કરીને 15MB ફાઇલ કદ પછી ઓછું પસંદ કરો.",
    submit_success: "સફળતાપૂર્વક સબમિટ કર્યું",
    grad_updat_success: "ગ્રેડ અપડેટ્સ સફળતાપૂર્વક",
    Quest_delet_succes: "પ્રશ્નાવલી સફળતાપૂર્વક કાઢી નાખી",
    Quest_disab_succes: "પ્રશ્નાવલી સફળતાપૂર્વક અક્ષમ કરી",
    Quest_enabled_succes: "પ્રશ્નાવલી સફળતાપૂર્વક સક્ષમ કરી",
    student_add_succes: "વિદ્યાર્થી સફળતાપૂર્વક ઉમેરાયો",
    plz_select_atleast_std: "કૃપા કરીને ઓછામાં ઓછો 1 વિદ્યાર્થી પસંદ કરો",
    fail_add_some_student: "કેટલાક વિદ્યાર્થીઓ ઉમેરવામાં નિષ્ફળ",
    std_add_succes: "વિદ્યાર્થીઓ સફળતાપૂર્વક ઉમેરાયા",
    sub_updat_succes: "વિષય સફળતાપૂર્વક અપડેટ થયો",
    sub_creat_succes: "વિષય સફળતાપૂર્વક બનાવવામાં આવ્યો",
    sub_dlt_succes: "વિષય સફળતાપૂર્વક કાઢી નાખ્યો",
    sub_enabl_succes: "વિષય સફળતાપૂર્વક સક્ષમ",
    sub_disab_succes: "વિષય સફળતાપૂર્વક અક્ષમ કર્યો",
    tchr_add_success: "શિક્ષક સફળતાપૂર્વક ઉમેરાયા",
    plz_slc_atlst_tchr: "કૃપા કરીને ઓછામાં ઓછા 1 શિક્ષક પસંદ કરો",
    tchr_remo_success: "શિક્ષક સફળતાપૂર્વક દૂર",
    plz_etr_valid_duration: "કૃપા કરીને માન્ય સમયગાળો દાખલ કરો",
    topic_updat_success: "વિષય સફળતાપૂર્વક અપડેટ થયો",
    class_dlt_success: "વર્ગ સફળતાપૂર્વક કાઢી નાખ્યો",
    class_upt_succes: "વર્ગ સફળતાપૂર્વક અપડેટ થયો",
    class_creat_succes: "વર્ગ સફળતાપૂર્વક બનાવવામાં આવ્યો",
    plz_select_quest: "કૃપા કરીને પ્રશ્નાવલી પસંદ કરો",
    first_add_data: "ડેટા ઉમેરવા માટે પ્લસ બટન પર ક્લિક કરો",
    certfct_generat_success: "પ્રમાણપત્ર સફળતાપૂર્વક જનરેટ થયું",
    plz_select_min_seats: "કૃપા કરીને ઓછામાં ઓછી 2 બેઠકો પસંદ કરો",
    plz_enter_mtng_name: "કૃપા કરીને સત્રનું નામ દાખલ કરો",
    fail_to_updt_mtng_try_again: "સત્ર અપડેટ કરવામાં નિષ્ફળ! ફરીથી પ્રયત્ન કરો",
    fail_update_scdle: "શેડ્યૂલ અપડેટ કરવામાં નિષ્ફળ",
    std_delet_success: "વિદ્યાર્થી સફળતાપૂર્વક કાઢી નાખ્યો",
    std_updat_succes: "વિદ્યાર્થી સફળતાપૂર્વક અપડેટ થયો",
    std_creat_succes: "વિદ્યાર્થીએ સફળતાપૂર્વક બનાવ્યું",
    fail_create_some_std: "કેટલાક વિદ્યાર્થીઓ બનાવવામાં નિષ્ફળ",
    std_creat_success: "વિદ્યાર્થીઓએ સફળતાપૂર્વક સર્જન કર્યું",
    tchr_creat_succes: "શિક્ષક સફળતાપૂર્વક બનાવ્યો",
    fail_crt_some_user: "કેટલાક વપરાશકર્તાઓ બનાવવામાં નિષ્ફળ",
    fail_create_mtg_try_again: "સત્ર બનાવવામાં નિષ્ફળ! ફરીથી પ્રયત્ન કરો",
    fail_create_schedu: "શેડ્યૂલ બનાવવામાં નિષ્ફળ",
    plz_enter_metng_title: "કૃપા કરીને સત્રનું શીર્ષક દાખલ કરો",
    invalid_phn_nmb: "અમાન્ય ફોન નંબર",
    plz_enter_phn_num: "કૃપા કરીને ફોન નંબર દાખલ કરો",
    topic_crt_succes: "વિષય સફળતાપૂર્વક બનાવવામાં આવ્યો",
    topic_enabled_succes: "વિષય સફળતાપૂર્વક સક્ષમ",
    topic_disabl_success: "વિષય સફળતાપૂર્વક અક્ષમ કર્યો",
    topic_delet_success: "વિષય સફળતાપૂર્વક કાઢી નાખ્યો",
    Media_delet_success: "મીડિયા સફળતાપૂર્વક કાઢી નાખ્યું",
    plz_enter_title_upload_doc:
      "કૃપા કરીને પહેલા શીર્ષક દાખલ કરો અને દસ્તાવેજ અપલોડ કરો",
    doc_add_succes: "દસ્તાવેજ સફળતાપૂર્વક ઉમેરાયો",
    plz_fst_ent_title_and_media:
      "કૃપા કરીને પહેલા શીર્ષક દાખલ કરો અને મીડિયા ફાઇલ દાખલ કરો",
    media_add_success: "મીડિયા સફળતાપૂર્વક ઉમેર્યું",
    plz_first_title_and_URL:
      "કૃપા કરીને પહેલા શીર્ષક દાખલ કરો અને મીડિયા URL દાખલ કરો",
    plz_etr_valid_url: "કૃપા કરીને માન્ય url દાખલ કરો",
    generate: "પેદા",
    issue_cert: "પ્રમાણપત્ર જારી કરો",
    total_score: "કુલ સ્કોર",
    created_by: "દ્વારા બનાવવામાં",
    certificate: "પ્રમાણપત્ર",
    not_completed: "પૂર્ણ થયું નથી",
    view_cert: "પ્રમાણપત્ર જુઓ",
    issue_certificate: "પ્રમાણપત્ર જારી કરો",
    title: "શીર્ષક",
    issue_date: "જારી તારીખ",
    note_edit_and_delete_txt:
      "નોંધ: સંપાદિત કરો અને કાઢી નાખો બટનો પરીક્ષણ પહેલા 10 મિનિટથી છુપાવવામાં આવશે",
    verify_email_msg: "કૃપા કરીને પુષ્ટિકરણ કોડ માટે તમારું ઇમેઇલ તપાસો",
    start_time_greater_currnt_time:
      "પ્રારંભ સમય વર્તમાન સમય પછી 10 મિનિટ કરતાં વધુ હોવો જોઈએ",
    copi_to_clipboard: "ક્લિપબોર્ડ પર કૉપિ કર્યું!",
    host_msg: "યજમાન",
    date_time: "તારીખ સમય",
    invities: "આમંત્રિતો",
    no_chat_history_avai: "કોઈ ચેટ ઇતિહાસ ઉપલબ્ધ નથી",
    no_feedbacks_avai: "કોઈ પ્રતિસાદ ઉપલબ્ધ નથી",
    no_invities_list_avai: "કોઈ આમંત્રિતોની સૂચિ ઉપલબ્ધ નથી",
    no_conference_note_avai: "કોઈ કોન્ફરન્સ નોંધો ઉપલબ્ધ નથી.",
    total_notes: "કુલ નોંધો ( 15 )",
    view_log_history: "લોગ ઇતિહાસ જુઓ",
    total_duration: "કુલ અવધિ:",
    min: "મિનિ",
    total_time_spent: "વિતાવેલો કુલ સમય:",
    entry: "પ્રવેશ",
    exit: "બહાર નીકળો",
    time_spent: "સમય પસાર કર્યો",
    no_conference_recording_avai: "કોઈ કોન્ફરન્સ રેકોર્ડિંગ ઉપલબ્ધ નથી",
    no_meetings: "કોઈ સત્રો નથી!",
    this_brow_dont_support_video_tag: "આ બ્રાઉઝર વિડિયો-ટેગને સપોર્ટ કરતું નથી",
    no_participants_list_avai: "કોઈ સહભાગીઓની સૂચિ ઉપલબ્ધ નથી.",
    total_number_session: "સત્રોની કુલ સંખ્યા",
    start_date: "પ્રારંભ તારીખ:",
    join_mtg_provide_id_below_input:
      "સત્રમાં જોડાવા માટે, નીચેના ઇનપુટ બોક્સમાં સત્ર ID પ્રદાન કરો.",
    You_enter_inva_meet: "તમે અમાન્ય સત્ર ID દાખલ કર્યું છે.",
    no_ques_creat_yet: "હજુ સુધી કોઈ પ્રશ્નાવલિ બનાવવામાં આવી નથી!",
    creat_quest_click_creat:
      "પ્રશ્નાવલી બનાવો બટન પર ક્લિક કરીને પ્રશ્નાવલી બનાવો.",
    only_invit_can_join: "ફક્ત આમંત્રિતો જ જોડાઈ શકે છે",
    invc_login_mandato: "inVC લૉગિન ફરજિયાત",
    training_mode: "તાલીમ મોડ",
    audio_only_mode: "માત્ર ઓડિયો મોડ",
    mute_parti_upon_entry: "પ્રવેશ પર સહભાગીઓને મ્યૂટ કરો",
    join_before_host: "હોસ્ટ પહેલાં જોડાઓ",
    enable_breakout_session: "બ્રેકઆઉટ સત્રો સક્ષમ કરો",
    anonymous_access: "અનામિક ઍક્સેસ",
    send_invite: "આમંત્રણ મોકલો",
    add_part_email_address_mobil_msg:
      "બહુવિધ એન્ટ્રીઓ માટે એન્ટર દબાવીને સહભાગીઓને તેમનું ઈમેલ એડ્રેસ અથવા મોબાઈલ નંબર ઉમેરીને ઉમેરો.",
    add_email_mobile: "ઇમેઇલ / મોબાઇલ નંબર ઉમેરો",
    make_sure_the_msg:
      "1 - ખાતરી કરો કે મોબાઇલ નંબર દેશ કોડ સાથે હોવો જોઈએ (ઉદા.: +91-99XXXXXXXXX)",
    email_id_note: "2 - ઈમેલ આઈડી લોઅરકેસ હોવો જોઈએ (ઉદા: username@xxx.com)",

    meet_before_schedul_time:
      "તમે નિર્ધારિત સમય પહેલા આ સત્રમાં જોડાઈ શકતા નથી.",
    go_to_dashboard: "ડેશબોર્ડ પર જાઓ",
    if_you_are_host_msg:
      "જો તમે હોસ્ટ હો, તો કૃપા કરીને તમારા ડેશબોર્ડથી બીજું ઝડપી સત્ર શરૂ કરો",
    this_meet_expir_on: "આ સત્રની સમયસીમા સમાપ્ત થઈ ગઈ છે",
    this_meet_link__expired: "આ સત્ર લિંક સમાપ્ત થઈ ગઈ છે",
    this_meet_schedul_for: "માટે આ સત્ર નક્કી કરવામાં આવ્યું છે",
    meet_min_before_schedule_time:
      "તમે નિર્ધારિત સમય કરતાં 5 મિનિટ પહેલાં આ સત્રમાં જોડાઈ શકો છો.",
    this_assign_start_yet: "આ અસાઇનમેન્ટનો સમય હજુ શરૂ થયો નથી...",
    time_not_yet_start: "સમય હજુ શરૂ થયો નથી",
    field_once_generat_cannot_edit:
      "મહેરબાની કરીને તપાસો કે એકવાર જનરેટ થઈ જાય પછી સંપાદિત કરી શકાતું નથી",
    certificate_title: "પ્રમાણપત્ર શીર્ષક",
    invalid_meet_code: "અમાન્ય સત્ર કોડડ",
    meeting_id_below_input_box:
      "સત્રમાં જોડાવા અને સ્ક્રીન શેર કરવા માટે, નીચેના ઇનપુટ બોક્સમાં સત્ર ID પ્રદાન કરો.",
    meeting_configuration: "સત્ર રૂપરેખાંકન",
    room_participant_limit_exceed: "રૂમ સહભાગી મર્યાદા ઓળંગાઈ.",
    only_audio_call_auto_mute_enabl: "માત્ર ઑડિયો કૉલ અને ઑટો મ્યૂટ સક્ષમ",
    you_audio_video_mute: "તમારો ઑડિયો અને વિડિયો મ્યૂટ છે!",
    only_audio_call: "માત્ર ઓડિયો કૉલ",
    your_video_mute: "તમારી વિડિઓ મ્યૂટ છે!",
    your_name: "તમારું નામ",
    ok_you_r_ready: "ઓકે, તમે તૈયાર છો",
    room_empty_meeting_wait_until_host_join:
      "ઓરડો ખાલી છે! તમે સત્ર શરૂ કરવા માટે લૉગ ઇન કરી શકો છો અથવા હોસ્ટ જોડાય ત્યાં સુધી રાહ જોઈ શકો છો",
    room_lock_hang_until_somebody_lets:
      "રૂમ લૉક છે - જ્યાં સુધી કોઈ તમને અંદર ન આવવા દે ત્યાં સુધી અટકી જાવ...",
    your_audio_is_muted: "તમારો ઑડિયો મ્યૂટ કર્યો છે!",
    view_assignment: "સોંપણી જુઓ",
    assigned_assignment: "અસાઇનમેન્ટ",
    attempte_assignment_written_anything:
      "તમે સોંપણીનો પ્રયાસ કર્યો છે પરંતુ તેમાં કંઈ લખ્યું નથી.",
    Marks_not_alloted: "માર્કસની મંજૂરી નથી",
    view_questionnaire: "પ્રશ્નાવલી જુઓ",
    assign_questionnaire_list: "પ્રશ્નાવલી યાદી સોંપો",
    assign_assignment: "સોંપણીઓની સૂચિ સોંપો",
    type: "પ્રકાર",
    class_description: "વર્ગ વર્ણન",
    password_updated: "પાસવર્ડ અપડેટ કર્યો!",
    numberOfLicense: "લાયસન્સની સંખ્યા",
    topic: "વિષય",
    del_poll: "મતદાન",
    std: "વિદ્યાર્થી",
    profile: "પ્રોફાઇલ",
    your_test: "તમારી કસોટી",
    unattended_incomplete_Questionaire_txt_msg:
      "કેટલાક કારણોસર ધ્યાન વિનાનું અથવા અધૂરું હતું. આથી સ્કોર કાર્ડ જનરેટ થઈ શક્યું નથી",
    Assgnmnt_time_not_started: "સોંપણીનો સમય હજુ શરૂ થયો નથી...",
    submitted_cnt: "સબમિટ કરેલી સામગ્રી",
    stud_list: "વિદ્યાર્થી યાદી",
    test_submitted_successfully: "તમારી કસોટી સફળતાપૂર્વક સબમિટ કરવામાં આવી છે",
    score_time_finished_successfully: "સમય પૂરો થયા પછી સ્કોર પ્રદર્શિત થશે",
    topics_list: "વિષયોની સૂચિ",
    subject_list: "વિષય યાદી",
    plz_enter_valid_number_license:
      "કૃપા કરીને લાયસન્સની માન્ય સંખ્યા દાખલ કરો",
    no_class_assigned: "કોઈ વર્ગ સોંપેલ નથી",
    class_list: "વર્ગ યાદી",
    plz_fill_all_details: "કૃપા કરીને બધી વિગતો ભરો",
    plz_click_upload_media_url: "કૃપા કરીને અપલોડ મીડિયા url પર ક્લિક કરો",
    please_enter_msg: "કૃપા કરીને દાખલ કરો",
    Media_msg: "મીડિયા.",
    media_url: "મીડિયા URL.",
    title: "શીર્ષક ",
    and_msg: "અને",
    wrong_answer: "ખોટો જવાબ",
    right_answer: "સાચો જવાબ",
    User_list: "વપરાશકર્તાઓની સૂચિ",
    questionaire_time_not_yet_start: "પ્રશ્નાવલીનો સમય હજુ શરૂ થયો નથી...",
    submitted_list: "સબમિટ કરેલ સૂચિ",
    search_by_name: "નામ દ્વારા શોધો",
    scheduleDate: "શેડ્યૂલ તારીખ",
    view_all: "બધુજ જુઓ",
    view_card: "કાર્ડ જુઓ",
    confirm_submit: "શું તમે ખરેખર સોંપણી સબમિટ કરવા માંગો છો?",
    confirm_finish: "શું તમે ખરેખર ટેસ્ટ સમાપ્ત કરવા માંગો છો?",
    questionaire: "પ્રશ્નાવલી",
    list_of_questns_for_above_questionaire:
      "ઉપરોક્ત પ્રશ્નાવલી માટે સોંપેલ પ્રશ્નોની યાદી નીચે આપેલ છે",
    view_all_assignments: "બધી સોંપણીઓ જુઓ",
    action: "ક્રિયા",
    start_dte: "પ્રારંભ તારીખ",
    subject: "વિષય",
    digital_file_upload_and_digital_signature:
      "અહીં અપલોડ કરેલી ડિજિટલ ફાઇલો વિદ્યાર્થીઓને આપવામાં આવેલા ડિજિટલ પ્રમાણપત્રો પર દેખાશે",
    upload_logo: "લોગો અપલોડ કરો",
    upload_signature: "સહી અપલોડ કરો",
    upload_stamp: "સ્ટેમ્પ અપલોડ કરો",
    drag_and_drop_file: "તમારી ફાઇલને અહીં ખેંચો અને છોડો અથવા",
    max_file_mb_dimensions: "મહત્તમ ફાઇલ કદ 20MB પરિમાણો ",
    note_assgn_qusnr_text:
      " નોંધ *: અસાઇનમેન્ટ શરૂ થાય તેની 10 મિનિટ પહેલાથી તમે તમારી એન્ટ્રીઓને સંપાદિત અથવા કાઢી નાખવામાં સમર્થ હશો નહીં",
    note_qusnr_text:
      " નોંધ *: પ્રશ્નાવલી શરૂ થાય તેની 10 મિનિટ પહેલાં તમે તમારી એન્ટ્રીઝને સંપાદિત કરી શકશો નહીં અથવા કાઢી નાખી શકશો નહીં",
    not_attended: "હાજરી આપી નથી",
    not_started: "શરૂ કરી નથી",
    dont_have_stu_acc: "વિદ્યાર્થી ખાતું નથી",
    buy_more: "વધુ ખરીદો",
    product: "ઉત્પાદન",
    no_subject_assigned: "કોઈ વિષયો સોંપેલ નથી",
    logo: "લોગો",
    stamp: "ટિકિટ",
    signature: "સહી",
    uploaded_successfully: "સફળતાપૂર્વક અપલોડ કર્યું",
    renewal: "નવીકરણ",
    domain_name: "ડોમેન નામ",
    pls_sel_frequency:
      "કૃપા કરીને અઠવાડિયાનો કયો દિવસ તમે શેડ્યૂલ કરવા માંગો છો તે પસંદ કરો",
    your_test_successfully_submitted:
      "તમારું પરીક્ષણ સફળતાપૂર્વક સબમિટ કરવામાં આવ્યું છે",
    score_will_finished: "સમય પૂરો થયા પછી સ્કોર પ્રદર્શિત થશે",
    license_expired: "લાઇસન્સ સમાપ્ત ",
    application_longer_accessed_since__license_expired:
      "તમારું લાઇસન્સ સમાપ્ત થઈ ગયું હોવાથી એપ્લિકેશનને હવે ઍક્સેસ કરી શકાશે નહીં. ઍક્સેસને ફરીથી સક્રિય કરવા માટે,",
    respective_admin_license_renewal:
      "કૃપા કરીને લાયસન્સ રિન્યુઅલ માટે તમારા સંબંધિત એડમિનનો સંપર્ક કરો.",
    okay: " બરાબર",
    delete_recurring_schedule: "રિકરિંગ શેડ્યૂલ કાઢી નાખો",
    are_you_sure_delete_recurring_schedule:
      "શું તમે ખરેખર આ પુનરાવર્તિત શેડ્યૂલને કાઢી નાખવા માંગો છો?",
    delete_all_recurring_days_completely:
      "બધા રિકરિંગ દિવસો સંપૂર્ણપણે કાઢી નાખો.",
    will_eleminate_all_selected: "શેડ્યૂલમાંથી બધા પસંદ કરેલા દિવસો દૂર કરશે",
    remove_only_selected_days: "ફક્ત પસંદ કરેલા દિવસો દૂર કરો",
    delete_selected_days_schedule:
      "આ શેડ્યૂલમાંથી ફક્ત પસંદ કરેલા દિવસોને કાઢી નાખશે",
    recurring_dates: "રિકરિંગ તારીખો",
    enter_the_coupon_code: "કૂપન કોડ દાખલ કરો",
    coupon_applied: "કૂપન લાગુ",
    coupon_id: "કૂપન આઈડી",
    del_recurring_by_dates:
      "સત્રનો કયો દિવસ તમે કાઢી નાખવા માંગો છો તે પસંદ કરો",
    more_details: "વધુ વિગતો",
    removeStudentUser: "શું તમે ખરેખર આ વિદ્યાર્થીને દૂર કરવા માંગો છો?",
    removeTeacherUser: "શું તમે ખરેખર આ શિક્ષકને દૂર કરવા માંગો છો?",
    sure_you_want_to_delete: "શું તમે ખરેખર આને કાઢી નાખવા માંગો છો",
    deleting_information_database: "આને કાઢી નાખવાથી ડેટાબેઝમાંથી બધી માહિતી ભૂંસી જશે.",
    to_confirm_type: "પ્રકાર કન્ફર્મ કરવા માટે",
    name_not_matched: "નામ મેળ ખાતું નથી.",
    confirm_this_type: "આની પુષ્ટિ કરવા માટે, ટાઇપ કરો",
    topic_title: "વિષયનું શીર્ષક",
    select: "પસંદ કરો",
    plz_enter_integers: "કૃપા કરીને ફક્ત પૂર્ણાંક મૂલ્યો દાખલ કરો",
    help_Center:"મદદ કેન્દ્ર",

  },
};
